import { DatePipe, formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
  FormArray

} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { EncdecriptService } from 'src/app/services/encdecrypt.service';
import { UpdateAdvtDetailsComponent } from '../update-advt-details/update-advt-details.component';
import * as XLSX from 'xlsx';
import { UpdatePlublishDatesComponent } from '../update-plublish-dates/update-plublish-dates.component';
import { MatSelect } from '@angular/material/select';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FileUploader } from 'ng2-file-upload';
import { SubscriptionAccountsComponent } from '../subscription-accounts/subscription-accounts.component';
import { AdvertisementInvoiceComponent } from '../advertisement-invoice/advertisement-invoice.component';
import { CreditvoucherDialogComponent } from '../creditvoucher-dialog/creditvoucher-dialog.component';
import { ReciptComponent } from '../recipt/recipt.component';
import { UpdateOfficeRepresentativeComponent } from '../update-office-representative/update-office-representative.component';
import { RegistrationReportComponent } from '../registration-report/registration-report.component';
import { PrasiddhipatrakComponent } from '../prasiddhipatrak/prasiddhipatrak.component';
import { PrasiddhipatrakbrowseComponent } from '../prasiddhipatrakbrowse/prasiddhipatrakbrowse.component';
import { ContractBriefReportComponent } from '../contract-brief-report/contract-brief-report.component';
import { AdvtBillComponent } from '../advt-bill/advt-bill.component';
import { ViewAdvtBillComponent } from '../view-advt-bill/view-advt-bill.component';
import { AdvtInvoiceRegisterComponent } from '../advt-invoice-register/advt-invoice-register.component';
import { AddAdvtIssuePerPriceComponent } from '../add-advt-issue-per-price/add-advt-issue-per-price.component';
import { UpdateAdvtIssuePerPriceComponent } from '../update-advt-issue-per-price/update-advt-issue-per-price.component';
import { AdvtInvoicePaymentReceiptComponent } from '../advt-invoice-payment-receipt/advt-invoice-payment-receipt.component';
import { OpenselectmodalComponent } from 'src/app/openselectmodal/openselectmodal.component';
import { CommmodalComponent } from 'src/app/commmodal/commmodal.component';
import { CrreceiptComponent } from 'src/app/crreceipt/crreceipt.component';
import { TworeceiptComponent } from 'src/app/tworeceipt/tworeceipt.component';
import { ToastrService } from 'ngx-toastr';
import { StampreceiptComponent } from 'src/app/stampreceipt/stampreceipt.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { OlddataupdateComponent } from 'src/app/olddataupdate/olddataupdate.component';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import { ColDef } from 'ag-grid-community';
import { ThreeStampReceiptComponent } from '../three-stamp-receipt/three-stamp-receipt.component';
import { PrasiddhiPatrakAddressComponent } from 'src/app/prasiddhi-patrak-address/prasiddhi-patrak-address.component';
import { AdvertisementAddressComponent } from 'src/app/advertisement-address/advertisement-address.component';
import { PrasiddhiPatrakListComponent } from 'src/app/prasiddhi-patrak-list/prasiddhi-patrak-list.component';
import { AdvtOutstandingReportComponent } from '../advt-outstanding-report/advt-outstanding-report.component';
import { PaymentReceiptRegisterComponent } from 'src/app/payment-receipt-register/payment-receipt-register.component';
import { PaymentRegisterMonthwiseComponent } from 'src/app/payment-register-monthwise/payment-register-monthwise.component';
import { PaymnetReceiptIndetailOfficerComponent } from 'src/app/paymnet-receipt-indetail-officer/paymnet-receipt-indetail-officer.component';
import { PaymnetReceieptVeryBreiflyOfficerComponent } from 'src/app/paymnet-receiept-very-breifly-officer/paymnet-receiept-very-breifly-officer.component';
import { PaymentReceiptBrieflyOfficerComponent } from 'src/app/payment-receipt-briefly-officer/payment-receipt-briefly-officer.component';
import { CreditNoteRegisterIndetailComponent } from 'src/app/credit-note-register-indetail/credit-note-register-indetail.component';
import { CreditNoteBrieflyRegisterComponent } from 'src/app/credit-note-briefly-register/credit-note-briefly-register.component';
import { CreditNoteMonthwiseRegisterComponent } from 'src/app/credit-note-monthwise-register/credit-note-monthwise-register.component';
import { CreditNoteInDetailCreditOfficerComponent } from 'src/app/credit-note-in-detail-credit-officer/credit-note-in-detail-credit-officer.component';
import { CreditNoteVeryBrieflyCreditNoteComponent } from 'src/app/credit-note-very-briefly-credit-note/credit-note-very-briefly-credit-note.component';
import { CreditNoteBrieflyOfficerCreditComponent } from 'src/app/credit-note-briefly-officer-credit/credit-note-briefly-officer-credit.component';
import { RepresentativeAddressListComponent } from 'src/app/representative-address-list/representative-address-list.component';
import { AdvtRepresentativeAddressListComponent } from 'src/app/advt-representative-address-list/advt-representative-address-list.component';
import { AdvertisementAddressListComponent } from 'src/app/advertisement-address-list/advertisement-address-list.component';
import { PaymentReceiptIndetailReportComponent } from 'src/app/payment-receipt-indetail-report/payment-receipt-indetail-report.component';
import { debug } from 'console';
import { AddAdvtRepPerPriceComponent } from 'src/app/add-advt-rep-per-price/add-advt-rep-per-price.component';
import { RegistrationRepVeryBrieflyComponent } from 'src/app/registration-rep-very-briefly/registration-rep-very-briefly.component';
import { UnpaidOutstandingInDetailComponent } from 'src/app/unpaid-outstanding-in-detail/unpaid-outstanding-in-detail.component';
import { RegistrationBrieflyRepresentativeComponent } from 'src/app/registration-briefly-representative/registration-briefly-representative.component';
import { AdvtInvoiceIndetailReportComponent } from 'src/app/advt-invoice-indetail-report/advt-invoice-indetail-report.component';
import { OutstandingBrieflyReportComponent } from 'src/app/outstanding-briefly-report/outstanding-briefly-report.component';
import { RegistrationOfficeRepresentativeDetailComponent } from 'src/app/registration-office-representative-detail/registration-office-representative-detail.component';
import { RegistrationOfficeRepresentativeBrieflyComponent } from 'src/app/registration-office-representative-briefly/registration-office-representative-briefly.component';
// import { RegistrationOfficeRepresentativeVbrieflyComponent } from 'src/app/registration-office-representative-vbriefly/registration-office-representative-vbriefly.component';
import { RegistrationDatewiseDetailsComponent } from 'src/app/registration-datewise-details/registration-datewise-details.component';
import { RegistrationDatewiseBrieflyComponent } from 'src/app/registration-datewise-briefly/registration-datewise-briefly.component';
import { UnpaidOutstandingBrieflyReportComponent } from 'src/app/unpaid-outstanding-briefly-report/unpaid-outstanding-briefly-report.component';
import { RegistrationOfficeRepresentativeVbrieflyComponent } from 'src/app/registration-office-representative-vbriefly/registration-office-representative-vbriefly.component';
import { RegistrationBrieflyComponent } from 'src/app/registration-briefly/registration-briefly.component';
import { RegistrationDatewiseVbrieflyComponent } from 'src/app/registration-datewise-vbriefly/registration-datewise-vbriefly.component';
import { RegistrationIndetailsComponent } from 'src/app/registration-indetails/registration-indetails.component';
import { RegistrationRepresentiveDetailComponent } from 'src/app/registration-representive-detail/registration-representive-detail.component';
import { UnpaidOutstandingVbrieflyComponent } from 'src/app/unpaid-outstanding-vbriefly/unpaid-outstanding-vbriefly.component';
import { OutstandingGstRegistrationReportComponent } from 'src/app/outstanding-gst-registration-report/outstanding-gst-registration-report.component';
import { PersonalLedgerInDetailComponent } from 'src/app/personal-ledger-in-detail/personal-ledger-in-detail.component';
import { PersonalLedgerInDetail1Component } from 'src/app/personal-ledger-in-detail1/personal-ledger-in-detail1.component';
import { ComModalPrintComponent } from 'src/app/com-modal-print/com-modal-print.component';
import { CompletedCommissionReportComponent } from 'src/app/completed-commission-report/completed-commission-report.component';
import { PendingCommReportComponent } from 'src/app/pending-comm-report/pending-comm-report.component';
import { debugPort } from 'process';
import { AdvtInvoiceMonthwiseRegisterComponent } from 'src/app/advt-invoice-monthwise-register/advt-invoice-monthwise-register.component';
import { AdvtInvoiceRegisterIndetailOfficerComponent } from 'src/app/advt-invoice-register-indetail-officer/advt-invoice-register-indetail-officer.component';
import { AdvtInvoiceRegisterOfficeBrieflyComponent } from 'src/app/advt-invoice-register-office-briefly/advt-invoice-register-office-briefly.component';
import { AdvtoutstandingAllbrieflyComponent } from 'src/app/advtoutstanding-allbriefly/advtoutstanding-allbriefly.component';
import { AdvtInvoiceVeryBrieflyComponent } from 'src/app/advt-invoice-very-briefly/advt-invoice-very-briefly.component';
import { SharedService } from 'src/app/services/shared.service';
import { AdvtStampRegisterReportComponentComponent } from 'src/app/advt-stamp-register-report-component/advt-stamp-register-report-component.component';
import { AdvtCreditPrintComponent } from 'src/app/advt-credit-print/advt-credit-print.component';
import { PrasiddhiPatrakRepresentaiveListComponent } from 'src/app/prasiddhi-patrak-representaive-list/prasiddhi-patrak-representaive-list.component';
import { CreditOutstandingIndetailsComponent } from 'src/app/credit-outstanding-indetails/credit-outstanding-indetails.component';
import { SendReminderLetterAdvtComponent } from 'src/app/send-reminder-letter-advt/send-reminder-letter-advt.component';
import { AllCommReportComponent } from 'src/app/all-comm-report/all-comm-report.component';
import { ContractBrieflyReportComponent } from 'src/app/contract-briefly-report/contract-briefly-report.component';
import { SendReminderLetterRepComponent } from 'src/app/send-reminder-letter-rep/send-reminder-letter-rep.component';
import { AddressAdvtLabelsComponent } from 'src/app/address-advt-labels/address-advt-labels.component';
import { ExpenseLedgerReportComponent } from 'src/app/expense-ledger-report/expense-ledger-report.component';
import { BusinessReportIndetailComponent } from 'src/app/business-report-indetail/business-report-indetail.component';
import { BusinessReportBrieflyComponent } from 'src/app/business-report-briefly/business-report-briefly.component';
import { BusinessReportVeryBrieflyComponent } from 'src/app/business-report-very-briefly/business-report-very-briefly.component';
import { IssueWiseReportAdvtBusinessComponent } from 'src/app/issue-wise-report-advt-business/issue-wise-report-advt-business.component';
import { IssueWiseReportAdvtDetailBusinessComponent } from 'src/app/issue-wise-report-advt-detail-business/issue-wise-report-advt-detail-business.component';
import { ContractIndetailReportComponent } from 'src/app/contract-indetail-report/contract-indetail-report.component';
import { AdvtissueYearWiseReportComponent } from 'src/app/advtissue-year-wise-report/advtissue-year-wise-report.component';
import { JahiriatJamaReportComponent } from 'src/app/jahiriat-jama-report/jahiriat-jama-report.component';
import { JahiratPratinidiwiseJamareportComponent } from 'src/app/jahirat-pratinidiwise-jamareport/jahirat-pratinidiwise-jamareport.component';
import { YeneBakiJahiratReportComponent } from 'src/app/yene-baki-jahirat-report/yene-baki-jahirat-report.component';
import { YenebakiOffwiseJahirataComponent } from 'src/app/yenebaki-offwise-jahirata/yenebaki-offwise-jahirata.component';
import { AddressListAdvtComponentComponent } from 'src/app/address-list-advt-component/address-list-advt-component.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
// import { RegistrationRepresentiveDetailComponent } from 'src/app/registration-representive-detail/registration-representive-detail.component';
// import { RegistrationDatewiseVbrieflyComponent } from 'src/app/registration-datewise-vbriefly/registration-datewise-vbriefly.component';


// export function financialYearValidator(): ValidatorFn {
//   return (control: FormControl) => {
//     const selectedDateStr = control.value;
//     const selectedDate = new Date(selectedDateStr);

//     // Read financial year boundaries from localStorage
//     const startDateStr = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
//     const endDateStr = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

//     if (!startDateStr || !endDateStr || isNaN(selectedDate.getTime())) {
//       return { financialYear: true }; // invalid or missing data
//     }

//     const financialYearStart = new Date(startDateStr);
//     const financialYearEnd = new Date(endDateStr);

//     // Check if the selected date is within the stored financial year range
//     if (selectedDate >= financialYearStart && selectedDate <= financialYearEnd) {
//       return null; // Valid
//     } else {
//       return { financialYear: true }; // Invalid
//     }
//   };
// }






export interface StateGroup {
  category: string;
  details: string[];
}

const uploadAPI = 'https://vivekweb.in/VivekApplication/portal_fileUpload.php';

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter1 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter2 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter3 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter4 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter7 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};





const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY', // Input format (e.g., from the input)
  },
  display: {
    dateInput: 'MM/DD/YYYY', // Output format (e.g., displayed on the input)
    monthYearLabel: 'MMM YYYY', // Optional: Month and year display format
    dateA11yLabel: 'LL', // Optional: Accessibility date format
    monthYearA11yLabel: 'MMMM YYYY', // Optional: Accessibility month and year format
  },
};

@Component({
  selector: 'app-advertisement-details',
  templateUrl: './advertisement-details.component.html',
  styleUrls: ['./advertisement-details.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class AdvertisementDetailsComponent implements OnInit {



  // manualEntries: FormArray;

  manualEntries: FormArray = this.formBuilder.array([]);

  financialYearMin!: Date;
  financialYearMax!: Date;

  isButtonDisabled = false;

  personalLedBriefData: any;
  repName = '';
  // offRepName = '';
  advtName = '';
  public uploader: FileUploader = new FileUploader({
    url: uploadAPI,
    itemAlias: 'file',
  });

  imgPath : any;
  stateForm: FormGroup = this.formBuilder.group({
    stateGroup: '',
  });

  stateGroups: StateGroup[] = [
    { category: 'Magazine', details: ['Vivek_Weekly'] },
    {
      category: 'Grantha',
      details: ['abc', 'pqr'],
    },
    { category: 'Special Magazine', details: ['xyq'] },
  ];


  manualEntryForm!: FormGroup;


  AdvtGeneratedInvoice = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  advtinvoiceForm = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    issuename: new FormControl(''),
    issuedate: new FormControl(''),
    repname: new FormControl(),
    off_rep_name: new FormControl(),
  });
  stampgetdata = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    advtname: new FormControl(''),
    // issuedate: new FormControl(''),
  });

  stampgetdata1 = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    repname: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
    advtname: new FormControl(''),
  });





  advtAdvanceStampform = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    date: new FormControl(''),
    recptdate: new FormControl(''),
    crdtvno: new FormControl(''),
    advtname: new FormControl(''),
    repname: new FormControl(''),
    newordeleted: new FormControl(''),

  });
  PersonalNoteform = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    advtname: new FormControl(''),
  });

  @ViewChild('myInput')
  myInputField!: ElementRef;
  stateGroupOptions!: Observable<StateGroup[]>;
  advtInvoiceList :any;
  ionicForm!: FormGroup;
  contractForm!: FormGroup;
  issueForm!: FormGroup;
  advtbillForm!: FormGroup;
  advtbillFormsecond!: FormGroup;

  contractDetailsForm!: FormGroup;
  advtpymtrecptform!: FormGroup;
  advtCreditNoteform!: FormGroup;
  advtcommrecptform!: FormGroup;
  expense: FormGroup;


  advtcommForm = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    repname: new FormControl(''),
  });


  commission_Total: number = 0;
  commRemainingTotal: number = 0;

  advtTypes : any;
  validDOB: any;
  defaultDate : any;;
  countries = [];
  states = [];
  cities = [];
  talukas = [];
  titles = [];
  bookList = [];
  selectedState = '';
  selectedCity = '';
  selectedTaluka = '';
  AdvtDetails = [];
  advtSizes = [];
  occupations = [];
  advtpaymentList = [];
  invoicenumber = 'VSJ-'
  getAllRepList = [
    {
      id: 777,
      mobile: '1234567893',
      name: 'All',
      rep_address: '',
      rep_advt_comm: '0',
      rep_book_comm: '0',
      rep_comm: '0',
    },
  ];

  getFinancialYears = [
    { startdate: '2020 April', enddate: '2021 March' },
    { startdate: '2021 April', enddate: '2022 March' },
    { startdate: '2022 April', enddate: '2023 March' },
    { startdate: '2023 April', enddate: '2024 March' },
    { startdate: '2024 April', enddate: '2025 March' },
    { startdate: '2025 April', enddate: '2026 March' },
    { startdate: '2026 April', enddate: '2027 March' },
    { startdate: '2027 April', enddate: '2028 March' },
    { startdate: '2028 April', enddate: '2029 March' },
    { startdate: '2029 April', enddate: '2030 March' },
    { startdate: '2020 April', enddate: '2031 March' },
  ];

  rangeRegistration = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  RegistrationreportRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    offrepname: new FormControl(),
    issuename: new FormControl(),
    issuedate: new FormControl(),
    tiktype : new FormControl(),
  });

  PrasiddhipatrakRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    pagetype: new FormControl(),
    issueDates: new FormControl(),
    AmtType : new FormControl(),
    tiktype :new FormControl(),

  });

  RepwiseRegistrationreportRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),

  });
  PaymentReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });

  PendingCreditVoucher = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),

  })

  StamptReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    rep_name: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });

  // CreditReport1 = new FormGroup({
  //   start: new FormControl(),
  //   end: new FormControl(),
  // });
  CreditNoteForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
    newordeleted: new FormControl(''),

  });
  OutStandingForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    offrepname: new FormControl(),
    issuecate: new FormControl(),
    advtname: new FormControl(),
    name: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });
  GSTFullReportForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    offrepname: new FormControl(),
  });
  CreditNoteReportForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  CommissionReportForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });


  BusinessReportForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    offrepname: new FormControl(),
    country: new FormControl(),
    state: new FormControl(),
    district: new FormControl(),
    taluka: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
  });

  AddressForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    issuename: new FormControl(),
    issueDates: new FormControl(),
    repname: new FormControl(),
    offrepname: new FormControl(),
    country: new FormControl(),
    state: new FormControl(),
    district: new FormControl(),
    taluka: new FormControl(),
    advtType: new FormControl(),


  })

  Sendreminderform = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
    repname: new FormControl(),
    advtname: new FormControl(),

  });
  Advtremainingamt = new FormGroup({
    invoiceNumber: new FormControl(),
    invoiceDate: new FormControl(),
    advtName: new FormControl(),
    issueName: new FormControl(),
    issueDate: new FormControl(),
    receivedAmount: new FormControl(),
    CreditdAmount: new FormControl(),
    totalamt: new FormControl(),
    pendingamt: new FormControl(),
    rep_name: new FormControl(),
    invoicedate: new FormControl(),
    issuedate: new FormControl(),
    off_rep_name: new FormControl(),
  });
  Addadvttype = new FormGroup({
    advttype: new FormControl('', []),
    advttypedeatils: new FormControl('', []),
    id: new FormControl('', []) // Assuming 'id' is a string, defaulting to an empty string
  });


  Addudhishta = new FormGroup({
    repname: new FormControl('', Validators.required),
    Udhishta_amount: new FormControl('', Validators.required),
    id: new FormControl('')
  });


  advt_mag_name_details = [];
  advt_person_name = [];
  filteredOptions!: Observable<string[]>;
  filteredOptions1!: Observable<string[]>;
  filteredOptions2!: Observable<string[]>;
  filteredOptions3!: Observable<string[]>;
  filteredOptions4!: Observable<string[]>;
  filteredOptions5!: Observable<string[]>;
  filteredOptions6!: Observable<string[]>;
  filteredOptions7!: Observable<string[]>;
  advtCategorylist : any;
  invoiceDetails : any;
  viewmode = false;
  repInvoice = 'Y';
  AdvtInvoiceData = [];
  newCustadvtInvoice = false;
  gstNumber = '';
  displayadvtSubscriber = false;
  getAdvtPersonDetail = [];
  getAdvertisement: any;
  advt_mobile : any;
  cust_id : any;
  cust_mobile : any;
  advt_id;
  today = formatDate(new Date(), 'dd-MM-yyyy', 'en-IN', 'GMT+0530');
  issueSellerName;
  issue_seller_name = [];
  advtwisereplist : any;
  advtshow = false;
  issueshow = false;
  contractshow = false;
  advt_names = [];
  rep_names = [];
  advtNamesData = [];
  advt_mobile_no = [];
  advt_owner_name = [];
  contract_no = '';
  booking_no = '';
  contractDetails = [];
  advtSubDetails = [];
  booking_date = '';
  inDetailsRegReport = [];
  inDetailsRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  inDetailsOffRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  offrepNamesOfRegReport = [];
  repNamesOfRegReport = [];
  contractData = [];
  contractRepName = [];
  contractOffRepName = [];
  contractAdvtName = [];
  http: any;
  currentDate!: Date;
  oneMonthAgo!: Date;
  startDate!: Date;
  generatedCreditNote!: string;
  replistFormBeans: any;
  data: any;
  contractRepNamenew: any;
  advtnewreplistForm: any;
  advtnewNewlistForm: any;
  autogeneratedno: any;
  newg: any;
  advtCreditNote: any;
  selecteddata!: number;
  endDate: any;
  offRepName: any;
  CommissionData: any;
  CommissionData1: any
  advtnamesearch: any;
  advtCreditNote1: any;
  data_for_two_receipt: any;
  old_data: any;
  start: any;
  end: any;
  onselect: any;
  credit_type: any;
  remark: any;
  GetOffRep: any;
  issuesub: any;
  getMagIssueDatesandAdvtNames1!: any[];
  newadvtname: any;
  filterrep: any;
  filterissuedate!: any[];
  oldissuename!: Object;
  oldadvttype: any;
  oldadvtudhishta: any;
  PPwithoutnumber: any;
  advtcatsize: any;
  commission_cgst: any
  commission_sgst: any
  advtplus!: number;
  pendingTotal: number = 0;
  totalTotal: number = 0;
  contractTotal: number = 0;
  isupdate = false;
  tds_amt: number = 0;
  other_credit_amt: number = 0;
  total_credit_amt: number = 0;
  district: any;

  startDate_registrationReport: string = '';
  enddate_registrationReport: string = '';
  dateIsEnableReport: boolean = false;
  allList: any;


  // selectedOption: any;
  // GSTFullReportForm: any;

  rowData = [
    { make: "Tesla", model: "Model Y", price: 64950, electric: true },
    { make: "Ford", model: "F-Series", price: 33850, electric: false },
    { make: "Toyota", model: "Corolla", price: 29600, electric: false },
  ];

  // Column Definitions: Defines the columns to be displayed.
  colDefs: ColDef[] = [
    { field: "make" },
    { field: "model" },
    { field: "price" },
    { field: "electric" }
  ];
  getentrybyrepnamelist: any;
  getentrybyadvtrepnamelist: any;
  latestbookingnumber: any;
  issuedate: any;
  issuedatelist: any = [];
  advtPaymentRegiInDetailsFormBeans: any;
  advtcreditnotetRegiInDetailsFormBeans: any;
  PaymentadvtOffInDTotal: any;
  voucherdate: any;
  advtsn: any;
  cid: any;
  newissuedate: any;
  newissuedate1: any;
  stampdata: any;
  deleterec: boolean = false;
  getdeleterecipt: any;

  getdeletereciptinvoice: any;
  getdeletedBookings: any;
  getdeletecnrecipt: any;
  getdeleterecitstamp: any;
  getdeleterecitcn: any;
  advtupdatestatus: any;
  newissuedatepp: any;
  issueDates1: any;
  issuedatespp: any;
  invoicenumberlist: any = [];
  arraynew: any;
  getMagIssueDatesandNames1: any;
  cust_name: any;
  issueName1: any;
  issue_name1: any;
  issue_date1: any;
  invoice_no: any;
  rcpt_no: any;
  address: any;
  pincode: any;
  country: any;
  state: any;
  taluka: any;
  demo1TabIndex1!: number;
  getmodaldata: any;
  tdsamount: any;
  tdspercentage: any;
  balamount: any;
  commissionAmount: any;
  commissionPercentage: any;
  myModalList: any;
  voucher_no: any;
  cheque_no: any;
  cheque_date: any;
  voucher_date: any;
  advtSizeId: any;
  AdvtSizeId: any;
  stampdata1: any;
  snackBar: any;
  stampAdvanceReportType!: string;
  mainexpId: any;
  mainexpName: any;
  subExpData!: any[];
  subexpense: boolean = false;

  mainExpData = [
    {
      id: 35,
      exp_name: 'देणगी',
      source: 'Income'
    }
  ];


  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    public encr: EncdecriptService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private toaster: ToastrService,
    private sharedService: SharedService

  ) {
    this.expense = formBuilder.group({
      expnameother: [''],
      subexpnameother: [''],
      start: [''],
      end: [''],
    });
  }

  addEvent(event: MatDatepickerInputEvent<Date>): void {
    this.Advtremainingamt.get('invoiceDate').setValue(event.value);
    console.log(this.Advtremainingamt)
  }
  public demo1BtnClick1(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }



  public demo1BtnClick12(tabCount: any) {

    this.demo1TabIndex1 = Number(tabCount);

  }
  date: any
  ngOnInit(): void {
    this.getstampdata()

    this.autoGenerateCommissionNo();
    this.sharedService.getData().subscribe((data) => {
      if (data) {
        this.personalLedBriefData = data;
        console.log("Received shared ledger briefly data:", this.personalLedBriefData);
      }
    });


    


    this.demo1BtnClick1(localStorage.getItem("tab"))

    this.Advtremainingamt.get('totalamt').valueChanges.subscribe(() => {
      this.updatePendingAmount();
    });
    this.Advttype();
    this.Advtudhishta();

    this.Advtremainingamt.get('receivedAmount').valueChanges.subscribe(() => {
      this.updatePendingAmount();
    });


    // this.Advtremainingamt.get('credit_noinvoice_amt').valueChanges.subscribe(() => {
    //   this.updatePendingAmount();
    // });


    this.addManualEntry(); // Add first empty entry
    this.setupManualEntryListeners();

    this.getNewRepList();
    this.getNewNameList();
    this.practice();
    this.oldata();
    this.getOffRep();
    this.getNewAdvtName();
    this.withoutpagenopatrak();

    // this.getallVouchersData();
    // this.dataforreceipt(


    const start = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const end = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
    this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');

    // this.getCreditNoteMain(req1);
    // this.advtCreditNoteform = this.formBuilder.group({
    //   date: new FormControl(new Date().toISOString().split('T')[0]) // Set the default value to today's date
    // });

    this.currentDate = new Date();
    this.oneMonthAgo = new Date();
    this.oneMonthAgo.setMonth(this.currentDate.getMonth() - 1);
    this.PaymentReceiptRegister.value.start = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy') || '';
    this.PaymentReceiptRegister.value.end = this.datePipe.transform(this.oneMonthAgo, 'dd/MM/yyyy') || '';

    this.PendingCreditVoucher.value.start = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy') || '';
    this.PendingCreditVoucher.value.end = this.datePipe.transform(this.oneMonthAgo, 'dd/MM/yyyy') || '';


    this.date = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy') || ''
    this.fetchAdvtSizes();
    this.ionicForm = this.formBuilder.group({
      sadvtname: [''],
      smobno: [''],
      sownername: [''],
      name: ['', [Validators.required, Validators.minLength(2)]],
      e_advt_name: [''],
      ownername: [''],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
      ],
      address: ['', [Validators.required, Validators.minLength(2)]],
      country: ['', [Validators.required, Validators.minLength(2)]],
      state: ['', [Validators.required, Validators.minLength(2)]],
      taluka: ['', [Validators.required, Validators.minLength(2)]],
      district: ['', [Validators.required, Validators.minLength(2)]],
      e_district: [''],
      mobileNumber: [
        '',
        [Validators.maxLength(10), Validators.pattern('^[7-9][0-9]{9}$')],
      ],
      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
      ],
      advtType: ['', [Validators.required]],
      dob: [],
      companyRegistration: [''],
      gstno: ['', [Validators.maxLength(15)]],
      rep_name: [''],
      rep_mobile_no: [''],
      stateGroup: [''],
      landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],
      instruction: [''],
      newordeletedBooking: ['new'],
      bookingno: [''],
      bookingdate: ['']
    });

    this.manualEntryForm = this.formBuilder.group({
      advt_invoice_no: [''],
      advt_invoice_date: [''],
      advt_name: [''],
      DS_ISSUENAME: [''],
      DS_ISSUEDATE: [''],
      net_amount: [0],
      pending_amt: [0],
      rcv_amt: [0],
      commissionPercentage: [15],
      isSelected: [false]
    });

    // Initialize form - add this in your ngOnInit or wherever you create the form
    this.contractForm = this.formBuilder.group({
      contractno: [''],
      contractdate: [''],
      repname: [''],
      offrepname: [''],
      advtname: [''],
      priviousbal: [0],
      contractamt: [0],
      discountamt: [0],
      gstpercentage: [18], // Default GST percentage
      gstie: [''],
      netamt: [0],
      netgstprice: [0],
      nettotal: [0],
      contractfromdate: [''],
      contracttodate: [''],
      bookingadvtamt: [0],
      balamt: [0],        // Previous + New Contract
      actualbalamt: [0], 
      instruction: [''],
      subCategory: [''],
    });

    this.issueForm = this.formBuilder.group({
      bookingdate: [''],
      bookingno: [''],
      advtname: [''],
      custname: [''],
      repname: [''],
      issue: [''],
      advtsize: [''],
      issuedates: [''],
      rep_mobile_no: [''],
      offrepname: [''],
      ro_number: [''],
      ro_dates: [''],
      instruction: [''],
      otherdetls: [''],
      pageno: [''],
      advtamout: [''],
      advtdiscount: [''],
      gstie: [''],
      gstamount: [''],
      igstamount: [''],
      totalamt: [''],
      amount: ['', [Validators.minLength(2)]],
      ispartpayment: [''],
      partAmount: [''],
      remainingAmount: [''],
      paymentmode: [''],
      checkno: [''],
      receiptdate: [''],
      receiptno: [''],
      document_name: [''],
      subCategory: [''],
    });

    this.advtbillForm = this.formBuilder.group({
      billno: [''],
      date: [''],
      issuename: [''],
      issuedate: [''],
      advt_name: [''],
      newordeleted: [''],
    });

    this.advtbillFormsecond = this.formBuilder.group({
      start: [''],
      end: [''],
      rep_name: [''],
      zeroFilter: ['']
    });


    this.contractDetailsForm = this.formBuilder.group({
      start: [''],
      end: [''],
      rep_name: [''],
      off_rep_name: [''],
      advt_name: [''],
    });

    this.advtpymtrecptform = this.formBuilder.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      crdtvamt: [''],
      seamt: [''],
      balamt: [''],
      advtname: [''],
      advtnamesearch: [''],
      newordeleted: [''],
    });




    this.stampgetdata1 = this.formBuilder.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
      advtname: [''],
      issuename: [''],
      issueDates: [''],
      repname: [''],
      off_rep_name: [''],
    });


    this.advtcommrecptform = this.formBuilder.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      crdtvamt: [''],
      seamt: [''],
      balamt: [''],
      advtname: [''],
      advtnamesearch: [''],
      newordeleted: [''],
      tdsPercentage: [''],
      tdsAmount: [''],
      totalBalanceAmt: [''],
      comm_percentage: [''],

    });

    this.advtCreditNoteform = this.formBuilder.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      CrNno: [''],
      seamt: [''],
      balamt: [''],
      advtname: [''],
      advtnamesearch: [''],
      newordeleted: [''],

    })

this.contractForm.get('balamt').setValue(this.contractTotal + this.preBal);
this.calculatebookingamt(); // ADDED

// GST Exclude block — after setting balamt  
this.contractForm.get('balamt').setValue(this.contractTotal + this.preBal);
this.calculatebookingamt(); // ADDED

// Zero/empty block — after setting balamt
this.contractForm.get('balamt').setValue(this.preBal);
this.calculatebookingamt(); // ADDED

    

    this.advtCreditNoteform.patchValue({
      date: this.datePipe.transform(this.currentDate, 'dd-MM-yyyy') || '',

    })

    this.advtAdvanceStampform.patchValue({
      date: this.datePipe.transform(this.currentDate, 'dd-MM-yyyy') || '',

    })

    this.service.getAdvtissuename().subscribe((data) => {
      // console.log('Database data', data);
      this.issuesub = data;
      this.oldissuename = data;
      console.log(this.issuesub, "issue sub name")
    });

    // advtinvoiceForm;
    this.booking_date = formatDate(
      new Date(),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    this.issueForm.get('bookingdate').setValue(this.booking_date);

    this.service.getAdvtPersonName().subscribe((data) => {
      this.advt_person_name = data;
      // console.log('advt_person_name', data);
      for (
        let index = 0;
        index < Object.keys(this.advt_person_name).length;
        index++
      ) {
        // if (
        //   this.advt_person_name[index]['name'] != '' &&
        //   this.advt_person_name[index]['name'] != null
        // ) {
        //   this.advt_names.push({
        //     name: this.advt_person_name[index]['name'],
        //   });
        // }

        if (this.advt_person_name[index]['mobile'] != 0) {
          this.advt_mobile_no.push({
            mobile: this.advt_person_name[index]['mobile'],
          });
        }

        if (
          this.advt_person_name[index]['owner_name'] != '' &&
          this.advt_person_name[index]['owner_name'] != null
        ) {
          this.advt_owner_name.push({
            owner_name: this.advt_person_name[index]['owner_name'],
          });
        }
      }


      // this.advt_names = this.uniqueid(this.advt_names, (a) => a.name);

      this.advt_mobile_no = this.uniqueid(this.advt_mobile_no, (a) => a.mobile);

      this.advt_owner_name = this.uniqueid(
        this.advt_owner_name,
        (a) => a.owner_name
      );

      // console.log('advt_owner_name', this.advt_owner_name);
    });



    this.service.getAdvtWiseRep().subscribe((data) => {
      this.advtwisereplist = data;
    });

    this.service.getIssuesellersname().subscribe((data) => {
      this.issue_seller_name = data;
      // console.log('issue_seller_name', this.issue_seller_name);
    });

    this.service.getAdvtCategory().subscribe((data) => {
      // console.log('Database data', data);
      this.advtCategorylist = data;
    });



    this.service.getIssueSellerName().subscribe((data) => {
      this.issueSellerName = data;
      // console.log('issueSellerName ', this.issueSellerName);
    });

    //Autocomplete :
    this.stateGroupOptions = this.stateForm
      .get('stateGroup')!
      .valueChanges.pipe(
        startWith(''),
        map((value) => this._filterGroup(value))
      );

    this.getAdvtMagDetails();

    this.service.getAdvtTypes().subscribe((data) => {
      // console.log(data);
      this.advtTypes = data;
    });

    this.service.get_AllRepresentative_List().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.getAllRepList.push(data[index]);
      }
      // console.log('getAllRepList', this.getAllRepList);
    });
    this.service.get_AllRepresentative_List().subscribe((data: any) => {
      console.log("rep name", data);
      this.replistFormBeans = (data as any);;

    });
    // Read All Contries
    // this.service.getAllContries().subscribe((data) => {
    // console.log(data);
    //   this.countries = data;
    // });

    this.getRepAndOffNames();

    this.service.getCountry().subscribe((data) => {
      this.countries = data;
    });

    this.service.getOccupation().subscribe((data) => {
      // console.log(data);
      this.occupations = data;
    });

    this.service.getAlltitle().subscribe((data) => {
      // console.log(data);
      this.titles = data;
    });

    this.service.getAdvtSizes().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.advtSizes.push({ name: data[index]['advt_size'] });
      }
    });

    this.service.getAllBooks().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        if (index == 0) {
          this.bookList.push({ name: 'Vivek_Weekly' });
        }
        this.bookList.push({ name: data[index]['bookname'] });
      }
    });



    this.filteredOptions = this.ionicForm.get('sadvtname').valueChanges.pipe(

      startWith(''),

      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter(name) : this.advt_names.slice()))
    );


    this.filteredOptions1 = this.ionicForm.get('rep_name').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter1(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions2 = this.ionicForm.get('smobno').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.mobile)),
      map((mobile) =>
        mobile ? this._filter2(mobile) : this.advt_mobile_no.slice()
      )
    );

    this.filteredOptions3 = this.ionicForm.get('sownername').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.owner_name)),
      map((owner_name) =>
        owner_name ? this._filter3(owner_name) : this.advt_owner_name.slice()
      )
    );

    this.filteredOptions4 = this.issueForm.get('repname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter1(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions6 = this.contractForm.get('repname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter1(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions7 = this.advtpymtrecptform
      .get('advtnamesearch')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.advt_name)),
        map((advt_name) =>
          advt_name ? this._filter7(advt_name) : this.advtNamesData.slice()
        )
      );
    this.filteredOptions7 = this.advtCreditNoteform
      .get('advtnamesearch')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.advt_name)),
        map((advt_name) =>
          advt_name ? this._filter7(advt_name) : this.advtNamesData.slice()
        )
      );

    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      console.log('FileUpload:uploaded successfully:', item, status, response);
      this.imgPath = item['file']['name'];
      this.issueForm.get('document_name').setValue(this.imgPath);
      console.log('imgPath', this.imgPath);

      alert('Your file has been uploaded successfully');
    };

    this.getContractNo();
    this.getAdvtPayments();

    this.enableDisableRule('Contract');
    this.getBookingNo(formatDate(new Date(), 'MM', 'en-IN', 'GMT+0530'));
    this.getPrasiddhiPatrakNamesData();
    this.getallcontarctdetails();
    this.setDefaultValues();
    this.getAllAdvtInovicesData();



    this.advtcommForm.valueChanges.subscribe(() => {
      const start = this.advtcommForm.get('start')?.value;
      const end = this.advtcommForm.get('end')?.value;
      const repname = this.advtcommForm.get('repname')?.value;


      if (start && end) {
        this.getChangedDateContractCommisionpending();
      }
    });



    

    const fyDates = this.getCurrentFinancialYearDates();

    // Call the API with financial year dates
    this.getAllVouchers(fyDates.start, fyDates.end);

    this.getAllCommVouchers(fyDates.start, fyDates.end);

    this.initializeCommissions();
  }


  
  // Helper method to get current financial year dates
  getCurrentFinancialYearDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0-11 (0 = January)

    let fyStart: string;
    let fyEnd: string;

    // Assuming financial year is April to March (adjust if different)
    if (currentMonth >= 3) { // April (month 3) onwards
      fyStart = `${currentYear}-04-01`;
      fyEnd = `${currentYear + 1}-03-31`;
    } else { // January to March
      fyStart = `${currentYear - 1}-04-01`;
      fyEnd = `${currentYear}-03-31`;
    }

    return { start: fyStart, end: fyEnd };
  }

  // getAllVouchers(startDate: string, endDate: string) {
  //   this.totalTotal = 0;
  //   this.pendingTotal = 0;

  //   this.service.getvoucherbyAdvt(startDate, endDate).subscribe((data: any) => {
  //     this.getallVouchersData = data;

  //     for (let item of this.getallVouchersData) {
  //       this.totalTotal += parseInt(item.price) || 0;
  //       this.pendingTotal += parseInt(item.remaining_amt) || 0;
  //     }
  //   });


  // }





  //end of ngOnInit()

  getAllVouchers(startDate: string, endDate: string) {
  // 1. Ensure totals reset
  this.totalTotal = 0;
  this.pendingTotal = 0;

  // 2. Check if dates exist
  if (!startDate || !endDate) {
    console.error("Dates are missing!");
    return;
  }

  this.service.getvoucherbyAdvt(startDate, endDate).subscribe({
    next: (data: any) => {
      this.getallVouchersData = data;
      
      // 3. Ensure data is an array before looping
      if (Array.isArray(this.getallVouchersData)) {
        for (let item of this.getallVouchersData) {
          // Use Number() to handle decimals properly
          this.totalTotal += Number(item.price) || 0;
          this.pendingTotal += Number(item.remaining_amt) || 0;
        }
      }
    },
    error: (err) => {
      console.error("Service error:", err); // This will tell you if the server crashed
    }
  });
}



  getstampdata() {


    // Get current date
    const currentDate = new Date();

    // Calculate start date as 3 months before the current date
    const startDate = new Date();
    startDate.setMonth(currentDate.getMonth() - 3);

    // Format dates as 'yyyy-mm-dd'
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if necessary
      const day = ('0' + date.getDate()).slice(-2); // Add leading zero if necessary
      return `${year}-${month}-${day}`;
    };

    // Assign formatted dates to variables
    const advt_name = '';
    const start_date = formatDate(startDate);
    const end_date = formatDate(currentDate);

    // Call the service with the calculated dates
    this.service.getStampdata(start_date, end_date, advt_name,).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.stampdata = data;
      console.log(this.stampdata, "stamp data");
      // this.ngOnInit();
    });
  }


  getAdvtissuename(event: any) {

  }




  fetchAdvtSizes() {
    // Fetch or set advtsizebyCategory
    this.advtsizebyCategory = []; // Update with your data
  }

  calculatebookingamt() {
    const bookingAmt = this.contractForm.get('bookingadvtamt').value;
    const netTotal = this.contractForm.get('nettotal').value;
    const balanceAmt = parseInt(netTotal) - parseInt(bookingAmt);
    // alert(netTotal+","+bookingAmt+","+balanceAmt)
    this.contractForm.patchValue({ balamt: balanceAmt }, { emitEvent: false });

  }




  getRepAndOffNames() {
    this.service.getOffRepAndRepForRegReport().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < data.length; index++) {
        this.offrepNamesOfRegReport.push({
          off_rep_name: data[index]['off_rep_name'],
        });
        this.repNamesOfRegReport.push({
          rep_name: data[index]['rep_name'],
        });
      }

      this.offrepNamesOfRegReport = this.uniqueid(
        this.offrepNamesOfRegReport,
        (a) => a.off_rep_name
      );

      this.repNamesOfRegReport = this.uniqueid(
        this.repNamesOfRegReport,
        (a) => a.rep_name
      );
    });
  }

  bookingdateChange(event) {
    // console.log(event.target.value);
    this.booking_date = formatDate(
      event.target.value,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    // console.log(this.booking_date);
    this.getBookingNo(
      formatDate(event.target.value, 'MM', 'en-IN', 'GMT+0530')
    );
  }

  getBookingNo(date) {
    this.service.getNextBookingNo(date).subscribe((res) => {
      // console.log('booking no db', res);
      if (Object.keys(res).length > 0) {
        this.booking_no = res[0]['booking_no'];
      }
    });

    setTimeout(() => {

      const currentYear = this.currentDate.getFullYear().toString().slice(-2);
      if (this.booking_no != '' && this.booking_no != null) {
        let val = this.booking_no.split('-');
        console.log('booking no', this.booking_no, val, currentYear);
        this.booking_no = `ABN${formatDate(
          new Date(date),
          'MM',
          'en-IN',
          'GMT+0530'
        )}-${currentYear}-${parseInt(val[2]) <= 9
          ? '0' + (parseInt(val[2]) + 1)
          : parseInt(val[2]) + 1
          }`;
        this.issueForm.get('bookingno').setValue(this.booking_no);

      }
    }, 1000);
  }

  getContractNo() {
    this.service.getNextContractNo().subscribe((res) => {
      // console.log(res);
      this.contract_no = `ADVTCON-${res['id']}`;
      // console.log(this.contract_no);
      this.contractshow = false
      this.contractForm.get('contractno').setValue(this.contract_no);
    });
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  toggle = false;
  toggle1 = false;
  toggle2 = false;
  enableDisableRule(val) {
    if (val == 'Special Issue') {
      this.toggle = true;
      this.toggle1 = false;
      this.toggle2 = false;
      this.contractForm.reset();
      this.contractshow = false;
    } else if (val == 'Occasional') {
      this.toggle = false;
      this.toggle1 = true;
      this.toggle2 = false;
      this.contractForm.reset();
      this.contractshow = false;
    } else if (val == 'Contract') {
      this.toggle = false;
      this.toggle1 = false;
      this.toggle2 = true;
      this.getContractNo();
      this.getcontractDetails(this.advt_id1);
      if (this.contractForm.get('repname').value != '') {
        this.setAdvtSubData(this.contractForm.get('repname').value);
        // this.setContractData(this.ionicForm.get('rep_name').value);
      }
    }
  }

  getAdvtPayments() {
    this.service.getAdvtPendingPayment().subscribe((res) => {
      // console.log(res);

      this.advtpaymentList = [];
      for (let index = 0; index < Object.keys(res).length; index++) {
        this.advtpaymentList.push({
          rep_id: parseInt(res[index]['repId']),
          name: res[index]['repName'],
          id: parseInt(res[index]['id']),
          claim_name: res[index]['name'],
          totalAmount: parseInt(res[index]['totalAmount']),
          payoptn: res[index]['payoptn'],
          repName: res[index]['repName'],
          repmobile: res[index]['repmobile'],
          rep_receipt: res[index]['rep_receipt'],
          task: 'advt',
        });
      }
    });
  }

  displayBookPayment(paymentdetails) {
    // console.log(paymentdetails);
    this.dialog.open(SubscriptionAccountsComponent, {
      data: {
        rep: paymentdetails,
        view: false,
      },
    });
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.advt_names.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter1(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter2(mobile: string): any[] {
    const filterValue = mobile.toLowerCase();

    return this.advt_mobile_no.filter((option) =>
      option.mobile.toLowerCase().includes(filterValue)
    );
  }

  private _filter3(owner_name: string): any[] {
    const filterValue = owner_name.toLowerCase();

    return this.advt_owner_name.filter((option) =>
      option.owner_name.toLowerCase().includes(filterValue)
    );
  }

  private _filter4(data: string): any[] {
    const filterValue = data.toLowerCase();

    return this.filterdMagIssueDatesandNames.filter((option) =>
      option.data.toLowerCase().includes(filterValue)
    );
  }

  private _filter7(advt_name: string): any[] {
    const filterValue = advt_name.toLowerCase();

    return this.advtNamesData.filter((option) =>
      option.advt_name.toLowerCase().includes(filterValue)
    );
  }

  private _filterGroup(value: string): StateGroup[] {
    if (value) {
      return this.stateGroups
        .map((group) => ({
          category: group.category,
          details: _filter(group.details, value),
        }))
        .filter((group) => group.details.length > 0);
    }

    return this.stateGroups;
  }

  update(item) {
    this.dialog.open(UpdateOfficeRepresentativeComponent, {
      data: {
        item: item,
        type: 'advt',
      },
    });
    this.service.getAdvtWiseRep().subscribe((data) => {
      this.advtwisereplist = data;
    });
  }

  mob_no1;
  selected_mob_no(event, option) {
    if (event.isUserInput) {
      this.mob_no1 = option['mobile'];
      this.owner_name = 'abc';
      this.advt_name1 = 'xyz';
    }
  }

  owner_name;
  selected_owner_name(event, option) {
    if (event.isUserInput) {
      this.owner_name = option['owner_name'];
      this.mob_no1 = 777;
      this.advt_name1 = 'xyz';
    }
  }

  comm_percentage: any;

  advt_name1;
  selected_name1(event, option) {
    debugger;
    if (event.isUserInput) {
      this.advt_name1 = option['name'];
      this.advt_name = option['name'];
      this.owner_name = 'abc';
      this.mob_no1 = 777;
      this.comm_percentage = option.comm_percentage;
    }

    this.searchRepAdvtName1();
  }
  advt_name2;
  filterstampdata: any
  selected_name2(event) {

    this.advt_name2 = event.source.value

    this.filterstampdata = this.stampdata.filter(data => data.advt_name == this.advt_name2);
    console.log(this.filterstampdata, " this.filterstampdata")
    this.stampdata = this.filterstampdata
  }

  advt_id1 = 0;
  contract_id = 0;
  old_name = ''
  selected_name() {
    // console.log(this.owner_name, this.mob_no1, this.advt_name1);
    this.service
      .getAdvtMobileorid(this.owner_name, this.mob_no1, this.advt_name1)
      .subscribe((data) => {
        // console.log('getAdvtMobileorid', data);
        this.old_name = data[0]['name']
        this.advtshow = true;
        this.advt_id1 = data[0]['advt_id'];
        this.ionicForm.get('name').setValue(data[0]['name']);
        this.issueForm.get('advtname').setValue(data[0]['name']);
        // this.contractForm.get('advtname').setValue(data[0]['name']);
        this.ionicForm.get('ownername').setValue(data[0]['owner_name']);
        this.ionicForm.get('email').setValue(data[0]['email']);
        this.ionicForm.get('address').setValue(data[0]['address']);
        this.getCountry({ value: data[0]['country'] });
        this.ionicForm.get('country').setValue(data[0]['country']);
        this.ionicForm.get('advtType').setValue(data[0]['advt_type']);
        this.ionicForm.get('e_advt_name').setValue(data[0]['e_advt_name']);
        this.ionicForm.get('e_district').setValue(data[0]['e_district']);
        this.ionicForm.get('dob').setValue(data[0]['dob']);
        setTimeout(() => {
          this.getState({ value: data[0]['state'] });
          this.ionicForm.get('state').setValue(data[0]['state']);
        }, 1000);
        this.ionicForm.get('district').setValue(data[0]['district']);
        setTimeout(() => {
          this.getDistricts({ value: data[0]['district'] });
        }, 1500);
        this.ionicForm.get('taluka').setValue(data[0]['taluka']);
        this.ionicForm.get('mobileNumber').setValue(data[0]['mobile']);
        this.ionicForm.get('pincode').setValue(data[0]['pincode']);
        this.ionicForm
          .get('companyRegistration')
          .setValue(data[0]['company_reg_date']);
        this.ionicForm.get('gstno').setValue(data[0]['gstno']);
        this.ionicForm.get('landline_no').setValue(data[0]['landline_no']);
        this.ionicForm.get('instruction').setValue(data[0]['instruction']);
        this.ionicForm.get('rep_name').setValue(data[0]['rep_name']);
        // this.setContractData(data[0]['rep_name']);
        this.ionicForm.get('rep_mobile_no').setValue(data[0]['rep_mob_no']);
        this.selectedCity = data[0]['district'];
        this.selectedState = data[0]['state'];
        this.selectedTaluka = data[0]['taluka'];
        // this.getState({ value: this.selectedState });
        // console.log(this.selectedCity, this.selectedState);

        this.getcontractDetails(this.advt_id1);
        setTimeout(() => {
          this.setContractDetails();
        }, 2000);
      });
  }

  preBal = 0;
  conAmt = 0;
  netAmt = 0;
  disAmt = 0;
  percentage = 18; // Set default GST percentage to 18%

  calculateNetGstAmt(event) {
    // Get values from form controls
    this.preBal =
      this.contractForm.get('priviousbal').value == '' ||
        this.contractForm.get('priviousbal').value == null
        ? 0
        : Number(this.contractForm.get('priviousbal').value);

    this.conAmt =
      this.contractForm.get('contractamt').value == '' ||
        this.contractForm.get('contractamt').value == null
        ? 0
        : Number(this.contractForm.get('contractamt').value);

    this.disAmt =
      this.contractForm.get('discountamt').value == '' ||
        this.contractForm.get('discountamt').value == null
        ? 0
        : Number(this.contractForm.get('discountamt').value);

    console.log('Contract Amount:', this.conAmt);
    console.log('Discount Amount:', this.disAmt);
    console.log('Previous Balance:', this.preBal);
    console.log('GST Option:', event.value);
    console.log('GST Percentage:', this.percentage);




    if (this.conAmt > 0 && this.percentage) {
      let contractTotal = 0;
      let gstamt = 0;
      let afterDiscount = this.conAmt - this.disAmt;

      if (event.value == 'gstInclude') {
        // GST is already included in the contract amount
        // Formula: Net Amount = (Contract Amount - Discount) / (1 + GST%/100)
        // GST Amount = (Contract Amount - Discount) - Net Amount
        contractTotal = afterDiscount;
        this.netAmt = Math.round(contractTotal / (1 + (Number(this.percentage) / 100)));
        gstamt = contractTotal - this.netAmt;

        console.log('GST Include - Contract Total:', contractTotal);
        console.log('GST Include - Net Amount:', this.netAmt);
        console.log('GST Include - GST Amount:', gstamt);

      } else if (event.value == 'gstExclude') {
        // GST needs to be added on top of contract amount
        // Formula: Net Amount = Contract Amount - Discount
        // GST Amount = Net Amount * (GST%/100)
        // Contract Total = Net Amount + GST Amount
        this.netAmt = afterDiscount;
        gstamt = Math.round(this.netAmt * (Number(this.percentage) / 100));
        contractTotal = this.netAmt + gstamt;

        console.log('GST Exclude - Net Amount:', this.netAmt);
        console.log('GST Exclude - GST Amount:', gstamt);
        console.log('GST Exclude - Contract Total:', contractTotal);
      }

      // Set the calculated values to form controls
      this.contractForm.get('netamt').setValue(this.netAmt);
      this.contractForm.get('netgstprice').setValue(gstamt);
      this.contractForm.get('nettotal').setValue(contractTotal);
      this.contractForm.get('balamt').setValue(contractTotal + this.preBal);

    } else {
      // If contract amount is 0 or empty, reset all calculated fields
      this.contractForm.get('netamt').setValue(0);
      this.contractForm.get('netgstprice').setValue(0);
      this.contractForm.get('nettotal').setValue(0);
      this.contractForm.get('balamt').setValue(this.preBal);
    }
  }

  // Call this method when contract amount, discount, or previous balance changes
  onAmountChange() {
    const gstOption = this.contractForm.get('gstie').value;
    if (gstOption && gstOption !== '') {
      this.calculateNetGstAmt({ value: gstOption });
    }
  }

  getcontractDetails(id) {
    if (id != 0) {
      this.service.getContractDetails(id).subscribe((res) => {
        // console.log('getContractDetails', res);
        this.contractDetails = res;
      });
      this.service.getAdvtSubDetailsById(id).subscribe((res) => {
        // console.log('getAdvtSubDetailsById', res);
        this.advtSubDetails = res;
      });
    }
  }



  advt_sub_id = 0;
  ds_advtId = 0;
  isInvoice;
  // selectAdvtIssue(item) {

  //   debugger
  //   if (item['igst'] === '0') {
  //     this.showigst = false;
  //     this.commission_cgst = Number(item['cgst']);
  //     this.commission_sgst = Number(item['sgst']);
  //   } else {
  //     this.showigst = true;
  //   }
  //   console.log(item);
  //   this.AdvtDetails = [];
  //   this.contractshow = true;
  //   this.issueshow = true;
  //   this.advt_sub_id = item['id'];
  //   this.advt_id1 = item['advt_id'];
  //   this.ds_advtId = item['ds_advtId'];
  //   this.isInvoice = item['isInvoice'];
  //   this.AdvtSizeId = item['AdvtSizeId'];
  //   this.advtSizeId = item['AdvtSizeId'];

  //   this.contract_no = item['contract_no'];
  //   this.booking_date = item['booking_date'];
  //   this.getIssues({ value: item['issue_name'] });
  //   this.issueForm.get('bookingdate').setValue(item['booking_date']);
  //   this.issueForm.get('bookingno').setValue(item['booking_no']);
  //   this.issueForm.get('advtname').setValue(item['advt_name']);
  //   this.issueForm.get('custname').setValue(item['cust_name']);
  //   this.issueForm.get('repname').setValue(item['rep_name']);
  //   this.issueForm.get('rep_mobile_no').setValue(item['rep_mob_no']);
  //   this.issueForm.get('offrepname').setValue(item['off_rep_name']);
  //   this.issueForm.get('issue').setValue(item['issue_name']);
  //   const match = this.advtsizebyCategory.find(x => x.Advt_size === item.Advt_size);
  //   this.issueForm.get('advtsize')?.setValue(match);
  //   this.issueName = item['issue_name'];
  //   // this.issueName1 = item['issue_name1'];
  //   debugger
  //   this.advtSize = item['advt_size'];
  //   this.invoice_no = item['invoice_no'];
  //   this.rcpt_no = item['rcpt_no'];
  //   this.stringdates = item['issue_date'];
  //   this.issue_name1 = item['issue_name1'];
  //   this.issue_date1 = item['issue_date1'];
  //   debugger;

  //   this.issueForm.get('issuedates').setValue(item['issue_date']);


  //   this.issueForm.get('ro_number').setValue(item['ro_no']);
  //   this.issueForm.get('ro_dates').setValue(item['ro_date']);
  //   this.issueForm.get('instruction').setValue(item['instruction']);
  //   this.issueForm.get('otherdetls').setValue(item['other_details']);
  //   this.issueForm.get('pageno').setValue(item['page_no']);
  //   this.issueForm.get('advtamout').setValue(item['advt_amt']);
  //   this.issueForm.get('advtdiscount').setValue(item['advt_discnt']);
  //   this.issueForm.get('gstie').setValue(item['gst_include_exclude']);
  //   this.gstie = item['gst_include_exclude'];
  //   this.sgstamt = item['sgst'];
  //   this.igstamt = item['igst'];

  //   // this.showigst
  //   //   ? this.issueForm.get('igstamount').setValue(item['igst'])
  //   //   : this.issueForm.get('gstamount').setValue(item['sgst']);
  //   this.issueForm.get('totalamt').setValue(item['total_amount']);
  //   this.issueForm.get('amount').setValue(item['amount']);
  //   this.issueForm.get('ispartpayment').setValue(item['is_part_pymt']);
  //   this.issueForm.get('partAmount').setValue(item['part_pymt_amt']);
  //   this.issueForm
  //     .get('remainingAmount')
  //     .setValue(item['part_pymt_remaning_amt']);
  //   this.issueForm
  //     .get('gstamount')
  //     .setValue(Number(item['sgst']) + Number(item['sgst']));
  //   this.issueForm
  //     .get('igstamount')
  //     .setValue(Number(item['igst']));
  //   this.issueForm.get('paymentmode').setValue(item['pymt_mode']);
  //   this.issueForm.get('checkno').setValue(item['cheque_no']);
  //   this.issueForm.get('receiptdate').setValue(item['rcpt_date']);
  //   this.issueForm.get('receiptno').setValue(item['rep_rcpt_no']);
  //   this.issueForm.get('document_name').setValue(item['img_name']);
  //   this.newissuedatepp = this.issue_name1;
  //   this.issuedatespp = this.issue_date1;
  //   this.addAdvt();
  //   // this.getAdvtDiscount();
  // }





  selectAdvtIssue(item) {

    debugger
    if (item['igst'] === '0') {
      this.showigst = false;
      this.commission_cgst = Number(item['cgst']);
      this.commission_sgst = Number(item['sgst']);
    } else {
      this.showigst = true;
    }
    console.log(item);
    this.AdvtDetails = [];
    this.contractshow = true;
    this.issueshow = true;
    this.advt_sub_id = item['id'];
    this.advt_id1 = item['advt_id'];
    this.ds_advtId = item['ds_advtId'];
    this.isInvoice = item['isInvoice'];
    this.AdvtSizeId = item['AdvtSizeId'];
    this.advtSizeId = item['AdvtSizeId'];

    this.contract_no = item['contract_no'];
    this.booking_date = item['booking_date'];

    this.issueForm.get('bookingdate').setValue(item['booking_date']);
    this.issueForm.get('bookingno').setValue(item['booking_no']);
    this.issueForm.get('advtname').setValue(item['advt_name']);
    this.issueForm.get('custname').setValue(item['cust_name']);
    this.issueForm.get('repname').setValue(item['rep_name']);
    this.issueForm.get('rep_mobile_no').setValue(item['rep_mob_no']);
    this.issueForm.get('offrepname').setValue(item['off_rep_name']);
    this.issueForm.get('issue').setValue(item['issue_name']);

    this.issueName = item['issue_name'];
    // this.issueName1 = item['issue_name1'];
    debugger
    this.advtSize = item['Advt_size'];
    this.invoice_no = item['invoice_no'];
    this.rcpt_no = item['rcpt_no'];
    this.stringdates = item['issue_date'];
    this.issue_name1 = item['issue_name1'];
    this.issue_date1 = item['issue_date1'];
    debugger;

    this.issueForm.get('issuedates').setValue(item['issue_date']);
    this.issueForm.get('ro_number').setValue(item['ro_no']);
    this.issueForm.get('ro_dates').setValue(item['ro_date']);
    this.issueForm.get('instruction').setValue(item['instruction']);
    this.issueForm.get('otherdetls').setValue(item['other_details']);
    this.issueForm.get('pageno').setValue(item['page_no']);
    this.issueForm.get('advtamout').setValue(item['advt_amt']);
    this.issueForm.get('advtdiscount').setValue(item['advt_discnt']);
    this.issueForm.get('gstie').setValue(item['gst_include_exclude']);
    this.issueForm.get('subCategory').setValue(item['subCategory']);
    this.gstie = item['gst_include_exclude'];
    this.sgstamt = item['sgst'];
    this.igstamt = item['igst'];




    // this.showigst
    //   ? this.issueForm.get('igstamount').setValue(item['igst'])
    //   : this.issueForm.get('gstamount').setValue(item['sgst']);
    this.issueForm.get('totalamt').setValue(item['total_amount']);
    this.issueForm.get('amount').setValue(item['amount']);
    this.issueForm.get('ispartpayment').setValue(item['is_part_pymt']);
    this.issueForm.get('partAmount').setValue(item['part_pymt_amt']);
    this.issueForm
      .get('remainingAmount')
      .setValue(item['part_pymt_remaning_amt']);
    this.issueForm
      .get('gstamount')
      .setValue(Number(item['sgst']) + Number(item['cgst']));
    this.issueForm
      .get('igstamount')
      .setValue(Number(item['igst']));
    this.issueForm.get('paymentmode').setValue(item['pymt_mode']);
    this.issueForm.get('checkno').setValue(item['cheque_no']);
    this.issueForm.get('receiptdate').setValue(item['rcpt_date']);
    this.issueForm.get('receiptno').setValue(item['rep_rcpt_no']);
    this.issueForm.get('document_name').setValue(item['img_name']);
    this.newissuedatepp = this.issue_name1;
    this.issuedatespp = this.issue_date1;

    // Call getIssues and wait for advtsize to be set
    this.getIssues({ value: item['issue_name'] });

    // Store the item Advt_size
    const selectedAdvtSize = item['Advt_size'];

    // Set advtsize and then call addAdvt
    setTimeout(() => {
      const match = this.advtsizebyCategory?.find(x => x.Advt_size === selectedAdvtSize);
      if (match) {
        this.issueForm.get('advtsize')?.setValue(match);
      }
      // Call addAdvt AFTER setting the form value
      this.addAdvt();
    }, 300);

    // this.getAdvtDiscount();
  }

  bookingAdvtAmount = 0;
  contractBalAmt = 0;
  setContractDetails() {
    if (Object.keys(this.contractDetails).length > 0) {
      this.contractshow = true;
      this.contract_id = this.contractDetails[0]['contract_id'];
      this.contract_no = this.contractDetails[0]['contract_no'];
      this.contractForm.get('contractno').setValue(this.contract_no);
      this.contractForm
        .get('contractdate')
        .setValue(this.contractDetails[0]['contract_date']);
      this.contractForm
        .get('repname')
        .setValue(this.contractDetails[0]['rep_name']);
      this.contractForm
        .get('offrepname')
        .setValue(this.contractDetails[0]['off_rep_name']);
      this.contractForm
        .get('advtname')
        .setValue(this.contractDetails[0]['advt_name']);
      this.contractForm
        .get('priviousbal')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_prev_bal'])
        );
      this.contractForm
        .get('contractamt')
        .setValue(this.convertToInt(this.contractDetails[0]['contract_amt']));
      this.contractForm
        .get('discountamt')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_discnt_amt'])
        );
      this.contractForm
        .get('netamt')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_net_amt'])
        );
      this.contractForm
        .get('netgstprice')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_net_gst_amt'])
        );
      this.contractForm
        .get('nettotal')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_net_total'])
        );
      this.contractForm
        .get('contractfromdate')
        .setValue(this.contractDetails[0]['contract_period_from']);
      this.contractForm
        .get('contracttodate')
        .setValue(this.contractDetails[0]['contract_period_to']);
      this.contractForm
        .get('bookingadvtamt')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_bkng_advt_amt'])
        );
      this.bookingAdvtAmount = parseInt(
        this.contractDetails[0]['contract_bkng_advt_amt']
      );
      this.contractForm
        .get('balamt')
        .setValue(
          this.convertToInt(this.contractDetails[0]['contract_bal_amt'])
        );
      this.contractForm
        .get('gstie')
        .setValue(this.contractDetails[0]['gst_include_exclude']);
      this.contractBalAmt = parseInt(
        this.contractDetails[0]['contract_bal_amt']
      );

      this.calculatebookingamt()
    }
  }

  getManualSelectedAmount(): number {
    const isSelected = this.manualEntryForm.get('isSelected')?.value;
    if (isSelected) {
      const netAmount = this.manualEntryForm.get('net_amount')?.value || 0;
      return netAmount;  // Returns net_amount when selected
    }
    return 0;
  }

  convertToInt(num) {
    return parseInt(num);
  }

  compareFn = (o1: any, o2: any) => {
    return o1 && o2 ? o1.Advt_size === o2.Advt_size : o1 === o2;
  };

  saveAdvt() {
    let data = {
      name: this.ionicForm.get('name').value,
      ownername: this.ionicForm.get('ownername').value,
      email: this.ionicForm.get('email').value,
      address: this.ionicForm.get('address').value,
      country: this.ionicForm.get('country').value,
      state: this.ionicForm.get('state').value,
      taluka: this.ionicForm.get('taluka').value,
      district: this.ionicForm.get('district').value,
      mobileNumber: this.ionicForm.get('mobileNumber').value,
      pincode: this.ionicForm.get('pincode').value,
      advtType: this.ionicForm.get('advtType').value,
      e_advt_name: this.ionicForm.get('e_advt_name').value,
      e_district: this.ionicForm.get('e_district').value,
      dob: this.ionicForm.get('dob').value,
      companyRegistration: this.ionicForm.get('companyRegistration').value,
      gstno: this.ionicForm.get('gstno').value,
      rep_name: this.ionicForm.get('rep_name').value,
      rep_mobile_no: this.ionicForm.get('rep_mobile_no').value,
      landline_no: this.ionicForm.get('landline_no').value,
      instruction: this.ionicForm.get('instruction').value,
    };

    this.service.insertAdvt(data).subscribe((res) => {
      window.alert('New Advertiser Added Successfully...');
      if (data.mobileNumber && data.mobileNumber != "" && /^\d{10}$/.test(data.mobileNumber) && data.mobileNumber !== "0000000000") {
                      // this.sendingSMSNew(subdetails);
                      //this.sendingNewWhatsAppMSG(subdetails);
                      this.sendingNewWhatsAppMSG1(data);
                    }
      this.ngOnInit();
    });
  }



  //New Whats App Message
    sendingNewWhatsAppMSG1(subdetails: any) {

    // let subfromdate = this.formatDateToDDMMYYYY(subdetails.subfromdate);
    // let subtodate = this.formatDateToDDMMYYYY(subdetails.subtodate);
    console.log(subdetails.distype);

    // let sunformdate1 = this.getPublishDate(subdetails.subfromdate);
    let subno = subdetails.subno.toString();
    let duration = subdetails.duration;
    let distype = subdetails.distype;
    let name = subdetails.name;
    let mobile = subdetails.mobileNumber.toString();
    let campaignName = "thanku2na";
    let userName = "Vivek Publication";
    let apikey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4MjFjZjIwZGJkNjYwMGMwMjIyYzFlYiIsIm5hbWUiOiJIaW5kdXN0YW4gUHJha2FzaGFuIFNhbnN0aGEiLCJhcHBOYW1lIjoiQWlTZW5zeSIsImNsaWVudElkIjoiNjgxYjJhNDI4YTI5OGUwYzMxMjUzNzM1IiwiYWN0aXZlUGxhbiI6IkZSRUVfRk9SRVZFUiIsImlhdCI6MTc0NzA0NjE3Nn0.SFz4QGZ6c8UCvMhATFf3DdWDvz7U-0MJ9zUgjb_wXnE";

    // let payload = {
    //   campaignName, mobile,
    //   templateParams: [name, subno, subfromdate, subtodate, sunformdate1, distype]
    // }

    let payload = {
      campaignName, mobile,
      // templateParams: [name, subno, duration, subfromdate, subtodate, sunformdate1, distype]
    }

    this.service.sendWhatsAppMSG(payload)
      .subscribe((_a) => {
        // console.log('msg sent successfully....');
      });

  }

  oldata() {
    this.service.get_old_data().subscribe((data: any) => {
      this.old_data = data as any;
      console.log(this.old_data, "old data")
    });
  }

  Advttype() {

    this.service.get_getadvttype().subscribe((data: any) => {
      this.oldadvttype = data as any;
      console.log(this.oldadvttype, "advt type")
    });
  }


  Advtudhishta() {

    this.service.getadvtudhishtha().subscribe((data: any) => {
      this.oldadvtudhishta = data as any;
      console.log(this.oldadvtudhishta, "advt type")
    });
  }
  // onSelectChange(event: MatSelectChange) {
  //   this.selectedOption = event.value;
  // }

  createManualEntryFormGroup(): FormGroup {
    return this.formBuilder.group({
      advt_invoice_no: [''],
      advt_invoice_date: [''],
      advt_name: [''],
      DS_ISSUENAME: [''],
      DS_ISSUEDATE: [''],
      net_amount: [0],
      pending_amt: [0],
      rcv_amt: [0],
      commissionPercentage: [this.comm_percentage || 15],
      isSelected: [false]
    });
  }

  // Add new manual entry
  addManualEntry(): void {
    this.manualEntries.push(this.createManualEntryFormGroup());
    this.setupManualEntryListenersForIndex(this.manualEntries.length - 1);
  }

  // Remove manual entry
  removeManualEntry(index: number): void {
    this.manualEntries.removeAt(index);
    this.calculateTdsAmount();
    this.calculateBalanceAmount();
    this.advtcommrecptform.patchValue({
      seamt: this.getGrandTotal('selectedAmount')
    });
  }

  setupManualEntryListeners(): void {
    // Setup listeners for all existing entries
    for (let i = 0; i < this.manualEntries.length; i++) {
      this.setupManualEntryListenersForIndex(i);
    }
  }

  setupManualEntryListenersForIndex(index: number): void {
    const formGroup = this.manualEntries.at(index) as FormGroup;

    formGroup.get('net_amount')?.valueChanges.subscribe(() => {
      this.calculateTdsAmount();
      this.calculateBalanceAmount();
    });

    formGroup.get('rcv_amt')?.valueChanges.subscribe(() => {
      if (formGroup.get('isSelected')?.value) {
        this.calculateTdsAmount();
        this.calculateBalanceAmount();
      }
    });

    formGroup.get('commissionPercentage')?.valueChanges.subscribe(() => {
      if (formGroup.get('isSelected')?.value) {
        this.calculateTdsAmount();
        this.calculateBalanceAmount();
      }
    });
  }

  isManualEntryValid(index: number): boolean {
    const formGroup = this.manualEntries.at(index) as FormGroup;
    const values = formGroup.value;
    const isSelected = values.isSelected;

    if (!isSelected) {
      return true;
    }

    // Validate that required fields are filled
    return !!(values.advt_invoice_no && values.net_amount > 0);
  }

  getManualCommissionAmount(index: number): number {
    const formGroup = this.manualEntries.at(index) as FormGroup;
    const rcvAmt = formGroup.get('rcv_amt')?.value || 0;
    const percentage = formGroup.get('commissionPercentage')?.value || 0;
    return (rcvAmt * percentage) / 100;
  }

  getManualEntryData(): any[] {
    const manualEntryDataArray = [];

    for (let i = 0; i < this.manualEntries.length; i++) {
      const formGroup = this.manualEntries.at(i) as FormGroup;

      if (!formGroup.get('isSelected')?.value) {
        continue;
      }

      if (!this.isManualEntryValid(i)) {
        continue;
      }

      const formValue = formGroup.value;
      const commissionAmount = this.getManualCommissionAmount(i);
      const netAmount = formValue.net_amount || 0;

      manualEntryDataArray.push({
        advt_invoice_no: formValue.advt_invoice_no,
        advt_invoice_date: formValue.advt_invoice_date,
        advt_name: formValue.advt_name || this.advtcommrecptform.get('advtname')?.value,
        DS_ISSUENAME: formValue.DS_ISSUENAME,
        DS_ISSUEDATE: formValue.DS_ISSUEDATE,
        net_amount: netAmount,
        pending_amt: formValue.pending_amt || 0,
        rcv_amt: formValue.rcv_amt || 0,
        commissionPercentage: formValue.commissionPercentage || 15,
        commissionAmount: commissionAmount,
        com_paid_date: null,
        com_amt: 0,
        unpaid_commission: commissionAmount,
        selected_amount: netAmount,
        isSelected: true,
        isManualEntry: true
      });
    }

    return manualEntryDataArray;
  }

  onManualEntryCheckboxChange(event: any): void {
    this.advtcommrecptform.patchValue({
      seamt: this.getGrandTotal('selectedAmount')
    });
  }

  // clearManualEntry(index: number): void {
  //   const formGroup = this.manualEntries.at(index) as FormGroup;
  //   formGroup.reset({
  //     commissionPercentage: this.comm_percentage || 15,
  //     isSelected: false
  //   });
  //   this.calculateTdsAmount();
  //   this.calculateBalanceAmount();
  // }

  clearManualEntry(index: number): void {
    const formGroup = this.manualEntries.at(index) as FormGroup;
    formGroup.reset({
      advt_invoice_no: '',
      advt_invoice_date: '',
      advt_name: '',
      DS_ISSUENAME: '',
      DS_ISSUEDATE: '',
      net_amount: 0,
      pending_amt: 0,
      rcv_amt: 0,
      commissionPercentage: this.comm_percentage || 15,
      isSelected: false
    });
    this.calculateTdsAmount();
    this.calculateBalanceAmount();
    this.advtcommrecptform.patchValue({
      seamt: this.getGrandTotal('selectedAmount')
    });
  }

  clearAllManualEntries(): void {
    while (this.manualEntries.length > 1) {
      this.manualEntries.removeAt(this.manualEntries.length - 1);
    }
    this.clearManualEntry(0);
  }

  updateAdvt() {
    let data = {
      old_advt_name: this.old_name,
      id: this.advt_id1,
      name: this.ionicForm.get('name').value,
      ownername: this.ionicForm.get('ownername').value,
      email: this.ionicForm.get('email').value,
      address: this.ionicForm.get('address').value,
      country: this.ionicForm.get('country').value,
      state: this.ionicForm.get('state').value,
      taluka: this.ionicForm.get('taluka').value,
      district: this.ionicForm.get('district').value,
      mobileNumber: this.ionicForm.get('mobileNumber').value,
      pincode: this.ionicForm.get('pincode').value,
      advtType: this.ionicForm.get('advtType').value,
      e_advt_name: this.ionicForm.get('e_advt_name').value,
      e_district: this.ionicForm.get('e_district').value,
      dob: this.ionicForm.get('dob').value,
      companyRegistration: this.ionicForm.get('companyRegistration').value,
      gstno: this.ionicForm.get('gstno').value,
      rep_name: this.ionicForm.get('rep_name').value,
      rep_mobile_no: this.ionicForm.get('rep_mobile_no').value,
      landline_no: this.ionicForm.get('landline_no').value,
      instruction: this.ionicForm.get('instruction').value,
      receiptdate: "",
      receiptno: "",
    };

    // console.log('update data', data);
    this.service.updateAdvtPerson(data).subscribe((res) => {
      window.alert('Advertiser updated successfully...');
      this.advtshow = false;
      this.ngOnInit();
    });
  }

  advtCancel() {
    if (this.advt_id1 > 0) {
      if (
        window.confirm(
          'This Operation is no reversable. Do you want to proceed!'
        )
      ) {
        this.service.cancelAdvt(this.advt_id1).subscribe((data) => {
          console.log(data);
          window.alert('Advertiser cancel successfully...');
          this.ngOnInit();
        });
      }
    } else {
      window.alert('Please select the Advertiser..');
    }
    this.ngOnInit();
  }

  saveContract() {
    if (this.advt_id1 > 0) {
      let data = {
        advt_id: this.advt_id1,
        contractno: this.contractForm.get('contractno').value,
        contractdate: this.contractForm.get('contractdate').value
          ? formatDate(
            this.contractForm.get('contractdate').value,
            'yyyy-MM-dd',
            'en-IN',
            'GMT+0530'
          )
          : '',
        repname: this.contractForm.get('repname').value,
        offrepname: this.contractForm.get('offrepname').value,
        advtname: this.contractForm.get('advtname').value,
        priviousbal: this.contractForm.get('priviousbal').value,
        contractamt: this.contractForm.get('contractamt').value,
        discountamt: this.contractForm.get('discountamt').value,
        gstie: this.contractForm.get('gstie').value,
        netamt: this.contractForm.get('netamt').value,
        netgstprice: this.contractForm.get('netgstprice').value,
        nettotal: this.contractForm.get('nettotal').value,
        subCategory: this.contractForm.get('subCategory').value,
        contractfromdate: this.contractForm.get('contractfromdate').value
          ? formatDate(
            this.contractForm.get('contractfromdate').value,
            'yyyy-MM-dd',
            'en-IN',
            'GMT+0530'
          )
          : '',
        contracttodate: this.contractForm.get('contracttodate').value
          ? formatDate(
            this.contractForm.get('contracttodate').value,
            'yyyy-MM-dd',
            'en-IN',
            'GMT+0530'
          )
          : '',
        bookingadvtamt: this.contractForm.get('bookingadvtamt').value,
        balamt: this.contractForm.get('balamt').value,
        instruction: this.contractForm.get('instruction').value,
      };

      // console.log('contractForm data', data);

      this.service.insertContractDetails(data).subscribe((res) => {
        window.alert('Contract Added Successfully...');
        this.ngOnInit();
      });
    } else {
      window.alert('Please select the Advertiser..');
    }
  }



  updateContract() {
    let data = {
      contract_id: this.contract_id,
      advt_id: this.advt_id1,
      contractno: this.contractForm.get('contractno').value,
      contractdate: this.contractForm.get('contractdate').value
        ? formatDate(
          this.contractForm.get('contractdate').value,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
        : '',
      repname: this.contractForm.get('repname').value,
      offrepname: this.contractForm.get('offrepname').value,
      advtname: this.contractForm.get('advtname').value,
      priviousbal: this.contractForm.get('priviousbal').value,
      contractamt: this.contractForm.get('contractamt').value,
      discountamt: this.contractForm.get('discountamt').value,
      gstie: this.contractForm.get('gstie').value,
      netamt: this.contractForm.get('netamt').value,
      netgstprice: this.contractForm.get('netgstprice').value,
      nettotal: this.contractForm.get('nettotal').value,
      subCategory: this.contractForm.get('subCategory').value,
      contractfromdate: this.contractForm.get('contractfromdate').value
        ? formatDate(
          this.contractForm.get('contractfromdate').value,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
        : '',
      contracttodate: this.contractForm.get('contracttodate').value
        ? formatDate(
          this.contractForm.get('contracttodate').value,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
        : '',
      bookingadvtamt: this.contractForm.get('bookingadvtamt').value,
      balamt: this.contractForm.get('balamt').value,
      instruction: this.contractForm.get('instruction').value,
    };

    const req: any = {
      "rep_name": this.repName,
      "issue_name": ""
    }

    // console.log('updateContract data', data);
    this.service.updateContractDetails(data).subscribe((res) => {
      window.alert('Contract Details Updated Successfully...');
      this.contractshow = false;
      this.advtshow = false;
      this.ngOnInit();
    });
  }

  cancelContract() {
    if (this.contract_id > 0) {
      if (
        window.confirm(
          'This Operation is no reversable. Do you want to proceed!'
        )
      ) {
        this.service
          .cancelContractDetails(this.contract_id)
          .subscribe((data) => {
            // console.log(data);
            window.alert('Contract cancel successfully...');
            this.ngOnInit();
          });
      }
    } else {
      window.alert('Please select the Contract..');
    }
  }

  getAdvtMagDetails() {
    this.advt_mag_name_details = [];
    this.stateGroups = [];
    let abc;
    this.service.getAdvtMagNames().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        // console.log(data[index]);
        this.advt_mag_name_details.push({
          id: data[index]['id'],
          is_active: data[index]['is_active'],
          issue_name: data[index]['issue_name'],
          category: data[index]['category'],
          publishing_date: data[index]['publishing_date'].split(','),
        });

        if (index == 0) {
          // console.log(
          //   data.filter((a) => a.category == data[index]['category'])
          // );
        }
      }

      // console.log('Issue/Grantha || stategroup', this.stateGroups);
      //this.advt_mag_name_details = data
    });
  } //end of getAdvtMagDetails

  getPincode(event) {
    if (this.ionicForm.get('pincode').valid) {
      // console.log(this.ionicForm.get('pincode').value);
      this.service
        .getPincodeData(parseInt(this.ionicForm.get('pincode').value))
        .subscribe((data) => {
          this.getCountry({ value: data[0]['country_name'] });
          setTimeout(() => {
            this.getState({ value: data[0]['state_name'] });
          }, 100);
          setTimeout(() => {
            this.getDistricts({ value: data[0]['district_name'] });
          }, 500);
          this.ionicForm.get('country').setValue(data[0]['country_name']);
          this.ionicForm.get('state').setValue(data[0]['state_name']);
          this.ionicForm.get('district').setValue(data[0]['district_name']);
          setTimeout(() => {
            this.ionicForm.get('taluka').setValue(data[0]['taluka_name']);
          }, 500);
        });
    }
  } //getPincode

  getCountry(event) {
    // console.log(event);
    // console.log(event.value);
    let country = this.countries.find((a) => a.country_name == event.value);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
        // console.log(this.states);
      });
    } else {
    }
  } //getcountry

  showigst = false;
  getState(event) {
    // console.log(event);
    // console.log(event.value);
    // this.selectedState = this.states['state_id'];
    let state = this.states.find((a) => a.state_name == event.value);
    // console.log(state);
    // console.log(this.states);
    if (state != undefined) {
      if (
        state.state_name != 'Maharashtra' ||
        state.state_name != 'महाराष्ट्र'
      ) {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service
        .getDistrict(parseInt(state['state_id']))
        .subscribe((data) => {
          this.cities = data;
          this.selectedCity = this.cities['district_name'];
          // console.log(this.cities);
        });
    } else {
    }
  } //get state

  getDistricts(event) {
    console.log(event.value);
    this.selectedCity = this.cities['district_id'];
    let district = this.cities.find((a) => a.district_name == event.value);
    if (district != undefined) {

      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        this.selectedTaluka = this.talukas['taluka_name'];
      });
    }
  }

  validmobile = false;
  validemail = false;
  validdob = false;
  validateMobile(event) {
    if (this.ionicForm.get('mobileNumber').valid) {
      this.validmobile = true;
    } else {
      this.validmobile = false;
    }
  }

  validateEmail(event) {
    if (this.ionicForm.get('email').valid) {
      this.validemail = true;
    } else {
      this.validemail = false;
    }
  }

  validatedob(event) {
    this.ionicForm
      .get('dob')
      .setValue(
        formatDate(
          new Date(event.target.value),
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
      );
    if (this.ionicForm.get('dob').valid) {
      this.validdob = true;
    } else {
      this.validdob = false;
    }
  }
  searchAdvtName2() {
    console.log("nice");

  }

  getallcontarctdetails() {
    this.service.getAllContractDetails().subscribe((res) => {
      // console.log(res);
      this.contractData = Array.isArray(res) ? res : res.data || [];
      this.getContractDetails();
      console.log(res, "off rep");
    });
  }

  getContractDetails() {
    debugger
    for (
      let index = 0;
      index < Object.keys(this.contractData).length;
      index++
    ) {
      this.contractRepName.push({
        name: this.contractData[index]['rep_name'],
      });
      this.contractOffRepName.push({
        name: this.contractData[index]['off_rep_name'],
      });
      this.contractAdvtName.push({
        name: this.contractData[index]['advt_name'],
      });
    }

    this.contractRepName = this.uniqueid(this.contractRepName, (a) => a.name);
    this.contractOffRepName = this.uniqueid(
      this.contractOffRepName,
      (a) => a.name
    );
    this.contractAdvtName = this.uniqueid(this.contractAdvtName, (a) => a.name);
  }

  dataforreceipt() {
    this.service.dataforrec().subscribe((data: any) => {
      console.log("tow receipt data=", data);
      this.data_for_two_receipt = (data as any);;
      // this.ngOnInit();
    });
  }
  getNewAdvtName() {
    this.service.getNewAdvtName().subscribe((data: any) => {
      console.log("new advt receipt data=", data);
      this.newadvtname = (data as any);;
      // this.ngOnInit();
    });
  }

  getNewRepList() {
    this.service.getNewRepList().subscribe((data: any) => {
      console.log("ADVT new list rep Data=", data);
      this.advtnewreplistForm = (data as any);;
      // this.ngOnInit();
    });
  }





  withoutpagenopatrak() {
    debugger
    const req = {
      issue_date: this.advtNamesIssueDates,
      issueName: this.issueName,
      issue_name: this.advtNames
    };

    this.service.withoutpagenopatrak(req).subscribe((data: any) => {
      console.log("prasiddhi ptrak without number", data);
      this.PPwithoutnumber = (data as any);;
      // this.ngOnInit();
      this.getData1()
    });
  }
  PPwithoutnumber1: any
  p: number = 1; // Current page number, starts from 1
  itemsPerPage: number = 10;
  getData1() {
    // Call your data service to get data
    this.PPwithoutnumber1 = this.PPwithoutnumber; // Assign response data to your data array
    this.setPage(1); // Set the initial page

  }

  setPage(page: number) {
    // Calculate start and end index of items for the current page
    let startIndex = (page - 1) * this.itemsPerPage;
    let endIndex = Math.min(startIndex + this.itemsPerPage - 1, this.PPwithoutnumber.length - 1);

    // Extract items for the current page
    this.PPwithoutnumber1 = this.PPwithoutnumber.slice(startIndex, endIndex + 1);
    this.p = page; // Update current page number
    console.log("pagination", this.p)
  }

  getNewNameList() {
    this.service.getNewNameList().subscribe((data: any) => {
      console.log("ADVT new list name Data=", data);
      this.advtnewNewlistForm = (data as any);;
      // this.ngOnInit();
    });
  }
  // getCreditNoteMain(req1:any) {
  //   this.service.getCreditNoteMain(req1).subscribe((data:any) => {
  //      console.log("ADVT new Credit name Data=",data);
  //     this.advtCreditNote = (data as any);;
  //     // this.ngOnInit();
  //   });
  // }


  getAdvtNames(event) {
    if (event.target.value.length > 2) {
      this.service.getAdvtNames(event.target.value).subscribe((res) => {
        this.advt_names = res;
        // console.log(res);
      });
    }
  }

  getAdvtRepNames(event) {
    if (event.target.value.length > 2) {
      this.service.getAdvtRepNames(event.target.value).subscribe((res) => {
        this.rep_names = res;
        // console.log(res);
      });
    }
  }




  issueName;
  advtSize;
  advtsizebyCategory;
  getFilterMagPublishDates = ['10-10-2021', ''];
  getMagIssueDatesandNames;
  filterdMagIssueDatesandNames = [];

  getIssues(e) {
    // console.log(e);
    this.issueName = e.value;
    this.percentage = this.advtCategorylist.find(issue => issue.category === e.value).percentage;
    // console.log('jgfdfgh', this.issueName);
    debugger
    this.service.getAdvtSizeByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    // console.log('hi', e.option.group.label);
    this.rangeRegistration.reset();
    this.cust_mobile_filter = '';
    this.rep_name = '';
    // console.log(
    //   'advt_mag_name_details',
    //   this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    // );
    // this.getFilterMagPublishDates = this.advt_mag_name_details.filter(
    //   (a) => a.issue_name == this.issueName
    // )[0]['publishing_date'];
    // console.log(this.getFilterMagPublishDates);
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      // console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
      for (
        let index = 0;
        index < Object.keys(this.getMagIssueDatesandNames).length;
        index++
      ) {
        this.filterdMagIssueDatesandNames.push({
          value: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )},${this.getMagIssueDatesandNames[index]['issueName']},${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
          data: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )} ${this.getMagIssueDatesandNames[index]['issueName']} ${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
        });
      }
      // console.log(
      //   'filterdMagIssueDatesandNames:',
      //   this.filterdMagIssueDatesandNames
      // );
    });

    this.issueGranthName = this.issueName;

    this.filteredOptions5 = this.issueForm.get('issuedates').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.data)),
      map((data) =>
        data ? this._filter1(data) : this.filterdMagIssueDatesandNames.slice()
      )
    );
  }


  showSubCategory(): boolean {
    const selectedIssue = this.issueForm.get('issue')?.value;
    return selectedIssue === 'नियिमत अंक';
  }

  getAdvtSize(e) {


    debugger
    // console.log(e);
    this.advtSize = e.value.Advt_size;
    this.advtSizeId = e.value.id;
  }
  icount: number = 0;
  addcate(e) {

    // this.advtSize = e.value;
    const data: any = {
      "issue_name": this.issueForm.value.issue,
      "issue_date": this.issueForm.value.issuedates,
    }
    // console.log(e);

    this.service.getAdvtcatsize(data).subscribe((res) => {
      // console.log(res);

      this.advtcatsize = (res as any);;
    });

  }

  getDates;
  stringdates;
  issueNameForRegReport: any = ""
  iisueDateFroRegReport: any = ""
  index: number = 0
  // getAdvtDates(e) {
  //   if (e.value[0] == 'ALL') {
  //     this.getDates = e.value;
  //     return
  //   }
  //   while (this.index < e.value.length) {
  //     if (this.index < 2) {
  //       let obj = this.getMagIssueDatesandNames.filter((x: any) => x.id == e.value[this.index]);
  //       if (this.issueNameForRegReport == "") {
  //         this.issueNameForRegReport = obj[0].issueName;
  //       } else {
  //         this.issueNameForRegReport = this.issueNameForRegReport + "," + obj[0].issueName;

  //       }
  //     }
  //     this.index++;
  //   }

  //   this.getDates = e.value;
  //   // this.getDates = this.getDates.filter((a) => a != 'all');
  //   // console.log('getDates', this.getDates);
  //   this.stringdates = this.getDates.toString();
  //   this.issueDates = this.stringdates;
  //   this.issueDates1 = this.stringdates.split(',');

  //   const splitValues = this.stringdates.split(',');
  //   this.issueDates1 = [];

  //   for (let i = 0; i < splitValues.length; i += 4) {
  //     const issueDate = splitValues[i]?.trim();      // 0
  //     const issueName = splitValues[i + 1]?.trim();  // 1
  //     const someDate = splitValues[i + 2]?.trim();   // 2 (not used, but kept if needed)
  //     const rawId = splitValues[i + 3]?.trim();      // 3 → "-559"

  //     if (issueDate && issueName && rawId) {
  //       const id = Math.abs(parseInt(rawId)); // removes "-" sign

  //       this.issueDates1.push({
  //         issueDate: issueDate,
  //         issueName: issueName,
  //         id: id
  //       });
  //     }
  //   }
  //   debugger;
  //   this.getMagIssueDatesandNames.forEach(element => {
  //     debugger
  //     if (parseInt(this.issueDates1[0].id) == parseInt(element.id)) {
  //       this.newissuedatepp = element.issueName
  //       this.issuedatespp = element.issueDate
  //     }
  //   });

  //   console.log(this.newissuedatepp, "issuename")
  //   console.log(this.issuedatespp, "issuedate")

  //   // this.getMagIssueDatesandNames1.forEach(element => {
  //   //   debugger
  //   //   this.issueDates1.forEach(element1 => {
  //   //     debugger
  //   //     if (element.id === element1.id) {
  //   //     element.id == element1.id
  //   //     this.newissuedatepp = element.issueName
  //   //     this.issuedatespp = element.issueDate
  //   //     }
  //   //   });
  //   // });
  //   // console.log(this.newissuedatepp, "issuename")
  //   // console.log(this.issuedatespp, "issuedate")
  // }

  getAdvtDates(e) {
    if (e.value[0] == 'ALL') {
      this.getDates = e.value;
      return
    }
    this.getDates = e.value;
    // this.getDates = this.getDates.filter((a) => a != 'all');
    // console.log('getDates', this.getDates);
    this.stringdates = this.getDates.toString();
    this.issueDates = this.stringdates;
    this.issueDates1 = this.stringdates.split(',');

    const splitValues = this.stringdates.split(',');
    this.issueDates1 = [];

    for (let i = 0; i < splitValues.length; i += 4) {
      const issueDate = splitValues[i]?.trim();      // 0
      const issueName = splitValues[i + 1]?.trim();  // 1
      const someDate = splitValues[i + 2]?.trim();   // 2 (not used, but kept if needed)
      const rawId = splitValues[i + 3]?.trim();      // 3 → "-559"

      if (issueDate && issueName && rawId) {
        const id = Math.abs(parseInt(rawId)); // removes "-" sign

        this.issueDates1.push({
          issueDate: issueDate,
          issueName: issueName,
          id: id
        });
      }
    }
    debugger;
    this.getMagIssueDatesandNames.forEach(element => {
      debugger
      if (parseInt(this.issueDates1[0].id) == parseInt(element.id)) {
        this.newissuedatepp = element.issueName
        this.issuedatespp = element.issueDate
      }
    });
    console.log(this.newissuedatepp, "issuename")
    console.log(this.issuedatespp, "issuedate")

    // this.getMagIssueDatesandNames1.forEach(element => {
    //   debugger
    //   this.issueDates1.forEach(element1 => {
    //     debugger
    //     if (element.id === element1.id) {
    //     element.id == element1.id
    //     this.newissuedatepp = element.issueName
    //     this.issuedatespp = element.issueDate
    //     }
    //   });
    // });
    // console.log(this.newissuedatepp, "issuename")
    // console.log(this.issuedatespp, "issuedate")
  }
  // getAdvtDates1(e) {
  //   if (e.value[0] == 'ALL') {
  //     this.getDates = e.value;
  //     return
  //   }
  //   this.getDates = e.value;
  //   this.issueDates1 = [];
  //   this.getMagIssueDatesandNames.forEach(element => {
  //     debugger
  //     if (parseInt(this.getDates[0]) == parseInt(element.id)) {
  //       this.newissuedatepp = element.issueName
  //       this.issuedatespp = element.issueDate
  //       this.stringdates = element.issueDate;
  //       this.issueDates = element.issueDate;
  //       this.issueDates1 = element.issueDate;
  //     }
  //   });
  //   console.log(this.newissuedatepp, "issuename")
  //   console.log(this.issuedatespp, "issuedate")

  //   // this.getMagIssueDatesandNames1.forEach(element => {
  //   //   debugger
  //   //   this.issueDates1.forEach(element1 => {
  //   //     debugger
  //   //     if (element.id === element1.id) {
  //   //     element.id == element1.id
  //   //     this.newissuedatepp = element.issueName
  //   //     this.issuedatespp = element.issueDate
  //   //     }
  //   //   });
  //   // });
  //   // console.log(this.newissuedatepp, "issuename")
  //   // console.log(this.issuedatespp, "issuedate")
  // }



 getAdvtDatesBusiness(e) {
    if (e.value[0] == 'ALL') {
      this.getDates = e.value;
      return;
    }

    this.getDates = e.value;
    this.issueDates1 = [];
    this.newissuedatepp = [];  // Array for multiple issue names
    this.issuedatespp = null;  // Single value for date (since same for all)

    this.getMagIssueDatesandNames.forEach(element => {
      // Check if the element.id matches ANY of the selected dates
      if (this.getDates.includes(element.id.toString())) {
        this.newissuedatepp.push(element.issueName);

        // Store date only once (since it's same for all)
        if (!this.issuedatespp) {
          this.issuedatespp = element.issueDate;
          this.stringdates = element.issueDate;
          this.issueDates = element.issueDate;
        }

        // Collect all issue dates
        if (Array.isArray(element.issueDate)) {
          this.issueDates1.push(...element.issueDate);
        } else {
          this.issueDates1.push(element.issueDate);
        }
      }
    });

    // Convert array to comma-separated string for display
    this.newissuedatepp = this.newissuedatepp.join(',');

    console.log(this.newissuedatepp, "issue names");
    console.log(this.issuedatespp, "issue date");
  }




  getAdvtDates1(e) {
    if (e.value[0] == 'ALL') {
      this.getDates = e.value;
      return;
    }

    this.getDates = e.value;
    this.issueDates1 = [];
    this.newissuedatepp = [];  // Array for multiple issue names
    this.issuedatespp = null;  // Single value for date (since same for all)

    this.getMagIssueDatesandNames.forEach(element => {
      // Check if the element.id matches ANY of the selected dates
      if (this.getDates.includes(element.id.toString())) {
        this.newissuedatepp.push(element.issueName);

        // Store date only once (since it's same for all)
        if (!this.issuedatespp) {
          this.issuedatespp = element.issueDate;
          this.stringdates = element.issueDate;
          this.issueDates = element.issueDate;
        }

        // Collect all issue dates
        if (Array.isArray(element.issueDate)) {
          this.issueDates1.push(...element.issueDate);
        } else {
          this.issueDates1.push(element.issueDate);
        }
      }
    });

    // Convert array to comma-separated string for display
    this.newissuedatepp = this.newissuedatepp.join(',');

    console.log(this.newissuedatepp, "issue names");
    console.log(this.issuedatespp, "issue date");
  }

  



  getAdvtDatesPrasiddhiPatrak(e) {
    if (e.value[0] == 'ALL') {
      this.getDates = e.value;
      return
    }
    this.getDates = e.value;

    this.issueDates1 = [];

    debugger;
    this.getMagIssueDatesandNames.forEach(element => {
      debugger
      if (parseInt(this.getDates[0]) == parseInt(element.id)) {
        this.newissuedatepp = element.issueName
        this.issuedatespp = element.issueDate
      }
    });
    console.log(this.newissuedatepp, "issuename")
    console.log(this.issuedatespp, "issuedate")

    // this.getMagIssueDatesandNames1.forEach(element => {
    //   debugger
    //   this.issueDates1.forEach(element1 => {
    //     debugger
    //     if (element.id === element1.id) {
    //     element.id == element1.id
    //     this.newissuedatepp = element.issueName
    //     this.issuedatespp = element.issueDate
    //     }
    //   });
    // });
    // console.log(this.newissuedatepp, "issuename")
    // console.log(this.issuedatespp, "issuedate")
  }

  


  getDatess;
  stringdatess;
  getAdvtPaymentDates(e) {
    if (e.value[0] == 'ALL') {
      this.getDatess = e.value;
      return
    }
    this.getDatess = e.value;

    this.stringdatess = this.getDatess.toString();
    this.issueDates = this.stringdatess;
    this.issueDates1 = this.stringdatess.split(',');

    this.getMagIssueDatesandNames.forEach(element => {
      if (this.issueDates1[0] == element.id) {
        this.newissuedatepp = element.issueName
        this.issuedatespp = element.issueDate
      }
    });
    console.log(this.newissuedatepp, "issuename")
    console.log(this.issuedatespp, "issuedate")

  }



  s_no;
  getAnkSerialNo(issuedate) {
    // console.log(issuedate);
    this.service.getNextIssueSerialNo(issuedate).subscribe((res) => {
      // console.log(res);
      if (Object.keys(res).length > 0) {
        this.s_no = parseInt(res[0]['ank_no']) + 1;
      } else {
        this.s_no = 1;
      }
      // console.log(this.s_no);
    });
  }

  // addAdvt() {
  //   debugger;

  //   if (this.AdvtDetails.length == 0) {
  //     if (this.advtcatsize != undefined) {
  //       if (this.advtcatsize[0].advt_count == null || this.advtcatsize[0].advt_count == undefined) {
  //         this.advtplus = 1;
  //       }
  //       else {
  //         this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
  //       }
  //     } else {
  //       this.advtplus = 1;
  //     }
  //     debugger
  //     this.AdvtDetails.push({


  //       s_no: this.advtplus,
  //       issue: this.issueName,
  //       advtsize: this.issueForm.value.advtsize?.Advt_size || this.advtSize,
  //       advtdates: this.stringdates,
  //       issuedate: this.issueForm.value.issuedates,
  //       issue_name1: this.newissuedatepp,
  //       issue_date1: this.issuedatespp,
  //     });
  //     debugger;
  //   }
  //   else {
  //     if (this.issueForm.value.issue == 'नियिमत अंक') {
  //       const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

  //       if (matchingObjects.length > 0) {
  //         const lastObject = matchingObjects[matchingObjects.length - 1];
  //         this.advtplus = parseInt(lastObject.s_no, 10) + 1;
  //         console.log('Found object:', lastObject);
  //       } else {
  //         // this.advtplus = 1;
  //         if (this.advtcatsize == null || this.advtcatsize == undefined) {
  //           this.advtplus = 1;
  //         }
  //         else {
  //           this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
  //         }
  //       }
  //       console.log(this.advtcatsize, "this.advtcatsize");
  //     }

  //     else if (this.issueForm.value.issue == 'ग्रंथ') {
  //       const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

  //       if (matchingObjects.length > 0) {
  //         const lastObject = matchingObjects[matchingObjects.length - 1];
  //         this.advtplus = parseInt(lastObject.s_no, 10) + 1;
  //         console.log('Found object:', lastObject);
  //       } else {
  //         // this.advtplus = 1;
  //         if (this.advtcatsize == null || this.advtcatsize == undefined) {
  //           this.advtplus = 1;
  //         }
  //         else {
  //           this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
  //         }
  //       }
  //       console.log(this.advtcatsize, "this.advtcatsize");
  //     }
  //     else if (this.issueForm.value.issue == 'विशेषांक') {
  //       const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

  //       if (matchingObjects.length > 0) {
  //         const lastObject = matchingObjects[matchingObjects.length - 1];
  //         this.advtplus = parseInt(lastObject.s_no, 10) + 1;
  //         console.log('Found object:', lastObject);
  //       } else {
  //         // this.advtplus = 1;
  //         if (this.advtcatsize == null || this.advtcatsize == undefined) {
  //           this.advtplus = 1;
  //         }
  //         else {
  //           this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
  //         }
  //       }
  //       console.log(this.advtcatsize, "this.advtcatsize");
  //     }

  //     else if (this.issueForm.value.issue == 'प्राेग्राम') {
  //       const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

  //       if (matchingObjects.length > 0) {
  //         const lastObject = matchingObjects[matchingObjects.length - 1];
  //         this.advtplus = parseInt(lastObject.s_no, 10) + 1;
  //         console.log('Found object:', lastObject);
  //       } else {
  //         // this.advtplus = 1;
  //         if (this.advtcatsize == null || this.advtcatsize == undefined) {
  //           this.advtplus = 1;
  //         }
  //         else {
  //           this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
  //         }
  //       }
  //       console.log(this.advtcatsize, "this.advtcatsize");
  //     }

  //     this.AdvtDetails.push({
  //       s_no: this.advtplus,
  //       issue: this.issueName,
  //       advtsize: this.issueForm.value.advtsize.Advt_size,
  //       advtdates: this.stringdates,
  //       issuedate: this.issueForm.value.issuedates,
  //     });
  //   }
  // }


  addAdvt() {
    debugger;

    if (this.AdvtDetails.length == 0) {
      if (this.advtcatsize != undefined) {
        if (this.advtcatsize[0].advt_count == null || this.advtcatsize[0].advt_count == undefined) {
          this.advtplus = 1;
        }
        else {
          this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
        }
      } else {
        this.advtplus = 1;
      }
      debugger
      this.AdvtDetails.push({


        s_no: this.advtplus,
        issue: this.issueName,
        advtsize: this.issueForm.value.advtsize?.Advt_size || this.advtSize,
        advtdates: this.stringdates,
        issuedate: this.issueForm.value.issuedates,
        issue_name1: this.newissuedatepp,
        issue_date1: this.issuedatespp,
      });
      debugger;
    }
    else {
      if (this.issueForm.value.issue == 'नियिमत अंक') {
        const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

        if (matchingObjects.length > 0) {
          const lastObject = matchingObjects[matchingObjects.length - 1];
          this.advtplus = parseInt(lastObject.s_no, 10) + 1;
          console.log('Found object:', lastObject);
        } else {
          // this.advtplus = 1;
          if (this.advtcatsize == null || this.advtcatsize == undefined) {
            this.advtplus = 1;
          }
          else {
            this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
          }
        }
        console.log(this.advtcatsize, "this.advtcatsize");
      }

      else if (this.issueForm.value.issue == 'ग्रंथ') {
        const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

        if (matchingObjects.length > 0) {
          const lastObject = matchingObjects[matchingObjects.length - 1];
          this.advtplus = parseInt(lastObject.s_no, 10) + 1;
          console.log('Found object:', lastObject);
        } else {
          // this.advtplus = 1;
          if (this.advtcatsize == null || this.advtcatsize == undefined) {
            this.advtplus = 1;
          }
          else {
            this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
          }
        }
        console.log(this.advtcatsize, "this.advtcatsize");
      }
      else if (this.issueForm.value.issue == 'विशेषांक') {
        const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

        if (matchingObjects.length > 0) {
          const lastObject = matchingObjects[matchingObjects.length - 1];
          this.advtplus = parseInt(lastObject.s_no, 10) + 1;
          console.log('Found object:', lastObject);
        } else {
          // this.advtplus = 1;
          if (this.advtcatsize == null || this.advtcatsize == undefined) {
            this.advtplus = 1;
          }
          else {
            this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
          }
        }
        console.log(this.advtcatsize, "this.advtcatsize");
      }

      else if (this.issueForm.value.issue == 'प्राेग्राम') {
        const matchingObjects = this.AdvtDetails.filter(item => (item.issue === this.issueForm.value.issue) && (item.issuedate === this.issueForm.value.issuedates));

        if (matchingObjects.length > 0) {
          const lastObject = matchingObjects[matchingObjects.length - 1];
          this.advtplus = parseInt(lastObject.s_no, 10) + 1;
          console.log('Found object:', lastObject);
        } else {
          // this.advtplus = 1;
          if (this.advtcatsize == null || this.advtcatsize == undefined) {
            this.advtplus = 1;
          }
          else {
            this.advtplus = parseInt(this.advtcatsize[0].advt_count) + 1
          }
        }
        console.log(this.advtcatsize, "this.advtcatsize");
      }

      this.AdvtDetails.push({
        s_no: this.advtplus,
        issue: this.issueName,
        advtsize: this.issueForm.value.advtsize?.Advt_size || this.advtSize,
        advtdates: this.stringdates,
        issuedate: this.issueForm.value.issuedates,
        issue_name1: this.newissuedatepp,
        issue_date1: this.issuedatespp,
      });
    }
  }


  modifyAdvt() {
    debugger
    this.AdvtDetails = [];
    console.log(this.AdvtDetails);
    // this.AdvtDetails[0]['issue'] = this.issueName;
    // this.AdvtDetails[0]['advtsize'] = this.advtSize;
    // this.AdvtDetails[0]['advtdates'] = this.stringdates;
    this.AdvtDetails.push({
      s_no: this.advtplus,
      issue: this.issueName,
      advtsize: this.issueForm.value.advtsize.Advt_size,
      advtdates: this.stringdates,
      issuedate: this.issueForm.value.issuedates,
      issue_name1: this.newissuedatepp,
      issue_date1: this.issuedatespp,
    });
    //  this.addAdvt();
  }


  deleteAdvt(i) {
    if (window.confirm('Do you really want to remove ?')) {
      this.AdvtDetails.splice(i, 1);
    }
  }

  displayChequqField = false;

  getcheque(event) {
    const value = event.value;
    if (value == 'cheque') {
      this.displayChequqField = true;
    } else {
      this.displayChequqField = false;
    }
  }

  displayPartAmount = false;
  getPartPayment(event) {
    const value = event.value;
    if (value == 'Y') {
      this.displayPartAmount = true;
    } else {
      this.displayPartAmount = false;
    }
  }

  getAdvtPartPayment(event) {
    if (
      parseInt(this.issueForm.value['partAmount']) >
      parseInt(this.issueForm.value['amount'])
    ) {
      window.alert('Please enter amount less than Total Amount!');
      this.issueForm.get('partAmount').setValue(0);
    } else {
      this.issueForm
        .get('remainingAmount')
        .setValue(
          parseInt(this.issueForm.value['amount']) -
          parseInt(this.issueForm.value['partAmount'])
        );
    }
  }

  advtamount = 0;
  discount = 0;
  sgstamt = 0;
  igstamt = 0;
  totalamt = 0;
  remainingamt = 0;
  amountTobePay = 0;

  gstie = '';
  changeType(type) {
    this.gstie = type.value;
    // console.log(this.gstie);
    console.log(this.percentage);
    let state_name = this.ionicForm.get('state').value;
    if (state_name === 'Maharashtra' || state_name === 'महाराष्ट्र') {
      // console.log(state_name);
      this.showigst = false;
    } else {
      this.showigst = true;
    }
    this.getAdvtDiscount();
  }

  getAdvtDiscount() {
    debugger
    this.advtamount = parseInt(this.issueForm.get('advtamout').value);
    if (this.advtamount != 0) {
      // if(this.ionicForm.get('gstie').value)
      if (this.issueForm.get('advtdiscount').value != '') {
        this.discount = parseInt(this.issueForm.get('advtdiscount').value);
        // console.log(this.discount);
        if (this.gstie === 'gstInclude') {
          let taxableAmount = this.advtamount - (this.advtamount * (this.discount / 100));
          let gstAmount = Math.round((taxableAmount * Number(this.percentage)) / (100 + Number(this.percentage)));

          debugger
          if (this.showigst) {
            this.igstamt = (gstAmount);
            this.issueForm.get('igstamount').setValue(this.igstamt);

            this.totalamt = Math.round(taxableAmount - this.igstamt);
            this.issueForm.get('amount').setValue(taxableAmount);
            this.issueForm.get('totalamt').setValue(Math.round(this.totalamt));
          } else {
            this.sgstamt = Math.round(gstAmount / 2); // Split GST for SGST and CGST
            // this.sgstamt = this.sgstamt; 

            this.issueForm.get('gstamount').setValue(this.sgstamt * 2); // Set total GST
            this.totalamt = Math.round(taxableAmount - (this.sgstamt * 2));
            let taxAmt = Number(this.totalamt) + Number(this.sgstamt * 2);

            this.issueForm.get('amount').setValue(taxAmt);
            this.issueForm.get('totalamt').setValue(this.totalamt);
          }
        }
        else if (this.gstie == 'gstExclude') {
          debugger;
          // Calculate taxable amount after discount
          let taxableAmount = Math.round(this.advtamount - (this.advtamount * (this.discount / 100)));

          // Calculate GST amount based on the taxable amount and GST percentage
          let gstAmount = Math.round((taxableAmount * Number(this.percentage)) / 100); // Use Math.round() for better accuracy

          if (this.showigst) {
            // If IGST is applicable, assign the full GST amount to IGST
            this.igstamt = gstAmount;
            this.issueForm.get('igstamount').setValue(this.igstamt);
            this.totalamt = Math.round(taxableAmount + this.igstamt);
          } else {
            // If SGST and CGST are applicable, split the GST amount equally
            this.sgstamt = Number(gstAmount / 2); // 2.5% SGST
            // this.cgstamt = Math.round(gstAmount / 2); // 2.5% CGST
            this.issueForm.get('gstamount').setValue(this.sgstamt * 2); // Set SGST value
            // If you have a separate field for CGST, set it as well
            // this.issueForm.get('cgstamount').setValue(this.cgstamt);
            this.totalamt = Math.round(taxableAmount + this.sgstamt + this.sgstamt);
          }

          // Calculate the total amount including GST
          // this.totalamt = Math.round(taxableAmount + this.sgstamt + this.sgstamt + this.igstamt);

          // Update form values
          this.issueForm.get('amount').setValue(this.totalamt); // Total amount including GST
          this.issueForm.get('totalamt').setValue(taxableAmount); // Taxable amount excluding GST
        }

      } else {
        this.discount = 0;
        // console.log(this.discount);
        if (this.gstie === 'gstInclude') {
          let taxableAmount = this.advtamount - (this.advtamount * (this.discount / 100));
          let gstAmount = (taxableAmount * Number(this.percentage)) / (100 + Number(this.percentage));

          if (this.showigst) {
            this.igstamt = Math.round(gstAmount);
            this.issueForm.get('igstamount').setValue(this.igstamt);

            this.totalamt = Math.round(taxableAmount - this.igstamt);
            this.issueForm.get('amount').setValue(Math.round(taxableAmount));
            this.issueForm.get('totalamt').setValue(this.totalamt);
          } else {
            // Don't round the gstAmount before dividing
            this.sgstamt = Math.round(gstAmount / 2);
            let cgstamt = Math.round(gstAmount / 2);

            let totalGst = this.sgstamt + cgstamt;
            this.issueForm.get('gstamount').setValue(totalGst);

            this.totalamt = Math.round(taxableAmount - totalGst);
            let taxAmt = this.totalamt + totalGst;

            this.issueForm.get('amount').setValue(taxAmt);
            this.issueForm.get('totalamt').setValue(this.totalamt);
          }
        }
        if (this.gstie == 'gstExclude') {
          debugger;
          let taxableAmount = Math.round(this.advtamount - (this.advtamount * (this.discount / 100))); // Taxable amount after discount
          let gstAmount = Math.round((taxableAmount * Number(this.percentage)) / 100); // Correct total GST with floor()

          if (this.showigst) {
            this.igstamt = gstAmount; // 5% IGST
            this.issueForm.get('igstamount').setValue(this.igstamt);
            this.totalamt = taxableAmount + Number(this.igstamt);
          } else {
            this.sgstamt = Number(gstAmount / 2); // 2.5% SGST
            // this.cgstamt = Math.floor(gstAmount / 2); // 2.5% CGST
            this.issueForm.get('gstamount').setValue(this.sgstamt * 2);
            // this.issueForm.get('gstamount').setValue(gstAmount); // Add both SGST & CGST
            this.totalamt = Math.round(taxableAmount + Number(this.sgstamt) + Number(this.sgstamt));
          }

          // Correct total amount with full GST
          this.issueForm.get('amount').setValue(this.totalamt);
          this.issueForm.get('totalamt').setValue(taxableAmount); // Store taxable amount separately
        }



      }
    } else {
      this.issueForm.get('gstamount').setValue(this.advtamount);
      this.issueForm.get('amount').setValue(this.advtamount);
      this.issueForm
        .get('totalamt')
        .setValue(this.advtamount - this.advtamount * (this.discount / 100));
    }
  }

  


  openModal() { }
  getSelectedRepId;
  getSelectedRep;
  repCommAmt;
  SelectRepresentative(option) {
    // console.log(option);
    this.getSelectedRepId = option['id'];
    this.getSelectedRep = this.getAllRepList.find(
      (a) => a['id'] == parseInt(this.getSelectedRepId)
    );
    // console.log(this.getSelectedRep);
    // this.repCommAmt = parseInt(this.getSelectedRep['rep_advt_comm']);
    let data = this.issue_seller_name.find((a) => a['id'] == option['id']);
    // console.log('data', data);
    this.ionicForm.get('rep_mobile_no').setValue(data['mob_no']);
  }

  setAdvtSubData(repname) {
    this.issueForm.get('repname').setValue(repname);
    let offrepname = this.filterRepresentative({ name: repname });
    if (offrepname) {
      this.issueForm.get('rep_mobile_no').setValue(offrepname[0]['rep_mob_no']);
      // console.log(offrepname);
      this.issueForm.get('offrepname').setValue(offrepname[0]['off_rep_name']);
    }
    this.contractForm
      .get('advtname')
      .setValue(this.ionicForm.get('name').value);
  }

  selected_rep_name1(event, option) {
    if (event.isUserInput) {
      let data = this.filterRepresentative(option);
      this.contractForm.get('offrepname').setValue(data[0]['off_rep_name']);
      this.setAdvtSubData(data[0]['rep_name']);
    }
  }

  filterRepresentative(option) {
    return this.advtwisereplist.filter((a) => a['rep_name'] == option['name']);
  }

  selected_rep_name(event, option) {
    if (event.isUserInput) {
      let data = this.filterRepresentative(option);
      this.issueForm.get('rep_mobile_no').setValue(data[0]['rep_mob_no']);
      this.issueForm.get('offrepname').setValue(data[0]['off_rep_name']);
    }
    this.isValid();
  }

  saveAdvtSubDetails() {


    this.isButtonDisabled = true;


    this.service.setnewbookingnumber().subscribe((res) => {
      this.latestbookingnumber = (res as any);;

      console.log(this.latestbookingnumber, "latestbookingnumber")
      if (this.advt_id1 > 0) {
        if (this.imageChange) {
          this.uploader.uploadAll();
        }

        setTimeout(() => {
          let data = {
            advt_id: this.advt_id1,
            contract_no: this.contractshow ? this.contract_no : '',
            bookingdate: this.issueForm.get('bookingdate').value
              ? formatDate(
                this.issueForm.get('bookingdate').value,
                'yyyy-MM-dd',
                'en-IN',
                'GMT+0530'
              )
              : '',
            bookingno: this.latestbookingnumber.new_booking_no,
            advtname: this.issueForm.get('advtname').value,
            custname: this.issueForm.get('custname').value,
            repname: this.issueForm.get('repname').value,
            rep_mobile_no: this.issueForm.get('rep_mobile_no').value,
            offrepname: this.issueForm.get('offrepname').value,
            ro_number: this.issueForm.get('ro_number').value,
            ro_dates: this.issueForm.get('ro_dates').value
              ? formatDate(
                this.issueForm.get('ro_dates').value,
                'yyyy-MM-dd',
                'en-IN',
                'GMT+0530'
              )
              : '',
            instruction: this.issueForm.get('instruction').value,
            otherdetls: this.issueForm.get('otherdetls').value,
            pageno: this.issueForm.get('pageno').value,
            advtamout: this.issueForm.get('advtamout').value,
            advtdiscount: this.issueForm.get('advtdiscount').value,
            gstie: this.gstie,
            cgst: this.sgstamt,
            sgst: this.sgstamt,
            igst: this.igstamt,
            totalamt: this.issueForm.get('totalamt').value,
            amount: this.issueForm.get('amount').value,
            ispartpayment: this.issueForm.get('ispartpayment').value,
            partAmount: this.issueForm.get('partAmount').value,
            remainingAmount: this.issueForm.get('remainingAmount').value,
            paymentmode: this.issueForm.get('paymentmode').value,
            chequeno: this.issueForm.get('checkno').value,
            subCategory: this.issueForm.get('subCategory').value,
            receiptdate: this.issueForm.get('receiptdate').value
              ? formatDate(
                this.issueForm.get('receiptdate').value,
                'yyyy-MM-dd',
                'en-IN',
                'GMT+0530'
              )
              : '',
            receiptno: this.issueForm.get('receiptno').value,
            document_name:
              this.issueForm.get('document_name').value == ''
                ? this.imgPath
                : this.issueForm.get('document_name').value,
          };

          // console.log('saveAdvtSubDetails', data);
          this.service.insertAdvtSubDetails(data).subscribe((res) => {


            for (
              let index = 0;
              index < Object.keys(this.AdvtDetails).length;
              index++
            ) {
              let newadvtdtl:any = {
                advtsizeno: this.AdvtDetails[index]['s_no'],
                s_no: this.AdvtDetails[index]['s_no'],
                issueName: this.AdvtDetails[index]['issue'],
                advtsize: this.AdvtDetails[index]['advtsize'],
                advtsizeId: this.advtSizeId,
                advt_dates: this.AdvtDetails[index]['advtdates'],
                id: res['id'],
              };
              this.service
                .insertNewadvtdetails(newadvtdtl)
                .subscribe((details) => {
                  // console.log(details);
                });
            }

            if (this.contractshow && this.contract_id > 0) {
              this.service
                .updateContractBalAmount(
                  this.contract_id,
                  this.bookingAdvtAmount +
                  parseInt(this.issueForm.get('amount').value),
                  this.contractBalAmt -
                  parseInt(this.issueForm.get('amount').value)
                )
                .subscribe((res) => {
                  console.log(res);
                });
            }

            setTimeout(() => {
              window.alert('Advertiesment Added Successfully...');
              this.contractshow = false;
              this.advtshow = false;
              this.AdvtDetails = [];
              this.advtSubDetails = [];
              // console.log(this.owner_name, this.mob_no1, this.advt_name1);
              localStorage.setItem('ownername', this.owner_name);
              localStorage.setItem('mob_no1', this.mob_no1);
              localStorage.setItem('advt_name1', this.advt_name1);
              this.ngOnInit();
              this.owner_name = localStorage.getItem('ownername');
              this.mob_no1 = localStorage.getItem('mob_no1');
              this.advt_name1 = localStorage.getItem('advt_name1');
              this.selected_name();
              localStorage.removeItem('ownername');
              localStorage.removeItem('mob_no1');
              localStorage.removeItem('advt_name1');
              this.myInputField.nativeElement.focus();
            }, 2000);
          });
        }, 1000);
      } else {
        window.alert('Please select Advertiser...');
      }

    });

  }

  updateAdvtSubDetails() {

    this.isButtonDisabled = true;

    // console.log('running fine');
    // console.log(this.issueForm.invalid);
    if (this.issueForm.get('ro_dates').value == "") {
      this.issueForm.patchValue({
        ro_dates: '0000-00-00'
      })

    }
    if (!this.issueForm.invalid) {
      // console.log('running fine 1');
      debugger;
      this.service.getAdvtcheckforudate(this.advt_sub_id).subscribe((res) => {
        // console.log(res);


        this.advtupdatestatus = (res as any);;
        console.log(this.advtupdatestatus, "status for advt update")
      });

      if (this.advtupdatestatus == 'N' || this.advtupdatestatus == null) {
        if (this.advt_sub_id > 0) {
          // console.log('running fine 2');
          // if (this.imageChange) {
          //   this.uploader.uploadAll();
          // }

          // setTimeout(() => {
          let data = {
            advt_sub_id: this.advt_sub_id,
            advt_id: this.advt_id1,
            contract_no: this.contractshow ? this.contract_no : '',
            bookingdate:
              this.issueForm.get('bookingdate').value == '0000-00-00'
                ? ''
                : formatDate(
                  this.issueForm.get('bookingdate').value,
                  'yyyy-MM-dd',
                  'en-IN',
                  'GMT+0530'
                ),
            bookingno: this.issueForm.get('bookingno').value,
            advtname: this.issueForm.get('advtname').value,
            custname: this.issueForm.get('custname').value,
            repname: this.issueForm.get('repname').value,
            rep_mobile_no: this.issueForm.get('rep_mobile_no').value,
            offrepname: this.issueForm.get('offrepname').value,
            ro_number: this.issueForm.get('ro_number').value,
            ro_dates:
              this.issueForm.get('ro_dates').value == '0000-00-00'
                ? ''
                : formatDate(
                  this.issueForm.get('ro_dates').value,
                  'yyyy-MM-dd',
                  'en-IN',
                  'GMT+0530'
                ),
            instruction: this.issueForm.get('instruction').value,
            otherdetls: this.issueForm.get('otherdetls').value,
            pageno: this.issueForm.get('pageno').value,
            advtamout: this.issueForm.get('advtamout').value,
            advtdiscount: this.issueForm.get('advtdiscount').value,
            gstie: this.gstie,
            cgst: this.sgstamt,
            sgst: this.sgstamt,
            igst: this.igstamt,
            totalamt: this.issueForm.get('totalamt').value,
            amount: this.issueForm.get('amount').value,
            ispartpayment: this.issueForm.get('ispartpayment').value,
            partAmount: this.issueForm.get('partAmount').value,
            remainingAmount: this.issueForm.get('remainingAmount').value,
            paymentmode: this.issueForm.get('paymentmode').value,
            chequeno: this.issueForm.get('checkno').value,
            subCategory: this.issueForm.get('subCategory').value,
            receiptdate:
              this.issueForm.get('receiptdate').value == '0000-00-00'
                ? ''
                : formatDate(
                  this.issueForm.get('receiptdate').value,
                  'yyyy-MM-dd',
                  'en-IN',
                  'GMT+0530'
                ),
            receiptno: this.issueForm.get('receiptno').value,
            document_name:
              this.issueForm.get('document_name').value == ''
                ? this.imgPath
                : this.issueForm.get('document_name').value,
          };

          // console.log('updateAdvtSubDetails', data);
          this.service.updateAdvtSubDetails(data).subscribe((res) => {
            debugger;
            for (
              let index = 0;
              index < Object.keys(this.AdvtDetails).length;
              index++
            ) {
              let newadvtdtl = {
                issueName: this.AdvtDetails[index]['issue'],
                advtsize: this.AdvtDetails[index]['advtsize'],
                advtsizeId: this.advtSizeId,
                advt_dates: this.AdvtDetails[index]['advtdates'],
                id: this.ds_advtId,
              };
              this.service
                .updateNewadvtdetails(newadvtdtl)
                .subscribe((details) => {
                  // console.log(details);
                });
            }

            // if (this.contractshow && this.contract_id > 0) {
            //   this.service
            //     .updateContractBalAmount(
            //       this.contract_id,
            //       this.bookingAdvtAmount +
            //         parseInt(this.issueForm.get('amount').value),
            //       this.contractBalAmt -
            //         parseInt(this.issueForm.get('amount').value)
            //     )
            //     .subscribe((res) => {
            //       console.log(res);
            //     });
            // }

            setTimeout(() => {
              window.alert('Advertiesment Updated Successfully...');
              this.contractshow = false;
              this.advtshow = false;
              this.AdvtDetails = [];
              this.advtSubDetails = [];
              // console.log(this.owner_name, this.mob_no1, this.advt_name1);
              localStorage.setItem('ownername', this.owner_name);
              localStorage.setItem('mob_no1', this.mob_no1);
              localStorage.setItem('advt_name1', this.advt_name1);
              this.ngOnInit();
              this.owner_name = localStorage.getItem('ownername');
              this.mob_no1 = localStorage.getItem('mob_no1');
              this.advt_name1 = localStorage.getItem('advt_name1');
              this.selected_name();
              localStorage.removeItem('ownername');
              localStorage.removeItem('mob_no1');
              localStorage.removeItem('advt_name1');
              this.myInputField.nativeElement.focus();
            }, 2000);
          });
          // }, 1000);
        } else {
          window.alert('Please select Advertisement Sub Details...');
        }
      } else {
        window.alert(
          'Already invoice is generated. Advt. sub details will not update.'
        );
      }
    } else {
      this.isValid();
    }
  }

  isrepValid: boolean = true;
  isValid() {
    this.isrepValid = this.issueForm.controls.repname.valid;
  }

  cancelAdvtSubDetails() {

    this.isButtonDisabled = true;

    if (this.advt_sub_id > 0) {
      if (
        window.confirm(
          'This Operation is no reversable. Do you want to proceed!'
        )
      ) {
        this.service
          .cancelAdvtSubDetails(this.advt_sub_id)
          .subscribe((data) => {
            // console.log(data);
            window.alert('Advtertiserment Sub Details cancel successfully...');
            // this.ngOnInit();
            this.ionicForm.reset();
            this.contractForm.reset();
            this.issueForm.reset();
            // this.advtSubDetails.reset();

          });
      }
    } else {
      window.alert('Please select the Advtertiserment Sub Details..');
    }
  }

  totalAmount;
  submitAdd() {
    if (this.imageChange) {
      this.uploader.uploadAll();
    }

    let newadvt = {
      custname: this.ionicForm.get('custname').value,
      name: this.ionicForm.get('name').value,
      ownername: this.ionicForm.get('ownername').value,
      email: this.ionicForm.get('email').value,
      address: this.ionicForm.get('address').value,
      country: this.ionicForm.get('country').value,
      state: this.ionicForm.get('state').value['state_name'],
      taluka: this.ionicForm.get('taluka').value,
      district: this.ionicForm.get('district').value['name'],
      mobileNumber: this.ionicForm.get('mobileNumber').value,
      paymentmode: this.ionicForm.get('paymentmode').value,
      pincode: this.ionicForm.get('pincode').value,
      advtType: this.ionicForm.get('advtType').value,
      checkno: this.ionicForm.get('checkno').value,
      dob: this.ionicForm.get('dob').value,
      companyRegistration: this.ionicForm.get('companyRegistration').value,
      gstno: this.ionicForm.get('gstno').value,
      rep_id: parseInt(this.getSelectedRepId),
      cgst: this.sgstamt,
      sgst: this.sgstamt,
      igst: this.igstamt,
      gstie: this.gstie,
      ispartpayment: 'N',
      //partAmount: this.ionicForm.get('amount').value,
      partAmount: this.ionicForm.get('partAmount').value,
      remainingAmount: this.ionicForm.get('remainingAmount').value,
      receiptdate: this.ionicForm.get('receiptdate').value,
      receiptno: this.ionicForm.get('receiptno').value,
      advtamout: this.ionicForm.get('advtamout').value,
      advtdiscount: this.ionicForm.get('advtdiscount').value,
      tapshil: this.ionicForm.get('tapshil').value,
      document_name: this.ionicForm.get('document_name').value,
      landline_no: this.ionicForm.get('landline_no').value ? null : '',
      ro_number: this.ionicForm.get('ro_number').value,
      ro_dates: this.ionicForm.get('ro_dates').value,
    };

    this.totalAmount = this.ionicForm.get('amount').value;
    let newcredit: number = 0;
    // console.log(newcredit);

    let commamt = (this.totalAmount * this.repCommAmt) / 100;
    this.insertData(newadvt, newcredit, commamt);
  }

  insertData(newadvt, newcredit, commamt) {
    this.service.insertNewadvtPerson(newadvt).subscribe((advtperson) => {
      // console.log(advtperson);
      for (
        let index = 0;
        index < Object.keys(this.AdvtDetails).length;
        index++
      ) {
        let newadvtdtl = {
          ds_custmobile: this.ionicForm.get('mobileNumber').value,
          ds_repid: parseInt(this.getSelectedRepId),
          issueName: this.AdvtDetails[index]['issue'],
          advtsize: this.AdvtDetails[index]['advtsize'],
          advt_dates: this.AdvtDetails[index]['advtdates'],
          comment: this.ionicForm.get('comment').value,
          advt_id: advtperson['id'],
        };
        this.service.insertNewadvtdetails(newadvtdtl).subscribe((details) => {
          // console.log(details);
        });
      }
      this.service
        .insertCustRepAdvt(
          parseInt(this.ionicForm.get('mobileNumber').value),
          parseInt(this.getSelectedRepId)
        )
        .subscribe((a) => {
          this.service
            .insertAdvtComissionLimit(
              parseInt(this.getSelectedRepId),
              parseInt(this.ionicForm.get('mobileNumber').value),
              commamt,
              parseInt(advtperson['id'])
            )
            .subscribe((res) => {
              // console.log(res);
              window.alert('Advertisement has been added!');
              setTimeout(() => {
                this.ionicForm.reset();
              }, 2000);
            });
        });
    });
  }

  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const selectedDate = this.advtbillForm.get('date')?.value;
    if (!selectedDate) return true;

    const selectedMonth = new Date(selectedDate).getMonth();
    const selectedYear = new Date(selectedDate).getFullYear();

    return d.getMonth() === selectedMonth && d.getFullYear() === selectedYear;
  };





  startDate_registration = '';
  enddate_registration = '';
  dateIsEnable = false;
  getChangedDateRegistration() {
    this.cust_mobile_filter = '';
    this.issueName = '';
    this.rep_name = '';
    if (
      this.rangeRegistration.get('start').value != null &&
      this.rangeRegistration.get('end').value != null
    ) {
      // console.log(this.rangeRegistration.value);
      this.dateIsEnable = true;
      // console.log(
      //   formatDate(
      //     new Date(this.rangeRegistration.get('start').value),
      //     'yyyy-MM-dd',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      // console.log(
      //   formatDate(
      //     new Date(this.rangeRegistration.get('end').value),
      //     'dd-MM-yyyy',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      let startdate = formatDate(
        new Date(this.rangeRegistration.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      let endDate = formatDate(
        new Date(this.rangeRegistration.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.startDate_registration = startdate;
      this.enddate_registration = endDate;
    } else {
      this.dateIsEnable = false;
    }
  }

  getcust_mobile_filter(mobile) {
    // console.log(mobile);
    // console.log(this.cust_mobile_filter.length);
    // this.rangeRegistration.reset();
    // this.startDate_registration = '';
    // this.enddate_registration = '';
    this.advt_name = '';
    this.issueName = '';
    this.rep_name = '';
  }

  

  getallVouchersData: any[] = [];
  // totalTotal = 0;
  // pendingTotal = 0;

  // getAllVouchers(startDate: string, endDate: string) {
  //   this.totalTotal = 0;
  //   this.pendingTotal = 0;

  //   this.service.getvoucherbyAdvt(startDate, endDate).subscribe((data: any) => {
  //     this.getallVouchersData = data;

  //     for (let item of this.getallVouchersData) {
  //       this.totalTotal += parseInt(item.price) || 0;
  //       this.pendingTotal += parseInt(item.remaining_amt) || 0;
  //     }
  //   });
  // }



  getallCommVouchersData = [];
  // getAllCommVouchers(startDate: string, endDate: string) {
  //   this.commission_Total = 0;
  //   this.commRemainingTotal = 0;

  //   console.log("Sending dates:", startDate, endDate);
  //   console.log("Date types:", typeof startDate, typeof endDate);

  //   this.service.getvoucherbycommisionadvt(startDate, endDate)
  //     .subscribe({
  //       next: (data) => {
  //         console.log("Received:", data);
  //         this.getallCommVouchersData = data;

  //         for (let comdata of this.getallCommVouchersData) {
  //           this.commission_Total += parseInt(comdata.commission) || 0;
  //           this.commRemainingTotal += parseInt(comdata.remaining_amt) || 0;
  //         }
  //       },
  //       error: (error) => {
  //         console.error("API Error:", error);
  //         console.error("Error status:", error.status);
  //         console.error("Error message:", error.message);
  //         console.error("Full error:", JSON.stringify(error));
  //       }
  //     });
  // }





  getAllCommVouchers(startDate: string, endDate: string, repname?: string) {
    this.commission_Total = 0;
    this.commRemainingTotal = 0;

    console.log("Sending dates:", startDate, endDate);
    console.log("Rep Name:", repname);
    console.log("Date types:", typeof startDate, typeof endDate);

    this.service.getvoucherbycommisionadvt(startDate, endDate, repname)
      .subscribe({
        next: (data) => {
          console.log("Received:", data);
          this.getallCommVouchersData = data;

          for (let comdata of this.getallCommVouchersData) {
            this.commission_Total += parseInt(comdata.commission) || 0;
            this.commRemainingTotal += parseInt(comdata.remaining_amt) || 0;

            console.log("Rep Name:", comdata.rep_name);
          }
        },
        error: (error) => {
          console.error("API Error:", error);
          console.error("Error status:", error.status);
          console.error("Error message:", error.message);
          console.error("Full error:", JSON.stringify(error));
        }
      });
  }


  generateinv(event) {

    let parts = event.target.value.split('-');

    if (parts[0] != "VSJ") {
      return;

    }
    let parts1 = parts[1].split('/');
    if (parts1[0].length == 2) {
      let val = parts[0] + "-" + parts1[0] + "/"
      if (parts1[1] == undefined) {
        this.invoicenumber = val
        return
      }

      if (parts1[1].length == 4) {
        val = val + parts1[1] + "/"
        if (parts1[2] == undefined) {
          this.invoicenumber = val
          return
        }
        if (parts1[2].length == 4) {
          val = val + parts1[2]
          return
        } else {
          this.invoicenumber = event.target.value
        }
      } else {
        this.invoicenumber = event.target.value
      }
      this.invoicenumber = event.target.value
    }
    // else{
    //   return;
    // }


    // else{
    //   return;
    // }

    // else{
    //   return;
    // }
  }

  getIssuesSearchAdvt(e) {
    // console.log(e);
    this.issueName = e.value;
    // this.rangeRegistration.reset();
    // this.startDate_registration = '';
    // this.enddate_registration = '';
    this.advt_name = '';
    this.cust_mobile_filter = '';
    this.rep_name = '';
  }

  reset_cust_mobile_filter(event) {
    this.cust_mobile_filter = '';
  }

  get_rep_name_filter(repname) {
    // console.log(repname);
    // this.rangeRegistration.reset();
    // this.startDate_registration = '';
    // this.enddate_registration = '';
    this.advt_name = '';
    this.issueName = '';
    this.cust_mobile_filter = '';
  }

  get_advt_name_filter(advtname) {
    // console.log(advtname);
    // this.rangeRegistration.reset();
    // this.startDate_registration = '';
    // this.enddate_registration = '';
    this.issueName = '';
    this.cust_mobile_filter = '';
    this.rep_name = '';
  }

  cust_mobile_filter = '';
  rep_name = '';
  getAdvtDetails = [];
  advt_name = '';
  getAdvtReport() {
    // console.log(
    //   // this.startDate_registration,
    //   // this.enddate_registration,
    //   this.advt_name,
    //   this.cust_mobile_filter,
    //   this.issueName,
    //   this.rep_name
    // );
    if (this.advt_name == '') {
      this.advt_name = 'opqr';
    }

    if (this.cust_mobile_filter == '') {
      this.cust_mobile_filter = '777';
    }

    if (this.issueName == '') {
      this.issueName = 'abc';
    }

    if (this.rep_name == '') {
      this.rep_name = 'xyz';
    }

    this.service
      .getAdvtReports(
        this.advt_name,
        this.cust_mobile_filter,
        this.issueName,
        this.rep_name
      )
      .subscribe((data) => {
        console.log(data);
        this.getAdvtDetails = data;
      });
  }

  /*name of the excel-file which will be downloaded. */
  //fileName = 'ExcelSheet.xlsx';

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  view_advt(advt) {
    // console.log(advt);
    this.dialog.open(UpdateAdvtDetailsComponent, {
      data: {
        advt: advt,
        view_mode: true,
      },
    });
  }

  expense_report_new() {

    debugger

    const subCtrl = this.expense.get('subexpnameother');

    // Case: sub expense is required and not selected
    if (!subCtrl?.value || subCtrl.value === '') {
      alert('Please select sub expense');
      return;
    }

    const dialogdata = this.dialog.open(ExpenseLedgerReportComponent, {
      data: {
        startDate: this.expenseledgerStartDate,
        endDate: this.expenseledgerEndDate,
        mainexp: this.expense.value.expnameother,
        subexp: this.expense.value.subexpnameother,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  getSubExpByMainExp(event: any) {
    debugger;

    // find selected main-expense (keeps your existing loop logic)
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value.id) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
        break;
      }
    }

    // fetch sub-expenses for selected main
    this.service.getSubExpenseLedgerWithId(event.value.id).subscribe((res: any[]) => {
      this.subExpData = res || [];

      const subCtrl = this.expense.get('subexpnameother');

      if (this.subExpData && this.subExpData.length > 0) {
        this.subexpense = true;

        if (subCtrl?.disabled) {
          subCtrl.enable({ emitEvent: false });
        }
        subCtrl?.reset();


      } else {
        this.subexpense = false;

        // clear value and state so old ids/names don't persist
        subCtrl?.reset();                  // clears value and marks pristine/touched = false
        subCtrl?.setErrors(null);         // clear any leftover errors
        subCtrl?.clearValidators();       // optional: remove validators if you don't want them
        subCtrl?.updateValueAndValidity();

        // disable so it won't be submitted if you're reading rawValue or form.value
        if (subCtrl?.enabled) {
          subCtrl.disable({ emitEvent: false });
        }
      }
    });
  }

  expenseledgerStartDate = '';
  expenseledgerEndDate = '';
  expenseledgerDateRange() {

    if (
      this.expense.get('start').value != null &&
      this.expense.get('end').value != null
    ) {
      this.expenseledgerStartDate = formatDate(
        this.expense.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.expenseledgerEndDate = formatDate(
        this.expense.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  pendingAdvtData1;
  displayCommItemId(advt) {
    this.voucherdate = advt.voucher_date
    this.pendingAdvtData1 = advt;
    this.repname = advt.rep_name;
    console.log(this.repname, "repname")
    this.demo1TabIndex = 17 % 23;

    this.demo1BtnClickCom();
    // this.getentrybyrep();
    //  this.advtcommrecptform.get('repnamesearch')?.reset();
    //  this.advtcommrecptform.value.repnamesearch.reset();

  }

  searchText1;
  // getentrybyrep() {

  //  this.service.getAdvtRepNames(this.repname).subscribe((res) => {
  //      // console.log(res);
  //      this.getentrybyadvtrepnamelist = res;
  //      console.log(res, "getentrybyadvtrepnamelist");
  //   });
  // }

  pendingAdvtData;
  displayItemId(advt) {


    this.voucherdate = advt.voucher_date
    this.pendingAdvtData = advt;
    this.repname = advt.rep_name;
    console.log(this.repname, "repname")
    this.demo1BtnClick();
    this.getentrybyrepname();
    this.advtpymtrecptform.value.advtnamesearch.reset()
  } //end of displayId
  searchText;
  getentrybyrepname() {

    this.service.getentrybyrepname(this.repname).subscribe((res) => {
      // console.log(res);
      this.getentrybyrepnamelist = res;
      console.log(res, "getentrybyrepnamelist");
    });
  }

  public demo1TabIndex = 0;
  public demo1BtnClick() {
    const tabCount = 12;
    this.demo1TabIndex = (this.demo1TabIndex + 1) % tabCount;
    this.advtrcptsetvalue();
  }


  // public demo1TabIndex1 = 0;
  // public demo1BtnClickCom() {
  //   const tabCount = 18;
  //   this.demo1TabIndex = (this.demo1TabIndex + 1) % tabCount;
  //   this.advtrcptsetvalue1();
  // }

  demo1BtnClickCom() {
    const tabCount = 22;
    this.demo1TabIndex1 = (this.demo1TabIndex1 + 1) % tabCount;
    this.advtrcptsetvalue1();
  }



  convertDateFormat(dateStr: string): string {
    // Split the input date string by hyphens
    const [day, month, year] = dateStr.split('-');

    // Return the new date string in the desired format
    return `${year}-${month}-${day}`;
  }

  advtrcptsetvalue() {

    console.log(this.pendingAdvtData, "setdata value");
    // let today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    // let rcpt_no = `JRJ1000049/${new Date(today).getMonth() + 1 < 4
    //     ? (new Date(today).getFullYear() - 1).toString().slice(-2) +
    //     '-' +
    //     new Date(today).getFullYear().toString().slice(-2)
    //     : new Date(today).getFullYear().toString().slice(-2) +
    //     '-' +
    //     (new Date(today).getFullYear() + 1).toString().slice(-2)
    //   }`;
    // let recdate = this.datePipe.transform(this.voucherdate, 'yyyy-MM-dd');
    let recdate = this.convertDateFormat(this.voucherdate);


    const req: any = {
      "date": recdate
    }


    //   this.service.getReceiptnumber(req).subscribe((data: any) => {


    //     // console.log("auto CrNo=",data);
    //     this.autogeneratedno = (data as any);;
    //     console.log(this.autogeneratedno)

    //     let newg = this.autogeneratedno[0].rcpt_no


    //     if (this.autogeneratedno == undefined) {
    //       newg = 1;
    //     }
    //     else {
    //       newg++;
    //     }


    //     const dateString = this.pendingAdvtData['voucher_date']; // Assuming format is DD-MM-YYYY
    //     const dateParts = dateString.split('-');
    //     const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);

    //     // Get the month in 2-digit format (01-12)
    //     const month = String(formattedDate.getMonth() + 1).padStart(2, '0');

    //     // Determine financial year based on the month
    //     // If month < 4 (before April), use previous year-current year, else use current year-next year
    //     const currentYear = formattedDate.getFullYear();
    //     const financialYear = formattedDate.getMonth() + 1 < 4 
    //       ? `${(currentYear - 1).toString().slice(-2)}${currentYear.toString().slice(-2)}`
    //       : `${currentYear.toString().slice(-2)}${(currentYear + 1).toString().slice(-2)}`;

    //     // Assuming newg is a counter/sequential number that needs to be padded to 4 digits
    //     // If newg is not defined or needs different handling, adjust accordingly
    //     const sequentialNumber = String(newg).padStart(4, '0');

    //     // Generate receipt number in the format JRJ/MM/YYZZ/NNNN
    //     const rcpt_no = `JRJ/${month}/${financialYear}/${sequentialNumber}`;

    //     // Set the receipt number in the form
    //     this.advtpymtrecptform.get('recptno').setValue(rcpt_no);

    // this.advtpymtrecptform.get('recptno').setValue(rcpt_no);
    //   let today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    //   this.advtpymtrecptform.get('date').setValue(today1);
    //   this.advtpymtrecptform
    //     .get('crdtvno')
    //     .setValue(this.pendingAdvtData['voucher_no']);
    //   this.advtpymtrecptform
    //     .get('recptdate')
    //     .setValue(this.pendingAdvtData['voucher_date']);
    //   this.advtpymtrecptform
    //     .get('repname')
    //     .setValue(this.pendingAdvtData['rep_name']);
    //   this.advtpymtrecptform
    //     .get('crdtvamt')
    //     .setValue(this.pendingAdvtData['remaining_amt']);
    //   this.advtpymtrecptform
    //     .get('advtname')
    //     .setValue(this.pendingAdvtData['advtName']);



    //   let name = this.advtpymtrecptform.get('repname').value;


    //   });
    this.service.getReceiptnumber(req).subscribe((data: any) => {
      // Store the response data
      this.autogeneratedno = data;
      console.log("Received data:", this.autogeneratedno);

      // The backend has already generated the next receipt number for us
      // Just use it directly without additional processing
      if (this.autogeneratedno && this.autogeneratedno.length > 0 && this.autogeneratedno[0].rcpt_no) {
        const rcpt_no = this.autogeneratedno[0].rcpt_no;
        console.log("Using receipt number from backend:", rcpt_no);

        // Set form values
        this.advtpymtrecptform.get('recptno').setValue(rcpt_no);
        let today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.advtpymtrecptform.get('date').setValue(today1);
        this.advtpymtrecptform.get('crdtvno').setValue(this.pendingAdvtData['voucher_no']);
        this.advtpymtrecptform.get('recptdate').setValue(this.pendingAdvtData['voucher_date']);
        this.advtpymtrecptform.get('advtname').setValue(this.pendingAdvtData['advtName']);
        this.advtpymtrecptform.get('crdtvamt').setValue(this.pendingAdvtData['remaining_amt']);
        this.advtpymtrecptform.get('repname').setValue(this.pendingAdvtData['rep_name']);

      } else {
        console.error("No valid receipt number received from backend");
      }
    });
    // let names = this.advtNames.filter(
    //   (a) => a['name'] === this.pendingAdvtData['rep_name']
    // );
  }

  // advtrcptsetvalue1() {
  //   console.log(this.pendingAdvtData1, "setdata value");

  //   let recdate = this.convertDateFormat(this.voucherdate);

  //   const req: any = {
  //     "date": recdate
  //   }

  //   this.service.getcommissionnumber(req).subscribe((data: any) => {
  //     // Store the response data
  //     this.autogeneratedno = data; // Added this line to store the data
  //     console.log("Received data:", this.autogeneratedno);
  //     debugger
  //     // The backend has already generated the next receipt number for us
  //     // Just use it directly without additional processing
  //     if (this.autogeneratedno && this.autogeneratedno.length > 0 && this.autogeneratedno[0].commision_no) {
  //       const rcpt_no = this.autogeneratedno[0].commision_no;
  //       console.log("Using receipt number from backend:", rcpt_no);

  //       debugger
  //       // Set form values
  //       this.advtcommrecptform.get('recptno').setValue(rcpt_no);
  //       let today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
  //       this.advtcommrecptform.get('date').setValue(today1);
  //       this.advtcommrecptform.get('crdtvno').setValue(this.pendingAdvtData1['voucher_no']);
  //       this.advtcommrecptform.get('recptdate').setValue(this.pendingAdvtData1['voucher_date']);
  //       this.advtcommrecptform.get('repname').setValue(this.pendingAdvtData1['rep_name']);
  //       this.advtcommrecptform.get('crdtvamt').setValue(this.pendingAdvtData1['commission']);
  //       this.advtcommrecptform.get('advtname').setValue(this.pendingAdvtData1['advtName']);


  //       // Clear previous table data and load new data for the current tab
  //       // this.loadTabData();
  //     } else {
  //       console.error("No valid receipt number received from backend");
  //     }
  //   });
  // }


  // advtrcptsetvalue1() {
  //   debugger
  //   console.log(this.pendingAdvtData1, "setdata value");

  //   let recdate = this.convertDateFormat(this.voucherdate); // Use receipt date from voucher

  //   const req: any = {
  //     "date": recdate  // Pass receipt date (not current date)
  //   }

  //   this.service.getcommissionnumber(req).subscribe((data: any) => {
  //     // Store the response data
  //     this.autogeneratedno = data;
  //     console.log("Received data:", this.autogeneratedno);
  //     debugger
  //     // The backend has already generated the next receipt number for us
  //     // Just use it directly without additional processing
  //     if (this.autogeneratedno && this.autogeneratedno.length > 0 && this.autogeneratedno[0].commision_no) {
  //       const rcpt_no = this.autogeneratedno[0].commision_no;
  //       console.log("Using receipt number from backend:", rcpt_no);

  //       debugger
  //       // Set form values
  //       this.advtcommrecptform.get('recptno').setValue(rcpt_no);
  //       let today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
  //       this.advtcommrecptform.get('date').setValue(today1);
  //       this.advtcommrecptform.get('crdtvno').setValue(this.pendingAdvtData1['voucher_no']);
  //       this.advtcommrecptform.get('recptdate').setValue(this.pendingAdvtData1['voucher_date']);
  //       this.advtcommrecptform.get('repname').setValue(this.pendingAdvtData1['rep_name']);
  //       this.advtcommrecptform.get('crdtvamt').setValue(this.pendingAdvtData1['commission']);
  //       this.advtcommrecptform.get('advtname').setValue(this.pendingAdvtData1['advtName']);
  //       this.comm_percentage = this.pendingAdvtData1['comm_percentage'];


  //       // Clear previous table data and load new data for the current tab
  //       // this.loadTabData();
  //     } else {
  //       console.error("No valid receipt number received from backend");
  //     }
  //   });
  // }

  advtrcptsetvalue1() {
    debugger
    console.log(this.pendingAdvtData1, "setdata value");

    // FIX: Use voucher_date from pendingAdvtData1 instead of undefined this.voucherdate
    let recdate = this.convertDateFormat(this.pendingAdvtData1['voucher_date']);

    const req: any = {
      "date": recdate  // Pass receipt date (not current date)
    }

    this.service.getcommissionnumber(req).subscribe((data: any) => {
      this.autogeneratedno = data;
      console.log("Received data:", this.autogeneratedno);
      debugger

      if (this.autogeneratedno && this.autogeneratedno.length > 0 && this.autogeneratedno[0].commision_no) {
        const rcpt_no = this.autogeneratedno[0].commision_no;
        console.log("Using receipt number from backend:", rcpt_no);

        debugger
        // Set form values
        this.advtcommrecptform.get('recptno').setValue(rcpt_no);
        let today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.advtcommrecptform.get('date').setValue(today1);
        this.advtcommrecptform.get('crdtvno').setValue(this.pendingAdvtData1['voucher_no']);
        this.advtcommrecptform.get('recptdate').setValue(this.pendingAdvtData1['voucher_date']);
        this.advtcommrecptform.get('repname').setValue(this.pendingAdvtData1['rep_name']);
        this.advtcommrecptform.get('crdtvamt').setValue(this.pendingAdvtData1['commission']);
        this.advtcommrecptform.get('advtname').setValue(this.pendingAdvtData1['advtName']);
        this.comm_percentage = this.pendingAdvtData1['comm_percentage'];
      } else {
        console.error("No valid receipt number received from backend");
      }
    });
  }


  newval: any = 0;
  addadvtpymtrcpt() {
    let data = {
      date: this.advtpymtrecptform.get('date').value,
      crdtvno: this.advtpymtrecptform.get('crdtvno').value,
      recptdate: this.advtpymtrecptform.get('recptdate').value,
      repname: this.advtpymtrecptform.get('repname').value,
      recptno: this.advtpymtrecptform.get('recptno').value,
      crdtvamt: this.advtpymtrecptform.get('crdtvamt').value,
      seamt: this.advtpymtrecptform.get('seamt').value,
      advtname: this.advtpymtrecptform.get('advtname').value,
      balamt: this.advtpymtrecptform.get('balamt').value,
      // booking_no : book.booking_no,
      // billno: this.booksellernamedata[0]['invoice_no'],
      // value: this.val1,
    };
    console.log(data, "Seamt new")
    // let newval = this.advtpymtrecptform.get('seamt').value;

    console.log(this.advtInvoicePymtRcptData, " this.advtInvoicePymtRcptData")
    this.dialog.open(AdvtInvoicePaymentReceiptComponent, {

      data: {
        data: data,
        pendingAdvtData: this.pendingAdvtData,
        advtInvoicePymtRcptData: this.advtInvoicePymtRcptData,
        advtInvoicePricePerIssue: this.advtInvoicePricePerIssue,
        advtname: this.advtpymtrecptform.get('advtnamesearch').value,
        // billno: this.booksellernamedata[0]['invoice_no'],
        val: data['seamt'],
        newval: this.newval,
        invoicenumberlist: this.arraynew

      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
    debugger;
    console.log(data, "new valuw is")
    // this.dialog.closeAll();
  }

  getOffRep() {

    this.service.getOffRepSub().subscribe((data: any) => {
      console.log("represntive name", data);
      this.GetOffRep = (data as any);
      this.filterrep = (data as any);
    });
  }

  searchAdvtName(event) {
    // console.log(event.target.value);
    if (event.target.value.length > 2) {
      this.service
        .getAdvtNamesForPymt(event.target.value)
        .subscribe((res: any) => {
          this.advtNamesData = res;
          // console.log(res);
          this.advtNamesData = this.uniqueid(
            this.advtNamesData,
            (a) => a.advt_name
          );
          // console.log(this.advtNamesData);
        });
    }
  }

  advtInvoiceListData;
  advtInvoiceListData1;
  // const req:any = {
  //   "rep_name":this.repName,
  //   "start_date":this.startDate,
  //   "end_date":this.endDate,
  //   "off_rep_name":this.offRepName,
  //   "issue_name":""
  // }
  // searchAdvtName1() {
  //   this.advtInvoiceListData1 = [];
  //   this.service.getAllAdvtInvoicesForPymt1(this.name).subscribe((res) => {
  //     // console.log(res);
  //     this.advtInvoiceListData1 = res;
  //     console.log(res);
  //   });

  //   setTimeout(() => {
  //     this.advtInvoiceListData = [];
  //     this.advtInvoiceListData = this.advtInvoiceListData1.filter(
  //       (a) => a.advt_name === this.name
  //     );
  //     // console.log(this.advtInvoiceListData);
  //   }, 700);
  // }

  searchAdvtName0() {
    const req: any = {
      "name": this.advtpymtrecptform.value.advtnamesearch,

    }
    this.advtInvoiceListData1 = [];
    this.service.getAllAdvtInvoicesForPymt(this.advtpymtrecptform.value.advtnamesearch).subscribe((res) => {

      // console.log(res);
      this.advtInvoiceListData1 = res;
      console.log(this.advtInvoiceListData1, "nan value")
    });

    setTimeout(() => {
      this.advtInvoiceListData = [];
      this.advtInvoiceListData = this.advtInvoiceListData1.filter(
        (a) => a.advt_name === this.name
      );
      // console.log(this.advtInvoiceListData);
    }, 700);
  }
  searchAdvtName1() {
    this.getentrybyrepnamelist = [];
    const req: any = {
      "name": this.advtpymtrecptform.value.advtnamesearch,

    }
    this.advtInvoiceListData1 = [];
    this.service.getAllAdvtInvoicesForPymt(this.advtpymtrecptform.value.advtnamesearch).subscribe((res) => {

      // console.log(res);
      this.getentrybyrepnamelist = res;
      console.log(this.getentrybyrepnamelist, "nan value")
    });

    setTimeout(() => {
      this.advtInvoiceListData = [];
      this.advtInvoiceListData = this.advtInvoiceListData1.filter(
        (a) => a.advt_name === this.name
      );
      // console.log(this.advtInvoiceListData);
    }, 700);
  }




  // Call this after searchRepAdvtName1()
  searchRepAdvtName1() {
    debugger
    this.getentrybyadvtrepnamelist = [];
    const req: any = {
      "name": this.advt_name,
    }
    this.advtInvoiceListData1 = [];
    this.service.getentrybyadvtrepnamelist(this.advt_name).subscribe((res) => {
      // console.log(res);
      // this.getentrybyadvtrepnamelist = res;
      this.CommissionData = res;
      console.log(res, "getentrybyrepnamelist");

    });

    setTimeout(() => {
      this.advtInvoiceListData1 = [];
      this.advtInvoiceListData1 = this.advtInvoiceListData1.filter(
        (a) => a.advt_name === this.name
      );
      // console.log(this.advtInvoiceListData);
    }, 700);

  }




  searchRepAdvtNamelist() {
    this.getentrybyadvtrepnamelist = [];
    const req: any = {
      "name": this.advtcommrecptform.value.repnamesearch,

    }
    this.advtInvoiceListData1 = [];
    this.service.getentrybyadvtrepnamelist(this.repname).subscribe((res) => {
      // console.log(res);
      // this.getentrybyadvtrepnamelist = res;
      this.CommissionData = res;
      this.initializeCommissions();
      console.log(res, "getentrybyrepnamelist");
    });

    setTimeout(() => {
      this.advtInvoiceListData1 = [];
      this.advtInvoiceListData1 = this.advtInvoiceListData1.filter(
        (a) => a.advt_name === this.name
      );
      // console.log(this.advtInvoiceListData);
    }, 700);
  }




  nameid;
  name;
  selectedname(event, option) {
    if (event.isUserInput) {
      // this.nameid = option['id'];
      this.name = option['advt_name'];
    }
  }

  advtInvoicePymtRcptData = [];



  selectedItem(advtInvoice) {

    console.log(advtInvoice, "selected dsata");
    console.log(this.advtInvoicePymtRcptData);


    // if (Object.keys(this.advtInvoicePymtRcptData).length != 0) { 
    //   let flag: Boolean = false;
    //   for (
    //     let index = 0;
    //     index < Object.keys(this.advtInvoicePymtRcptData).length;
    //     index++
    //   ) {
    //     if (this.advtInvoicePymtRcptData[index]['id'] == advtInvoice['id']) {
    //       flag = true;
    //     }

    //   }
    //   if (!flag) {
    //     this.calculateRcptAmt(advtInvoice);
    //   } else {
    //     window.alert('Receipt is Already Selected...');
    //   }
    // } else {
    //   this.calculateRcptAmt(advtInvoice);
    // }
    this.calculateRcptAmt(advtInvoice);
    console.log(this.advtInvoicePymtRcptData);

  }


  debugger;
  advtInvoiceRepData = [];

  selectedItemRep(advtInvoice1) {

    console.log(advtInvoice1, "selected dsata");
    console.log(this.advtInvoiceRepPymtRcptData);

    this.calculateRepRcptAmt(advtInvoice1);
    console.log(this.advtInvoiceRepPymtRcptData);

  }
  advtInvoiceRepPymtRcptData(advtInvoiceRepPymtRcptData: any) {
    throw new Error('Method not implemented.');
  }




  updateIssueAnk(advtInvoice) {
    console.log(advtInvoice, this.advtInvoicePricePerIssue);
    // let data = this.advtInvoicePricePerIssue.find(
    //   (a) => a.id == advtInvoice.id
    // );
    // if (data) {
    const dialogdata = this.dialog.open(UpdateAdvtIssuePerPriceComponent, {
      data: {
        advtInvoice: advtInvoice,
        crdtAmt: parseFloat(this.advtpymtrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.advtpymtrecptform.get('seamt').value),
        balAmt: parseFloat(this.advtpymtrecptform.get('balamt').value),
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {
      this.advtInvoiceListData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });

      debugger;
      this.advtpymtrecptform.get('seamt').setValue(res.selecetdAmt);
      this.advtpymtrecptform.get('balamt').setValue(res.balanceAmt);
      // console.log(this.advtInvoicePricePerIssue);

      this.advtInvoicePricePerIssue.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a = res.advtInvoiceData;
        }
      });
      // console.log(this.advtInvoicePricePerIssue);
    });
    // }
    //  else {
    //   window.alert('First select the receipt');
    // }
  }

  deletePymtreceipt(advt) {
    const req: any = {
      "id": advt
    }
    debugger;
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deletePymtreceipt(req).subscribe((res) => {
        console.log(res)
      });
    }
    this.ngOnInit()
  }

  deleteCreditNote(advt) {
    const req: any = {
      "id": advt
    }
    debugger;
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deleteCreditNote(req).subscribe((res) => {
        console.log(res)
      });
    }
    this.ngOnInit()
  }

  advtInvoicePricePerIssue = [];

  advtInvoiceRepPricePerIssue = [];



  calculateRepRcptAmt(advtInvoice1) {

    debugger;
    this.advtInvoiceRepData.push(advtInvoice1);
    const dialogdata = this.dialog.open(AddAdvtRepPerPriceComponent, {

      data: {
        advtInvoice: advtInvoice1,
        crdtAmt: parseFloat(this.advtcommrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.advtcommrecptform.get('seamt').value),
        balAmt: parseFloat(this.advtcommrecptform.get('balamt').value),
        bal: advtInvoice1.pay_amt - advtInvoice1.rcv_amt,

      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {

      console.log(res, 'res');
      if (this.newval == 0) {
        this.newval = res.newvalue;
      } else {
        this.newval = this.newval + ',' + res.newvalue
      }
      console.log(this.advtInvoiceList, "list")
      console.log(this.newval, "new val2")

      debugger;
      this.arraynew = res.invoicenumberlist;

      this.advtInvoiceListData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });

      this.getallVouchersData.forEach((element, index) => {
        if (this.pendingAdvtData.voucher_no == element.voucher_no) {
          element.remaining_amt = res.advtInvoiceData.remaining_amt;
          if (element.remaining_amt == 0) {
            this.getallVouchersData.splice(index, 1); // Remove the object from the array
          }
        }
      });
      debugger;
      this.invoicenumberlist = this.invoicenumberlist

      this.advtpymtrecptform.get('seamt').setValue(res.selecetdAmt);
      this.advtpymtrecptform.get('balamt').setValue(res.balanceAmt);
      // res.advtInvoiceData.map((a) => {
      this.advtInvoicePricePerIssue.push(res.advtInvoiceData);
      // });
      // console.log(this.advtInvoicePricePerIssue);
    });
  }






  calculateRcptAmt(advtInvoice) {


    this.advtInvoicePymtRcptData.push(advtInvoice);
    const dialogdata = this.dialog.open(AddAdvtIssuePerPriceComponent, {

      data: {
        advtInvoice: advtInvoice,
        crdtAmt: parseFloat(this.advtpymtrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.advtpymtrecptform.get('seamt').value),
        balAmt: parseFloat(this.advtpymtrecptform.get('balamt').value),
        bal: advtInvoice.pay_amt - advtInvoice.rcv_amt,

      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {

      console.log(res, 'res');
      if (this.newval == 0) {
        this.newval = res.newvalue;
      } else {
        this.newval = this.newval + ',' + res.newvalue
      }
      console.log(this.advtInvoiceList, "list")
      console.log(this.newval, "new val2")

      debugger;
      this.arraynew = res.invoicenumberlist;

      this.advtInvoiceListData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });

      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });

      this.getallVouchersData.forEach((element, index) => {
        if (this.pendingAdvtData.voucher_no == element.voucher_no) {
          element.remaining_amt = res.advtInvoiceData.remaining_amt;
          if (element.remaining_amt == 0) {
            this.getallVouchersData.splice(index, 1); // Remove the object from the array
          }
        }
      });
      debugger;
      this.invoicenumberlist = this.invoicenumberlist

      this.advtpymtrecptform.get('seamt').setValue(res.selecetdAmt);
      this.advtpymtrecptform.get('balamt').setValue(res.balanceAmt);
      // res.advtInvoiceData.map((a) => {
      this.advtInvoicePricePerIssue.push(res.advtInvoiceData);
      // });
      // console.log(this.advtInvoicePricePerIssue);
    });
  }

  update_advt(advt) {
    // console.log(advt);
    this.dialog.open(UpdateAdvtDetailsComponent, {
      data: {
        advt: advt,
        view_mode: false,
      },
    });
  }

  addPublishDates(advt) {
    // console.log(advt);
    let published_dates;

    if (advt['published_dates'] != null) {
      published_dates = advt['published_dates'].split(',');
    } else {
      published_dates = [];
    }

    this.dialog.open(UpdatePlublishDatesComponent, {
      data: {
        published_dates: published_dates,
        advt_dtl_id: advt['advt_dtl_id'],
        manage_mode: false,
        issue_date_mode: false,
        height: '600px',
        width: '600px',
      },
    });
  }

  addIssueDates(advt) {
    // console.log(advt);
    let issue_dates;

    if (advt['issue_dates'] != null) {
      issue_dates = advt['issue_dates'].split(',');
    } else {
      issue_dates = [];
    }

    this.dialog.open(UpdatePlublishDatesComponent, {
      data: {
        published_dates: issue_dates,
        advt_dtl_id: advt['advt_dtl_id'],
        manage_mode: false,
        issue_date_mode: true,
        height: '600px',
        width: '600px',
      },
    });
  }

  Cancel_advt(advt) {
    // console.log(advt);
    if (window.confirm('Do you really want to remove this Advertisement?')) {
      this.service
        .updateAdvtdtlStatus(parseInt(advt['advt_dtl_id']))
        .subscribe((data) => {
          // console.log(data);
          window.alert(
            'Advertisement has been remove. Please try to refresh the page.'
          );
        });
    }
  }

  getAdvtMagName(event, issue_name, id, dateIndex) {
    // console.log(event, issue_name, id, dateIndex);
    if (window.confirm('Do you really want to remove the date?')) {
      let mag = this.advt_mag_name_details.filter((a) => {
        return parseInt(a.id) === parseInt(id);
      });
      // console.log(mag);
      mag[0]['publishing_date'].splice(dateIndex, 1);
      // console.log(mag);
      // console.log(event, issue_name);
      //update Service call
    }
  }

  manageAdvtDates(advt) {
    this.dialog.open(UpdatePlublishDatesComponent, {
      data: {
        published_dates: advt['publishing_date'],
        advt_dtl_id: advt['id'],
        manage_mode: true,
        issue_date_mode: false,
        height: '600px',
        width: '600px',
      },
    });
  }

  remove_mag_advt(advt) {
    //remove Magazine advt

    this.service.updateAdvtMagStatus(advt['id'], 'N').subscribe((data) => {
      // console.log(data);
      this.getAdvtMagDetails();
      window.alert('Status Change!');
    });
  }

  make_it_activate(advt) {
    this.service.updateAdvtMagStatus(advt['id'], 'Y').subscribe((data) => {
      // console.log(data);
      this.getAdvtMagDetails();
      window.alert('Status Change!');
    });
  }

  allSelected = false;
  @ViewChild('mySel')
  skillSel!: MatSelect;
  toggleAllSelection() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }

  allSelected1 = false;
  @ViewChild('mySel1')
  skillSel1!: MatSelect;
  toggleAllSelection1() {
    this.allSelected1 = !this.allSelected1; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected1) {
      this.skillSel1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel1.close();
  }


  allSelected2 = false;
  @ViewChild('mySel5')
  skillSel3!: MatSelect;
  toggleAllSelection6() {
    this.allSelected2 = !this.allSelected2; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected2) {
      this.skillSel3.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel3.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel1.close();
  }


  allSelectedr1 = false;
  @ViewChild('mySelr1')
  skillSelr1!: MatSelect;
  toggleAllSelectionr1() {
    this.allSelectedr1 = !this.allSelectedr1; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedr1) {
      this.skillSelr1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelr1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelr1.close();
  }

  allSelectedr2 = false;
  @ViewChild('mySelr2')
  skillSelr2!: MatSelect;
  toggleAllSelectionr2() {
    this.allSelectedr2 = !this.allSelectedr2; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedr2) {
      this.skillSelr2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelr2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelr2.close();
  }

  allSelectedc1 = false;
  @ViewChild('mySelc1')
  skillSelc1!: MatSelect;
  toggleAllSelectionc1() {
    this.allSelectedc1 = !this.allSelectedc1; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedc1) {
      this.skillSelc1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelc1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelc1.close();
  }

  allSelectedc2 = false;
  @ViewChild('mySelc2')
  skillSelc2!: MatSelect;
  toggleAllSelectionc2() {
    this.allSelectedc2 = !this.allSelectedc2; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedc2) {
      this.skillSelc2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelc2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelc2.close();
  }


  allSelectedc3 = false;
  @ViewChild('mySelc3')
  skillSelc3!: MatSelect;
  toggleAllSelectionc3() {
    this.allSelectedc3 = !this.allSelectedc3; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedc3) {
      this.skillSelc3.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelc3.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelc3.close();
  }

  allSelected7 = false;
  @ViewChild('mySel2')
  skillSel2!: MatSelect;
  toggleAllSelection2() {
    this.allSelected7 = !this.allSelected7; // to control select-unselect
    // console.log(this.skillSel2.options);
    if (this.allSelected7) {
      this.skillSel2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel2.close();
  }

  allSelected3 = false;
  @ViewChild('mySel3')
  skillSel8!: MatSelect;
  toggleAllSelection3() {
    this.allSelected3 = !this.allSelected3; // to control select-unselect
    // console.log(this.skillSel3.options);
    if (this.allSelected) {
      this.skillSel8.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel8.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel8.close();
  }

  allSelected4 = false;
  @ViewChild('mySel4')
  skillSel4!: MatSelect;
  toggleAllSelection4() {
    this.allSelected4 = !this.allSelected4; // to control select-unselect
    // console.log(this.skillSel4.options);
    if (this.allSelected4) {
      this.skillSel4.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel4.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel4.close();
  }


  getChangedDateRegistrationReport() {
    debugger
    this.issueGranthName = '';
    this.issueDates = '';
    if (
      this.RegistrationreportRange.get('start').value != null &&
      this.RegistrationreportRange.get('end').value != null
    ) {
      this.dateIsEnable = true;
      this.startDate_registrationReport = formatDate(
        new Date(this.RegistrationreportRange.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_registrationReport = formatDate(
        new Date(this.RegistrationreportRange.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      const selectedDate = new Date(this.startDate_registrationReport);
      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      if (selectedDate < min || selectedDate > max) {
        alert('Date is outside the allowed range.');
        this.RegistrationreportRange.get('start')?.setValue(null);
        this.RegistrationreportRange.get('end')?.setValue(null);
      }

    } else {
      this.dateIsEnableReport = false;
    }
  }

  startDate_PrasiddhiPatrak = '';
  enddate_PrasiddhiPatrak = '';
  getChangedDatePrasiddhiPatrak() {
    debugger
    if (
      this.PrasiddhipatrakRange.get('start').value != null &&
      this.PrasiddhipatrakRange.get('end').value != null
    ) {
      let startdate = formatDate(
        new Date(this.PrasiddhipatrakRange.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      let endDate = formatDate(
        new Date(this.PrasiddhipatrakRange.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.startDate_PrasiddhiPatrak = startdate;
      this.enddate_PrasiddhiPatrak = endDate;
    }

    const selectedDate = new Date(this.startDate_PrasiddhiPatrak);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.PrasiddhipatrakRange.get('start')?.setValue(null);
      this.PrasiddhipatrakRange.get('end')?.setValue(null);
    }


  }




  getcust_mobile_filter_report(mobile) {
    // console.log(mobile);
    // console.log(this.cust_mobile_filter_report.length);
    this.RegistrationreportRange.reset();
    this.startDate_registrationReport = '';
    this.enddate_registrationReport = '';
    this.issueNameRegistrationReport = '';
  }

  reset_cust_mobile_filter_report(event) {
    this.cust_mobile_filter_report = '';
  }

  issueNameRegistrationReport = '';
  getIssuesRegistrationreport(e) {
    // console.log(e);
    this.issueNameRegistrationReport = e.value;
    this.RegistrationreportRange.reset();
    this.cust_mobile_filter_report = '';
  }

  showindetail: boolean = false;
  showindetaildatewise: boolean = false;
  showoffdatewise: boolean = false;
  showdatewisevrybrfly: boolean = false;
  showoffrepvrybrfly: boolean = false;
  showindetailoffrep: boolean = false;
  selectedReportType;
  checkReportType(event) {
    // console.log(event.value);
    this.selectedReportType = event.value;
    let indetail: boolean = false;
    let brfly: boolean = false;
    let verybrfly: boolean = false;
    let datewise: boolean = false;
    let offrepwise: boolean = false;
    // this.selectedReportType.forEach((type) => {
    //   if (type === 'In Detail') {
    //     indetail = true;
    //     if (this.offrepregreport != '') {
    //       offrepwise = true;
    //     }
    //   } else if (type === 'Briefly') {
    //     brfly = true;
    //   } else if (type === 'Very Briefly') {
    //     verybrfly = true;
    //     if (this.offrepregreport != '') {
    //       offrepwise = true;
    //     }
    //   } else if (type === 'Datewise') {
    //     datewise = true;
    //   }
    // });

    if (indetail && datewise) {
      this.showindetaildatewise = true;
      this.showindetail = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.inDetailsDatewise();
    } else if (datewise && verybrfly) {
      this.showdatewisevrybrfly = true;
      this.showoffrepvrybrfly = false;
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showoffdatewise = false;
      this.showindetailoffrep = false;
      this.datewiseBriefly();
      // this.datewiseBriefly();
    } else if (indetail && !datewise && !offrepwise) {
      this.showindetail = true;
      this.showindetaildatewise = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showindetailoffrep = false;
      this.showdatewisevrybrfly = false;
      this.getRegReportData();
    } else if (offrepwise && verybrfly) {
      this.showoffrepvrybrfly = true;
      this.showindetail = false;
      this.showindetaildatewise = false;
      this.showoffdatewise = false;
      this.showindetailoffrep = false;
      this.showdatewisevrybrfly = false;
      this.offrepVeryBriefly();
    } else if (indetail && offrepwise) {
      this.showindetailoffrep = true;
      this.showoffrepvrybrfly = false;
      this.showindetail = false;
      this.showindetaildatewise = false;
      this.showoffdatewise = false;
      this.showdatewisevrybrfly = false;
      this.inDetailsOffRep();
    }
  }

  inDetailsOffRep() {
    this.getRegReportData();
    setTimeout(() => {
      this.getReportInDetailOffRep();
    }, 200);
  }

  datewiseBriefly() {
    this.getRegReportData();
    setTimeout(() => {
      this.getReportDatewiseBriefly();
    }, 200);
  }

  offrepVeryBriefly() {
    this.getRegReportData();
    setTimeout(() => {
      this.getReportOffRepVeryBriefly();
    }, 200);
  }

  offrepregreport = '';
  getOfficeRep(event) {
    this.offrepregreport = event.value;
    this.checkReportType({ value: this.selectedReportType });
  }

  offrepname = '';
  getOfficeRep1(event) {
    this.offrepname = event.value;
  }

  repregreport = '';
  getRepName1(event) {
    this.repregreport = event.value;
    // console.log(event.value);
  }

  repname = '';
  getRepName2(event) {
    this.repname = event.value;
  }

  cust_mobile_filter_report = '';
  issueGranthName = '';
  issueDates = '';
  getAdvtDetailsReport = [];
  getAdvtRegistrationReport() {


    let repregreport: any = []
    if (this.repregreport[0] == 'ALL') {
      repregreport.push(this.repregreport[0])
    } else {
      repregreport = this.repregreport
    }
    let offrepregreport: any = []
    if (this.offrepregreport[0] == 'ALL') {
      offrepregreport.push(this.offrepregreport[0])
    } else {
      offrepregreport = this.offrepregreport
    }



    if (
      this.selectedReportType !== 'Represantative very Briefly' &&
      this.selectedReportType !== 'Represantative Briefly' &&
      this.selectedReportType !== 'Off_Represantative Indetails' &&
      this.selectedReportType !== 'Off_Represantative Briefly' &&
      this.selectedReportType !== 'Off_Represantative very Briefly' &&
      this.selectedReportType !== 'Datewise Indetails' &&
      this.selectedReportType !== 'Datewise Briefly' &&
      this.selectedReportType !== 'Represantative Indetails' &&
      this.selectedReportType !== 'datewise very Briefly' &&
      this.selectedReportType !== 'InDetail' &&
      this.selectedReportType !== 'Briefly'
    ) {
      debugger
      this.dialog.open(RegistrationReportComponent, {
        data: {
          type: this.selectedReportType,
          // start_date: this.startDate_registrationReport,
          // end_date: this.enddate_registrationReport,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.selectedReportType === 'Represantative very Briefly') {
      this.dialog.open(RegistrationRepVeryBrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
      this.index = 0;
    } else if (this.selectedReportType === 'Off_Represantative Indetails') {
      this.dialog.open(RegistrationOfficeRepresentativeDetailComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.selectedReportType === 'Off_Represantative Briefly') {
      this.dialog.open(RegistrationOfficeRepresentativeBrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.selectedReportType === 'Off_Represantative very Briefly') {
      debugger
      this.dialog.open(RegistrationOfficeRepresentativeVbrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.selectedReportType === 'Datewise Indetails') {
      debugger
      this.dialog.open(RegistrationDatewiseDetailsComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.selectedReportType === 'Datewise Briefly') {
      this.dialog.open(RegistrationDatewiseBrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
      this.index = 0;
    }
    else if (this.selectedReportType === 'Represantative Indetails') {
      this.dialog.open(RegistrationRepresentiveDetailComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
      this.index = 0;
    }
    else if (this.selectedReportType === 'datewise very Briefly') {
      this.dialog.open(RegistrationDatewiseVbrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.selectedReportType === 'InDetail') {
      debugger
      this.dialog.open(RegistrationIndetailsComponent, {
        data: {
          type: this.selectedReportType,
          // start_date: this.startDate_registrationReport,
          // end_date: this.enddate_registrationReport,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          value: this.tiktype,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.selectedReportType === 'Briefly') {
      this.dialog.open(RegistrationBrieflyComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    //     else if (this.selectedReportType === 'Represantative Indetails') {
    //   this.dialog.open(RegistrationRepresentiveDetailComponent , {
    //     data: {
    //       type: this.selectedReportType,
    //       start_date: this.startDate_registrationReport,
    //       end_date: this.enddate_registrationReport,
    //       rep_name: repregreport,
    //       off_rep_name: offrepregreport,
    //       issue_cat: this.issueName,
    //       issueDates: this.getDates,
    //       newissuedatepp: this.newissuedatepp,
    //     },
    //     width: '1200px',
    //     height: '1300px',
    //     maxWidth: '100%',
    //   });
    // }
    // else if (this.selectedReportType === 'datewise very Briefly') {
    //   this.dialog.open(RegistrationDatewiseVbrieflyComponent , {
    //     data: {
    //       type: this.selectedReportType,
    //       start_date: this.startDate_registrationReport,
    //       end_date: this.enddate_registrationReport,
    //       rep_name: repregreport,
    //       off_rep_name: offrepregreport,
    //       issue_cat: this.issueName,
    //       issueDates: this.getDates,
    //       newissuedatepp: this.newissuedatepp,
    //     },
    //     width: '1200px',
    //     height: '1300px',
    //     maxWidth: '100%',
    //   });
    // }
    else {
      this.dialog.open(RegistrationBrieflyRepresentativeComponent, {
        data: {
          type: this.selectedReportType,
          startDate: this.startDate_registrationReport,
          endDate: this.enddate_registrationReport,
          rep_name: repregreport,
          off_rep_name: offrepregreport,
          issue_cat: this.issueName,
          issueDates: this.getDates,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }

    //Previous Code
    // if (this.startDate_registrationReport == '') {
    //   this.startDate_registrationReport = '1800-01-01';
    // }
    // if (this.issueGranthName == '' && this.issueDates == '') {
    //   this.issueGranthName = 'xyz';
    //   this.issueDates = 'abc';
    // }
    // this.service
    //   .getAdvtRegistrationReports(
    //     this.startDate_registrationReport,
    //     this.enddate_registrationReport,
    //     this.issueGranthName,
    //     this.issueDates
    //   )
    //   .subscribe((data) => {
    //     // console.log(data);
    //     this.getAdvtDetailsReport = data;
    //   });
    // console.log('getAdvtDetailsReport', this.getAdvtDetailsReport);
  }

  //Rep Wise Registration Report :

  startDate_repregistrationReport = '';
  enddate_repregistrationReport = '';
  dateIsEnablerepReport = false;
  getChangedDateRepRegistrationReport() {
    if (
      this.RepwiseRegistrationreportRange.get('start').value != null &&
      this.RepwiseRegistrationreportRange.get('end').value != null
    ) {
      // console.log(this.RepwiseRegistrationreportRange.value);
      this.dateIsEnable = true;
      // console.log(
      //   formatDate(
      //     new Date(this.RepwiseRegistrationreportRange.get('start').value),
      //     'yyyy-MM-dd',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      // console.log(
      //   formatDate(
      //     new Date(this.RepwiseRegistrationreportRange.get('end').value),
      //     'dd-MM-yyyy',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      let startdate = formatDate(
        new Date(this.RepwiseRegistrationreportRange.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      let endDate = formatDate(
        new Date(this.RepwiseRegistrationreportRange.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.startDate_repregistrationReport = startdate;
      this.enddate_repregistrationReport = endDate;
    } else {
      this.dateIsEnableReport = false;
    }
  }

  rep_name_report = '';
  getRepNameReport(e) {
    // console.log(e);
    if (e.value == 'All') {
      this.rep_name_report = 'all';
    } else {
      this.rep_name_report = e.value;
    }
  }

  getAdvtDetailsRepReport = [];
  getAdvtRepRegistrationReport() {
    // console.log(
    //   this.startDate_repregistrationReport,
    //   this.enddate_repregistrationReport,
    //   this.rep_name_report
    // );
    if (this.startDate_repregistrationReport == '') {
      window.alert('Please select valid dates...!');
    } else if (this.rep_name_report == '') {
      window.alert('Please select valid Rep. Name...!');
    } else {
      this.service
        .getAdvtReportRepWise(
          this.startDate_repregistrationReport,
          this.enddate_repregistrationReport,
          this.rep_name_report
        )
        .subscribe((data) => {
          console.log(data);
          this.getAdvtDetailsRepReport = data;
        });
    }
  }

  financialYearStartDate;
  financialYearEndDate;
  getFinancialYearsDates(event) {
  debugger
    // console.log(event);
    this.financialYearStartDate = event.value['start'];
    this.financialYearEndDate = event.value['endd'];
  }

  testData = {
    key1: [1, 2],
    key2: [3, 4, 5],
  };

  bussinessReportData = [];
  abc = [];

  // getBussinessReport() {
  //   this.service
  //     .getAdvtBusinessReport(
  //       this.financialYearStartDate,
  //       this.financialYearEndDate
  //     )
  //     .subscribe((data) => {
  //       // console.log(data);
  //       for (let index = 0; index < Object.keys(data).length; index++) {
  //         // console.log(
  //         //   (data[index]['report_month'] == 'October',
  //         //   data[index]['total_amount'],
  //         //   0)
  //         // );

  //         if (index == 0) {
  //           this.bussinessReportData.push({
  //             rep_id: data[index]['rep_id'],
  //             rep_name: data[index]['rep_name'],
  //             district: data[index]['district'],
  //             taluka: data[index]['taluka'],
  //             April:
  //               data[index]['report_month'] == 'April'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             May:
  //               data[index]['report_month'] == 'May'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             June:
  //               data[index]['report_month'] == 'June'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             July:
  //               data[index]['report_month'] == 'July'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             August:
  //               data[index]['report_month'] == 'August'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             September:
  //               data[index]['report_month'] == 'September'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             October:
  //               data[index]['report_month'] == 'October'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             November:
  //               data[index]['report_month'] == 'November'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             December:
  //               data[index]['report_month'] == 'December'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             January:
  //               data[index]['report_month'] == 'January'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             February:
  //               data[index]['report_month'] == 'February'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             March:
  //               data[index]['report_month'] == 'March'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //           });
  //         } else if (data[index]['rep_id'] == data[index - 1]['rep_id']) {
  //           if (data[index]['district'] == data[index - 1]['district']) {
  //             if (data[index]['taluka'] == data[index - 1]['taluka']) {
  //               let dataIndex = this.bussinessReportData.findIndex(
  //                 (a) => a.rep_id == data[index]['rep_id']
  //               );
  //               let newabc = this.bussinessReportData.find(
  //                 (a) => a.rep_id == data[index]['rep_id']
  //               );
  //               // console.log(newabc);
  //               // console.log(this.bussinessReportData[dataIndex]);

  //               this.bussinessReportData[dataIndex] = {
  //                 rep_id: data[index]['rep_id'],
  //                 rep_name: data[index]['rep_name'],
  //                 district: data[index]['district'],
  //                 taluka: data[index]['taluka'],
  //                 April:
  //                   data[index]['report_month'] == 'April'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['April'],
  //                 May:
  //                   data[index]['report_month'] == 'May'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['May'],
  //                 June:
  //                   data[index]['report_month'] == 'June'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['June'],
  //                 July:
  //                   data[index]['report_month'] == 'July'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['July'],
  //                 August:
  //                   data[index]['report_month'] == 'August'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['August'],
  //                 September:
  //                   data[index]['report_month'] == 'September'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['September'],
  //                 October:
  //                   data[index]['report_month'] == 'October'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['October'],
  //                 November:
  //                   data[index]['report_month'] == 'November'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['November'],
  //                 December:
  //                   data[index]['report_month'] == 'December'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['December'],
  //                 January:
  //                   data[index]['report_month'] == 'January'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['January'],
  //                 February:
  //                   data[index]['report_month'] == 'February'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['February'],
  //                 March:
  //                   data[index]['report_month'] == 'March'
  //                     ? data[index]['total_amount']
  //                     : this.bussinessReportData[dataIndex]['March'],
  //               };
  //             } else {
  //               this.bussinessReportData.push({
  //                 rep_id: data[index]['rep_id'],
  //                 rep_name: data[index]['rep_name'],
  //                 district: data[index]['district'],
  //                 taluka: data[index]['taluka'],
  //                 April:
  //                   data[index]['report_month'] == 'April'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 May:
  //                   data[index]['report_month'] == 'May'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 June:
  //                   data[index]['report_month'] == 'June'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 July:
  //                   data[index]['report_month'] == 'July'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 August:
  //                   data[index]['report_month'] == 'August'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 September:
  //                   data[index]['report_month'] == 'September'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 October:
  //                   data[index]['report_month'] == 'October'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 November:
  //                   data[index]['report_month'] == 'November'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 December:
  //                   data[index]['report_month'] == 'December'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 January:
  //                   data[index]['report_month'] == 'January'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 February:
  //                   data[index]['report_month'] == 'February'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //                 March:
  //                   data[index]['report_month'] == 'March'
  //                     ? data[index]['total_amount']
  //                     : 0,
  //               });
  //             } //end of taluka
  //           } else {
  //             this.bussinessReportData.push({
  //               rep_id: data[index]['rep_id'],
  //               rep_name: data[index]['rep_name'],
  //               district: data[index]['district'],
  //               taluka: data[index]['taluka'],
  //               April:
  //                 data[index]['report_month'] == 'April'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               May:
  //                 data[index]['report_month'] == 'May'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               June:
  //                 data[index]['report_month'] == 'June'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               July:
  //                 data[index]['report_month'] == 'July'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               August:
  //                 data[index]['report_month'] == 'August'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               September:
  //                 data[index]['report_month'] == 'September'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               October:
  //                 data[index]['report_month'] == 'October'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               November:
  //                 data[index]['report_month'] == 'November'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               December:
  //                 data[index]['report_month'] == 'December'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               January:
  //                 data[index]['report_month'] == 'January'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               February:
  //                 data[index]['report_month'] == 'February'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //               March:
  //                 data[index]['report_month'] == 'March'
  //                   ? data[index]['total_amount']
  //                   : 0,
  //             });
  //           } //end of district
  //         } else {
  //           this.bussinessReportData.push({
  //             rep_id: data[index]['rep_id'],
  //             rep_name: data[index]['rep_name'],
  //             district: data[index]['district'],
  //             taluka: data[index]['taluka'],
  //             April:
  //               data[index]['report_month'] == 'April'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             May:
  //               data[index]['report_month'] == 'May'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             June:
  //               data[index]['report_month'] == 'June'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             July:
  //               data[index]['report_month'] == 'July'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             August:
  //               data[index]['report_month'] == 'August'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             September:
  //               data[index]['report_month'] == 'September'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             October:
  //               data[index]['report_month'] == 'October'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             November:
  //               data[index]['report_month'] == 'November'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             December:
  //               data[index]['report_month'] == 'December'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             January:
  //               data[index]['report_month'] == 'January'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             February:
  //               data[index]['report_month'] == 'February'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //             March:
  //               data[index]['report_month'] == 'March'
  //                 ? data[index]['total_amount']
  //                 : 0,
  //           });
  //         }
  //       }
  //       // console.log(this.bussinessReportData);
  //     });
  // }

monthColumns = ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"];

transformedData: any[] = [];

getBussinessReport() {
  const rawStart = this.BusinessReportForm.value.start;
  const rawEnd = this.BusinessReportForm.value.end;

  const startDate = this.formatDateForPhp(rawStart);
  const endDate = this.formatDateForPhp(rawEnd);

  this.service.getAdvtBusinessReport(startDate, endDate)
    .subscribe((data: any[]) => {
      this.transformReport(data); // ✅ was wrongly calling transformBusinessData()
    });
}

transformReport(data: any[]) {
  const repMap: { [key: string]: any } = {};

  data.forEach(item => {
    const id = item.rep_id;
    if (!repMap[id]) {
      repMap[id] = {
        rep_name: item.rep_name,
        district: item.district,
        taluka: item.taluka,
        months: {}
      };
    }
    const monthName = item.report_month.split(' ')[0]; // "April 2025" → "April"
    repMap[id].months[monthName] = item.total_amount;
  });

  this.transformedData = Object.values(repMap);
}

// Helper function to handle different date formats
formatDateForPhp(date: any): string {
  if (!date) return '';
  
  // If it's already a string in YYYY-MM-DD, just return it
  if (typeof date === 'string' && date.includes('-')) return date;

  // If it's a JS Date object
  const d = new Date(date);
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  const year = d.getFullYear();

  return `${year}-${month}-${day}`;
}

  // Helper method to transform the data
transformBusinessData(data: any[]) {
  const grouped: any = {};

  // Map English response from PHP to your Marathi HTML keys
  const monthMap: { [key: string]: string } = {
    'April': 'एप्रिल',
    'May': 'मे',
    'June': 'जून',
    'July': 'जुलै',
    'August': 'ऑगस्ट',
    'September': 'सप्टेंबर',
    'October': 'ऑक्टोबर',
    'November': 'नोव्हेंबर',
    'December': 'डिसेंबर',
    'January': 'जानेवारी',
    'February': 'फेब्रुवारी',
    'March': 'मार्च'
  };

  data.forEach(item => {
    // Unique key to group records by representative and location
    const key = `${item.rep_id}_${item.district}_${item.taluka}`;

    if (!grouped[key]) {
      grouped[key] = {
        rep_name: item.rep_name,
        district: item.district,
        taluka: item.taluka,
        'एप्रिल': 0, 'मे': 0, 'जून': 0, 'जुलै': 0, 'ऑगस्ट': 0, 'सप्टेंबर': 0,
        'ऑक्टोबर': 0, 'नोव्हेंबर': 0, 'डिसेंबर': 0, 'जानेवारी': 0, 'फेब्रुवारी': 0, 'मार्च': 0
      };
    }

    // Get the Marathi month name from our map
    const marathiMonth = monthMap[item.report_month];
    
    if (marathiMonth) {
      grouped[key][marathiMonth] += parseFloat(item.total_amount);
    }
  });

  return Object.values(grouped);
}

  // Alternative: If you want to maintain the original structure more closely
  private transformBusinessDataAlternative(data: any[]): any[] {
    const result: any[] = [];
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March'
    ];

    data.forEach((record, index) => {
      const currentKey = `${record.rep_id}_${record.district}_${record.taluka}`;

      // Find if this combination already exists in result
      const existingIndex = result.findIndex(item =>
        item.rep_id === record.rep_id &&
        item.district === record.district &&
        item.taluka === record.taluka
      );

      if (existingIndex === -1) {
        // Create new entry
        const newEntry: any = {
          rep_id: record.rep_id,
          rep_name: record.rep_name,
          district: record.district,
          taluka: record.taluka
        };

        // Initialize all months
        months.forEach(month => {
          newEntry[month] = (record.report_month === month) ? record.total_amount : 0;
        });

        result.push(newEntry);
      } else {
        // Update existing entry
        if (record.report_month && months.includes(record.report_month)) {
          result[existingIndex][record.report_month] = record.total_amount;
        }
      }
    });

    return result;
  }

  getDatesPatrak;
  getAdvtDatesPatrak(e) {
    this.getDatesPatrak = e.value;
    // console.log('getDatesPatrak', this.getDatesPatrak);
  }

  advt_names1 = '';
  getAdvtName(event) {
    this.advt_names1 = event.value;
  }

  reportType = '';
  getReportType(event) {
    // console.log(event.value);
    this.reportType = event.value;
  }

  pageType = '';
  getPagewise(event) {
    this.pageType = event.value;
  }
  AmtType = '';
  getAmtwise(event) {
    this.AmtType = event.value;
  }

 
  tiktype = '';
  gettikwise(event){
    this.tiktype = event.value;
  }




  prasiddhiPatrak = [];
  getPrasiddhiPatrak
    () {
    // let patrakDate = this.getDatesPatrak;
    if (this.reportType === 'Report') {
      debugger
      this.dialog.open(PrasiddhipatrakComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name,
          value: this.tiktype,

        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.reportType === 'Browse') {
      this.dialog.open(PrasiddhipatrakbrowseComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name
        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.reportType === 'Address') {
      this.dialog.open(PrasiddhiPatrakAddressComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name,
          address: this.address,
          pincode: this.pincode,
          country: this.country,
          state: this.state,
          taluka: this.taluka,
        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.reportType === 'Represantative') {
      this.dialog.open(RepresentativeAddressListComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name,
          address: this.address,
          pincode: this.pincode,
          country: this.country,
          state: this.state,
          taluka: this.taluka,
        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.reportType === 'AddressList') {
      this.dialog.open(PrasiddhiPatrakListComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name,
          address: this.address,
          pincode: this.pincode,
          country: this.country,
          state: this.state,
          taluka: this.taluka,
        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.reportType === 'RepresantativeList') {
      this.dialog.open(PrasiddhiPatrakRepresentaiveListComponent, {
        data: {
          start_date: this.startDate_PrasiddhiPatrak,
          end_date: this.enddate_PrasiddhiPatrak,
          advt_name: this.advt_names1,
          // rep_name: this.repname,
          rep_name: this.repregreport,
          off_rep_name: this.offrepname,
          issue_category: this.issueName,
          issue_date: this.getDates,
          val: this.pageType,
          val1: this.AmtType,
          issuenamenew: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
          cust_name: this.cust_name,
          address: this.address,
          pincode: this.pincode,
          country: this.country,
          state: this.state,
          taluka: this.taluka,
        },
        width: '1300px',
        height: '1300px',
        maxWidth: '100%',
      });
    }

    // this.service
    //   .getAdvtPrasiddhiPatrak(this.issueName, this.getDatesPatrak)
    //   .subscribe((data) => {
    //     // console.log(data);

    //     for (let index = 0; index < Object.keys(data).length; index++) {
    //       this.prasiddhiPatrak.push({
    //         advt_id: data[index]['advt_id'],
    //         advt_person_name: data[index]['advt_person_name'],
    //         cust_name: data[index]['cust_name'],
    //         advt_size: data[index]['advt_size'],
    //         advt_page: [
    //           data[index]['page_no'].split(',')[
    //             data[index]['published_date']
    //               .split(',')
    //               .findIndex((a) => a == patrakDate)
    //           ]
    //             ? data[index]['page_no'].split(',')[
    //                 data[index]['published_date']
    //                   .split(',')
    //                   .findIndex((a) => a == patrakDate)
    //               ]
    //             : '',
    //         ],
    //         comment: data[index]['comment'],
    //       });
    //     }
    //   });
  }

  pp_advt_names = [];
  pp_off_rep_names = [];
  pp_rep_names = [];
  getPrasiddhiPatrakNamesData() {
    this.pp_advt_names = [];
    this.pp_off_rep_names = [];
    this.pp_rep_names = [];
    this.service.getPrasiddhiPatrakOff_Rep_and_advt_name().subscribe((res) => {
      // console.log(res);
      for (let index = 0; index < res.length; index++) {
        this.pp_advt_names.push({
          advt_name: res[index]['name'],
        });

        this.pp_off_rep_names.push({
          off_rep_name: res[index]['off_rep_name'],
        });

        this.pp_rep_names.push({
          rep_name: res[index]['rep_name'],
        });
      }

      this.pp_advt_names = this.uniqueid(
        this.pp_advt_names,
        (a) => a.advt_name
      );

      this.pp_off_rep_names = this.uniqueid(
        this.pp_off_rep_names,
        (a) => a.off_rep_name
      );

      this.pp_rep_names = this.uniqueid(this.pp_rep_names, (a) => a.rep_name);
    });
  }

  imageChange = false;
  ImageUploads(event) {
    // console.log(event.target.value);
    if (event.target.value == '') {
      this.imageChange = false;
    } else {
      this.imageChange = true;
    }
  }

  getadvtinvoiceStartDate;
  getadvtinvoiceEndDate;
  getAdvtDateRange() {
    if (
      this.AdvtGeneratedInvoice.get('start').value != null &&
      this.AdvtGeneratedInvoice.get('end').value != null
    ) {
      // console.log(this.AdvtGeneratedInvoice.value);
      // console.log(
      //   formatDate(
      //     new Date(this.AdvtGeneratedInvoice.get('start').value),
      //     'yyyy-MM-dd',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      // console.log(
      //   formatDate(
      //     new Date(this.AdvtGeneratedInvoice.get('end').value),
      //     'dd-MM-yyyy',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      this.getadvtinvoiceStartDate = formatDate(
        new Date(this.AdvtGeneratedInvoice.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getadvtinvoiceEndDate = formatDate(
        new Date(this.AdvtGeneratedInvoice.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  isGSTInvoice = 'N';
  displaygstNumberInput = false;
  getInvoiceType(event) {
    this.isGSTInvoice = event.value;
    if (this.isGSTInvoice == 'Y') {
      this.displaygstNumberInput = true;
    } else {
      this.displaygstNumberInput = false;
    }
  }

  getGstNumber(gst) {
    this.gstNumber = gst;
  }

  reset_cust_mobile() {
    this.cust_mobile = '';
  }

  //Advt details :
  get_cust_advt_id(advt_id) {
    // console.log(this.advt_id);
    this.reset_cust_mobile();
  }

  reset_advt_id() {
    this.advt_id = '';
  }

  getcust_advt_mobile(mobile) {
    // console.log(mobile);
    //this.cust_id = ''
    // console.log(this.advt_mobile.length);
    this.reset_advt_id();
  }

  reset_advt_mobile() {
    this.advt_mobile = '';
  }

  readAdvtInvoice() {
    this.service
      .getCustInvoicesadvt(
        this.getadvtinvoiceStartDate,
        this.getadvtinvoiceEndDate
      )
      .subscribe((data) => {
        console.log(data);
        this.AdvtInvoiceData = data;
      });
  }

  ViewAdvtInvoice(advt) {
    // console.log(advt);

    let prepareCust = {
      cust_id: advt['id'],
      name: advt['name'],
      mobile: advt['mobile'],
      address: advt['address'],
      invoice_amount: parseInt(advt['invoice_total']),
      cgst: parseInt(advt['cgst']),
      sgst: parseInt(advt['sgst']),
      igst: parseInt(advt['igst']),
      taxable_amount: parseInt(advt['taxable_amount']),
      total_amount: parseInt(advt['total_amount']),
      total_discount: parseInt(advt['total_discount']),
      discounted_price: parseInt(advt['discounted_price']),
      gst_no: advt['gst_no'],
      invoice_id: advt['invoice_id'],
      invoice_date: advt['invoice_date'],
    };

    let prepareAdvt = [];
    this.service
      .getadvtInvoiceData(parseInt(advt['invoice_id']))
      .subscribe((advt_data) => {
        for (let index = 0; index < Object.keys(advt_data).length; index++) {
          prepareAdvt.push({
            issue_name: advt_data[index]['advt_name'],
            publish_date: advt_data[index]['published_date'],
            publish_page: advt_data[index]['page_number'],
            advt_size: advt_data[index]['advt_size'],
          });
        }
      });

    // console.log(prepareAdvt);
    //console.log(this.getRepSelectedBookslist)
    this.invoiceDetails = {
      rep: prepareCust,
      advts: prepareAdvt,
      GST: 'Y',
      GST_no: advt['gst_no'],
    };
    this.viewmode = true;
    this.repInvoice = 'N';

    this.dialog.open(AdvertisementInvoiceComponent, {
      data: {
        book: this.invoiceDetails,
        view: this.viewmode,
        rep_invoice: this.repInvoice,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  /*name of the excel-file which will be downloaded. */
  fileName = 'ExcelSheet.xlsx';

  exportexcel1(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  getAdvtInvoice() {
    let prepareCust = {
      cust_id: this.getAdvtPersonDetail[0]['advt_id'],
      name: this.getAdvtPersonDetail[0]['name'],
      mobile: this.getAdvtPersonDetail[0]['mobile'],
      address:
        this.getAdvtPersonDetail[0]['address'] +
        ',' +
        this.getAdvtPersonDetail[0]['taluka'] +
        ',' +
        this.getAdvtPersonDetail[0]['district'] +
        ',' +
        this.getAdvtPersonDetail[0]['state'] +
        ',' +
        this.getAdvtPersonDetail[0]['country'],
      advt_amount: parseInt(this.getAdvtPersonDetail[0]['advt_amount']),
      advt_discount: parseInt(this.getAdvtPersonDetail[0]['advt_discount']),
      cgst: parseInt(this.getAdvtPersonDetail[0]['cgst']),
      sgst: parseInt(this.getAdvtPersonDetail[0]['sgst']),
      igst: parseInt(this.getAdvtPersonDetail[0]['igst']),
      part_amount: parseInt(this.getAdvtPersonDetail[0]['DS_partAmount']),
      remaining_amount: parseInt(
        this.getAdvtPersonDetail[0]['DS_remainingAmount']
      ),
    };

    let prepareAdvt = [];
    for (
      let index = 0;
      index < Object.keys(this.getAdvertisement).length;
      index++
    ) {
      let issue_name = this.getAdvertisement[index]['issue_name'];
      let issue_date =
        this.getAdvertisement[index]['published_dates'].split(',');
      let issue_pages =
        this.getAdvertisement[index]['published_pages'].split(',');
      let advt_size = this.getAdvertisement[index]['advt_size'];

      if (issue_date.length == 0) {
        window.alert(issue_name + ' does not have publishing dates / pages.');
      } else {
        for (
          let index1 = 0;
          index1 < Object.keys(issue_date).length;
          index1++
        ) {
          prepareAdvt.push({
            issue_name: issue_name,
            publish_date: issue_date[index1],
            publish_page: issue_pages[index1],
            advt_size: advt_size,
          });
        }
      }
    }

    // console.log(prepareAdvt);
    //console.log(this.getRepSelectedBookslist)
    this.invoiceDetails = {
      rep: prepareCust,
      advts: prepareAdvt,
      GST: this.isGSTInvoice,
      GST_no: this.gstNumber,
    };
    this.viewmode = false;
    this.repInvoice = 'N';

    this.dialog.open(AdvertisementInvoiceComponent, {
      data: {
        book: this.invoiceDetails,
        view: this.viewmode,
        rep_invoice: this.repInvoice,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  allSelectedISN = false;
  @ViewChild('isn')
  skillSelISN!: MatSelect;
  toggleAllSelectionISN() {
    this.allSelectedISN = !this.allSelectedISN; // to control select-unselect
    // console.log(this.skillSelISN.options);
    if (this.allSelectedISN) {
      this.skillSelISN.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelISN.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelISN.close();
  }

  allSelectedtable = false;
  someComplete(): boolean {
    if (this.advtInvoiceList == null) {
      return false;
    }
    return (
      this.advtInvoiceList.filter((t) => t.is_selected).length > 0 &&
      !this.allSelectedtable
    );
  }
  allSelectedtable1 = false;
  someComplete1(): boolean {
    if (this.advtInvoiceList == null) {
      return false;
    }
    return (
      this.advtInvoiceList.filter((t) => t.is_selected).length > 0 &&
      !this.allSelectedtable1
    );
  }

  printAdvtInvoice() {
    // console.log(this.advtInvoiceList.filter((t) => t.is_selected));
    let data = this.advtInvoiceList.filter((t) => t.is_selected);
    this.openAdvtInvoice(data);
  }

  updateAllComplete() {
    this.allSelectedtable =
      this.advtInvoiceList != null &&
      this.advtInvoiceList.every((t) => t.is_selected);
  }

  setAll(completed: boolean) {
    debugger;
    this.allSelectedtable = completed;
    if (this.advtInvoiceList == null) {
      return;
    }
    this.advtInvoiceList.forEach((t) => (t.is_selected = completed));
  }




  getData;
  stringdata;
  getISN(e) {
    // console.log(e.value.toString());
    this.getData = e.value;
    this.getData = this.getData.filter((a) => a != 'all');
    this.stringdata = this.getData.toString();
  }

  getRepName(event) { }

  toInt(no) {
    return parseInt(no);
  }

  filteredinDetailsRegReport;
  addFilters() {
    // console.log('call addFilters');

    if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport != '' &&
      this.offrepregreport != '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.repregreport.includes(a['rep_name']) &&
          this.offrepregreport.includes(a['off_rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport == '' &&
      this.offrepregreport != '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      console.log('excluded repname Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.offrepregreport.includes(a['off_rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport != '' &&
      this.offrepregreport == '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('excluded offrepname Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.repregreport.includes(a['rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport != '' &&
      this.offrepregreport != '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('excluded offrepname Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.repregreport.includes(a['rep_name']) &&
          this.offrepregreport.includes(a['off_rep_name'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport == '' &&
      this.offrepregreport == '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('excluded repname and offrepname Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport == '' &&
      this.offrepregreport != '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.offrepregreport.includes(a['off_rep_name'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport != '' &&
      this.offrepregreport == '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport &&
          this.repregreport.includes(a['rep_name'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport != '' &&
      this.enddate_registrationReport != '' &&
      this.repregreport == '' &&
      this.offrepregreport == '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      console.log('just datewise Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.startDate_registrationReport &&
          a['booking_date'] <= this.enddate_registrationReport
        );
      });
      console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport != '' &&
      this.offrepregreport != '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.repregreport.includes(a['rep_name']) &&
          this.offrepregreport.includes(a['off_rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport != '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.offrepregreport.includes(a['off_rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport != '' &&
      this.offrepregreport == '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.repregreport.includes(a['rep_name']) &&
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport != '' &&
      this.offrepregreport != '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.repregreport.includes(a['rep_name']) &&
          this.offrepregreport.includes(a['off_rep_name'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport == '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport != '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.offrepregreport.includes(a['off_rep_name']);
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport != '' &&
      this.offrepregreport == '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.repregreport.includes(a['rep_name']);
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport != '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.offrepregreport.includes(a['off_rep_name']);
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport == '' &&
      this.issueName != '' &&
      this.getDates != ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issueName &&
          this.getDates.includes(a['issue_date'])
        );
      });
      // console.log(this.filteredinDetailsRegReport);
    } else if (
      this.startDate_registrationReport == '' &&
      this.enddate_registrationReport == '' &&
      this.repregreport == '' &&
      this.offrepregreport == '' &&
      this.issueName == '' &&
      this.getDates == ''
    ) {
      // console.log('all Filters');
      this.filteredinDetailsRegReport = this.inDetailsRegReport;
      // console.log(this.filteredinDetailsRegReport);
    }
    console.log(this.filteredinDetailsRegReport);
    this.filtersCalculateData();
  }

  filtersCalculateData() {
    this.inDetailsRegReportTotal = {
      total_advt: 0,
      advt_total: 0,
      net_amt: 0,
      gst: 0,
      total_amt: 0,
      rcvd_amt: 0,
      pndg_amt: 0,
    };
    this.inDetailsRegReportTotal.total_advt =
      this.filteredinDetailsRegReport.length;
    for (
      let index = 0;
      index < this.filteredinDetailsRegReport.length;
      index++
    ) {
      this.inDetailsRegReportTotal.net_amt += parseInt(
        this.filteredinDetailsRegReport[index]['total_amount']
      );
      this.inDetailsRegReportTotal.advt_total += parseInt(
        this.filteredinDetailsRegReport[index]['advt_amt']
      );
      this.inDetailsRegReportTotal.gst += parseInt(
        this.filteredinDetailsRegReport[index]['sgst']
      );
      this.inDetailsRegReportTotal.gst += parseInt(
        this.filteredinDetailsRegReport[index]['cgst']
      );
      this.inDetailsRegReportTotal.total_amt += parseInt(
        this.filteredinDetailsRegReport[index]['amount']
      );
      this.inDetailsRegReportTotal.rcvd_amt += parseInt(
        this.filteredinDetailsRegReport[index]['part_pymt_amt']
      );
      this.inDetailsRegReportTotal.pndg_amt += parseInt(
        this.filteredinDetailsRegReport[index]['part_pymt_remaning_amt']
      );
    }
  }

  getRegReportData() {

    debugger

    const req: any = {
      "rep_name": this.RegistrationreportRange.value.repname,
      "start_date": this.RegistrationreportRange.value.start,
      "end_date": this.RegistrationreportRange.value.end,
      "off_rep_name": this.RegistrationreportRange.value.offrepname,
      "issue_name": this.RegistrationreportRange.value.issuename,
      "issue_date": this.RegistrationreportRange.value.issuedate
    }

    // {
    //   "start_date":"2021-01-01",
    //   "end_date":"2025-12-31",
    //   "rep_name":["कार्यालय ( पुस्तक विभाग )"],
    //   "off_rep_name":["ALL"],
    //   "issue_name":["ALL"],
    //   "issue_date":["29/10/2023,विवेक साप्ताहिक,22/10/2023"]
    //   }

    this.service.getRegReportInDetails().subscribe((data) => {
      this.inDetailsRegReport = data;
      console.log(this.inDetailsRegReport);
      this.addFilters();

      // this.inDetailsRegReportTotal = {
      //   total_advt: 0,
      //   advt_total: 0,
      //   net_amt: 0,
      //   gst: 0,
      //   total_amt: 0,
      //   rcvd_amt: 0,
      //   pndg_amt: 0,
      // };
      // this.inDetailsRegReportTotal.total_advt = this.inDetailsRegReport.length;
      // for (let index = 0; index < this.inDetailsRegReport.length; index++) {
      //   this.inDetailsRegReportTotal.net_amt += parseInt(
      //     this.inDetailsRegReport[index]['total_amount']
      //   );
      //   this.inDetailsRegReportTotal.advt_total += parseInt(
      //     this.inDetailsRegReport[index]['advt_amt']
      //   );
      //   this.inDetailsRegReportTotal.gst += parseInt(
      //     this.inDetailsRegReport[index]['sgst']
      //   );
      //   this.inDetailsRegReportTotal.gst += parseInt(
      //     this.inDetailsRegReport[index]['cgst']
      //   );
      //   this.inDetailsRegReportTotal.total_amt += parseInt(
      //     this.inDetailsRegReport[index]['amount']
      //   );
      //   this.inDetailsRegReportTotal.rcvd_amt += parseInt(
      //     this.inDetailsRegReport[index]['part_pymt_amt']
      //   );
      //   this.inDetailsRegReportTotal.pndg_amt += parseInt(
      //     this.inDetailsRegReport[index]['part_pymt_remaning_amt']
      //   );
      // }
    });
  }

  inDetailsRegReportsubTotalData = [];
  tempdata;
  getReportDatewiseBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueid(
        this.inDetailsRegReport,
        (a) => a.booking_date
      );
      this.inDetailsRegReportsubTotalData = [];
      // console.log('why', tempData);
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.inDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          date: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        inDetailsRegReportsubTotal.date = arr[0]['booking_date'];
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseInt(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseInt(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseInt(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseInt(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseInt(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
      // console.log(this.inDetailsRegReportsubTotalData);
    }
  }

  inDetailsDatewise() {
    this.getRegReportData();
    setTimeout(() => {
      this.getReportDatewise();
    }, 200);
  }

  getReportDatewise() {
    if (this.filteredinDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueid(
        this.filteredinDetailsRegReport,
        (a) => a.booking_date
      );
      this.inDetailsRegReportsubTotalData = [];
      // console.log('why', tempData);
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.filteredinDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseInt(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseInt(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseInt(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseInt(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseInt(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
      }
    }
  }

  addadvtCNrcpt() {
    console.log(this.contractReportRepName, this.advtCreditNoteform.value.advtname)
    console.log(this.advtCreditNoteform.value)

    const req1 = {
      advt_name: this.advtCreditNoteform.value.advtname
    }
    const req2 = {
      advt_name1: this.advtCreditNoteform.value.advtname,
      cr_vocher: this.advtCreditNoteform.value.crdtvno,
      create_date: this.advtCreditNoteform.value.date,
      receipt_date: this.advtCreditNoteform.value.recptdate,
      rep_name: this.contractReportRepName,
      credit_count: this.newg
    }
    this.service.getCreditNoteMain(req1).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.advtCreditNote = (data as any);;
      // this.ngOnInit();
    });

    console.log("req2", req2)

  }

  addadvtCNrcpt1() {
    console.log(this.contractReportRepName, this.advtAdvanceStampform.value.advtname)
    console.log(this.advtAdvanceStampform.value)

    const req1 = {
      advt_name: this.advtAdvanceStampform.value.advtname
    }
    // const req2 = {
    //   advt_name1: this.advtCreditNoteform.value.advtname,
    //   cr_vocher: this.advtCreditNoteform.value.crdtvno,
    //   create_date: this.advtCreditNoteform.value.date,
    //   receipt_date: this.advtCreditNoteform.value.recptdate,
    //   rep_name: this.contractReportRepName,
    //   credit_count: this.newg
    // }
    this.service.getCreditNoteMain(req1).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.advtCreditNote = (data as any);;
      // this.ngOnInit();
    });

    console.log("req1 for stamp", req1)

  }



  calculateTotal(data) {
    this.inDetailsOffRegReportTotal.total_advt = 0;
    this.inDetailsOffRegReportTotal.net_amt = 0;
    this.inDetailsOffRegReportTotal.advt_total = 0;
    this.inDetailsOffRegReportTotal.gst = 0;
    this.inDetailsOffRegReportTotal.total_amt = 0;
    this.inDetailsOffRegReportTotal.rcvd_amt = 0;
    this.inDetailsOffRegReportTotal.pndg_amt = 0;
    this.inDetailsOffRegReportTotal.total_advt = data.length;
    for (let index = 0; index < data.length; index++) {
      this.inDetailsOffRegReportTotal.net_amt += parseInt(
        data[index]['total_amount']
      );
      this.inDetailsOffRegReportTotal.advt_total += parseInt(
        data[index]['advt_amt']
      );
      this.inDetailsOffRegReportTotal.gst += parseInt(data[index]['sgst']);
      this.inDetailsOffRegReportTotal.gst += parseInt(data[index]['cgst']);
      this.inDetailsOffRegReportTotal.total_amt += parseInt(
        data[index]['amount']
      );
      this.inDetailsOffRegReportTotal.rcvd_amt += parseInt(
        data[index]['part_pymt_amt']
      );
      this.inDetailsOffRegReportTotal.pndg_amt += parseInt(
        data[index]['part_pymt_remaning_amt']
      );
    }
  }

  getReportOffRepVeryBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.offrepregreport.includes(a.off_rep_name);
      });
      this.inDetailsRegReportsubTotalData = [];
      this.calculateTotal(this.tempdata);

      let data = this.uniqueid(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          off_rep_name: '',
          rep_name: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.off_rep_name = arr[index]['off_rep_name'];
          inDetailsRegReportsubTotal.rep_name = arr[index]['rep_name'];
          inDetailsRegReportsubTotal.net_amt += parseInt(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseInt(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseInt(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseInt(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseInt(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        // arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
    }
  }

  getReportInDetailOffRep() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = [];
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.offrepregreport.includes(a.off_rep_name);
      });

      this.inDetailsRegReportsubTotalData = [];
      this.calculateTotal(this.tempdata);

      let data = this.uniqueid(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseInt(
            arr[index]['total_amount']
          );
          inDetailsRegReportsubTotal.advt_total += parseInt(
            arr[index]['advt_amt']
          );
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseInt(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseInt(
            arr[index]['amount']
          );
          inDetailsRegReportsubTotal.rcvd_amt += parseInt(
            arr[index]['part_pymt_amt']
          );
          inDetailsRegReportsubTotal.pndg_amt += parseInt(
            arr[index]['part_pymt_remaning_amt']
          );
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
      }
    }
  }

  startDate_contract;
  enddate_contract;
  getChangedDateContract() {
    if (
      this.contractDetailsForm.get('start').value != null &&
      this.contractDetailsForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.contractDetailsForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.contractDetailsForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }


    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.contractDetailsForm.get('start')?.setValue(null);
      this.contractDetailsForm.get('end')?.setValue(null);
    }
  }

  getChangedDateContractM1() {
    if (
      this.PaymentReceiptRegister.get('start').value != null &&
      this.PaymentReceiptRegister.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.PaymentReceiptRegister.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.PaymentReceiptRegister.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }


    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.PaymentReceiptRegister.get('start')?.setValue(null);
      this.PaymentReceiptRegister.get('end')?.setValue(null);
    }

  }



  getChangedDateContractpending() {
    const start = this.PendingCreditVoucher.get('start')?.value;
    const end = this.PendingCreditVoucher.get('end')?.value;

    if (start && end) {
      this.startDate_contract = formatDate(new Date(start), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
      this.enddate_contract = formatDate(new Date(end), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

      const selectedDate = new Date(this.startDate_contract);
      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      if (selectedDate < min || selectedDate > max) {
        alert('Date is outside the allowed range.');
        this.PendingCreditVoucher.get('start')?.setValue(null);
        this.PendingCreditVoucher.get('end')?.setValue(null);
        return;
      }
    this.getAllVouchers(this.startDate_contract, this.enddate_contract);

    }
  }


  getChangedDateContractCommisionpending() {
    const start = this.advtcommForm.get('start')?.value;
    const end = this.advtcommForm.get('end')?.value;
    const repname = this.advtcommForm.get('repname')?.value;

    if (start && end) {
      this.startDate_contract = formatDate(new Date(start), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
      this.enddate_contract = formatDate(new Date(end), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

      const selectedDate = new Date(this.startDate_contract);
      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      if (selectedDate < min || selectedDate > max) {
        alert('Date is outside the allowed range.');
        this.advtcommForm.get('start')?.setValue(null);
        this.advtcommForm.get('end')?.setValue(null);
        return;
      }

      // ✅ FIXED: Use the formatted date variables
      this.getAllCommVouchers(this.startDate_contract, this.enddate_contract, repname);
    }
  }

  getChangedDateContractM11() {

    if (
      this.advtbillFormsecond.get('start').value != null &&
      this.advtbillFormsecond.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.start = formatDate(
        new Date(this.advtbillFormsecond.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.end = formatDate(
        new Date(this.advtbillFormsecond.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.advtbillFormsecond.get('start')?.setValue(null);
      this.advtbillFormsecond.get('end')?.setValue(null);
    }


    // this.getAllAdvtInovicesData()
  }


  // getChangedDateContractC1() {
  //   if (
  //     this.CreditReport1.get('start').value != null &&
  //     this.CreditReport1.get('end').value != null
  //   ) {
  //     // console.log(this.contractDetailsForm.value);
  //     this.startDate_contract = formatDate(
  //       new Date(this.CreditReport1.get('start').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );
  //     this.enddate_contract = formatDate(
  //       new Date(this.CreditReport1.get('end').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );
  //   }
  // }
  getChangedDateContractM2() {
    if (
      this.CreditNoteForm.get('start').value != null &&
      this.CreditNoteForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.CreditNoteForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.CreditNoteForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }


    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.CreditNoteForm.get('start')?.setValue(null);
      this.CreditNoteForm.get('end')?.setValue(null);
    }
  }

  getChangedDateContractM3() {
    if (
      this.OutStandingForm.get('start').value != null &&
      this.OutStandingForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.OutStandingForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.OutStandingForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.OutStandingForm.get('start')?.setValue(null);
      this.OutStandingForm.get('end')?.setValue(null);
    }
  }
  getChangedDateContractM4() {
    if (
      this.GSTFullReportForm.get('start').value != null &&
      this.GSTFullReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.GSTFullReportForm.get('start')?.setValue(null);
      this.GSTFullReportForm.get('end')?.setValue(null);
    }
  }
  getChangedDateContractM7() {

    if (
      this.PersonalNoteform.get('start').value != null &&
      this.PersonalNoteform.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.PersonalNoteform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.PersonalNoteform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.PersonalNoteform.get('start')?.setValue(null);
      this.PersonalNoteform.get('end')?.setValue(null);
    }
  }
  getChangedDateContractM8() {
    if (
      this.GSTFullReportForm.get('start').value != null &&
      this.GSTFullReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }
  getChangedDateContractM5() {
    if (
      this.CommissionReportForm.get('start').value != null &&
      this.CommissionReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.CommissionReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.CommissionReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.CommissionReportForm.get('start')?.setValue(null);
      this.CommissionReportForm.get('end')?.setValue(null);
    }
  }



  getChangedDateContractBusiness() {
    if (
      this.BusinessReportForm.get('start').value != null &&
      this.BusinessReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.BusinessReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.BusinessReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.BusinessReportForm.get('start')?.setValue(null);
      this.BusinessReportForm.get('end')?.setValue(null);
    }
  }




  getChangedDateContractAddress() {
    if (
      this.AddressForm.get('start').value != null &&
      this.AddressForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.AddressForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.AddressForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.AddressForm.get('start')?.setValue(null);
      this.AddressForm.get('end')?.setValue(null);
    }
  }

  getChangedDateAdvtRemainder() {
    if (
      this.Sendreminderform.get('startDate').value != null &&
      this.Sendreminderform.get('endDate').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.Sendreminderform.get('startDate').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.Sendreminderform.get('endDate').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.startDate_contract);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    // if (selectedDate < min || selectedDate > max) {
    //   alert('Date is outside the allowed range.');
    //   this.Sendreminderform.get('start')?.setValue(null);
    //   // this.Sendreminderform.get('end')?.setValue(endDate);
    // }
  }


  // startDate_contract;
  // enddate_contract_payment;
  // getChangedDatePaymentRegi() {
  //   if (
  //     this.contractDetailsForm.get('start').value != null &&
  //     this.contractDetailsForm.get('end').value != null
  //   ) {
  //     // console.log(this.contractDetailsForm.value);
  //     this.startDate_contract = formatDate(
  //       new Date(this.contractDetailsForm.get('start').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );
  //     this.enddate_contract = formatDate(
  //       new Date(this.contractDetailsForm.get('end').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );
  //   }
  // } 
  contractReportRepName = '';
  getContractRepName(event) {
    this.contractReportRepName = event.value;
  }


  contractReportOffRepName = '';
  getContractOffRepName(event) {
    this.contractReportOffRepName = event.value;
  }
  getRepNames(event: any) {
    if (event.target.value != "") {
      this.filterrep = this.GetOffRep.filter((data: any) =>
        data.rep_name.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else {
      this.filterrep = this.GetOffRep
    }
  }
  getIssuedateNames(event: any) {

    if (event.target.value != "") {

      this.filterissuedate = this.getMagIssueDatesandAdvtNames1.filter((data: any) =>
        data.issueDate.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else {
      this.filterissuedate = this.getMagIssueDatesandAdvtNames1
    }

  }
  setissueDate(date: any) {
    this.Advtremainingamt.patchValue({
      issuedate: date,
      issueDate: date

    })
  }
  getIssueNames(event: any) {
    if (event.target.value != "") {
      this.oldissuename = this.issuesub.filter((data: any) =>
        data.issueName.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else {
      this.oldissuename = this.issuesub
    }
  }


 getContractRepNames(event: MatOptionSelectionChange): void {
  if (event.isUserInput) {
    this.contractReportRepName = event.source.value;
  }
}



  // getContractRepNames(event) {

  //   this.Advtremainingamt.patchValue({
  //     rep_name: event.source.value
  //   })

  //   this.contractReportRepName = event.source.value

  // }


  contractReportAdvtRepName = '';
  getContractAdvtName(event) {


    console.log(this.advtCreditNoteform.value.advtname);
    this.contractReportAdvtRepName = event.value;
  }

  CreditnoteAdvt = '';
  getCAdvtName(event) {
    // console.log(event.value);
    this.CreditnoteAdvt = event.value;
  }

  updateolddata(data) {

    let result = this.dialog.open(OlddataupdateComponent, {
      data: data,
      width: '900px',
      height: '500px',
      maxWidth: '100%',
    });
  }
  updateadvttype(data) {

    this.Addadvttype.patchValue({
      id: data.id,
      advttype: data.advt_type,
      advttypedeatils: data.advt_types_select
    })

  }

  updateadvtudhishta(data: any) {
    this.Addudhishta.patchValue({
      id: data.id,
      repname: data.rep_udhishta,
      Udhishta_amount: data.udhishta_column
    });
  }





  addid: any
  pageno: any
  newpageno: any
  addpageno(data) {



    this.addid = data['DS_ADVTID'];
    this.pageno = data['pages_no'];
    const req: any = {
      "pages_no": this.pageno,
      "DS_ADVTID": this.addid
    }
    this.service.addpp_pageno(req).subscribe((data) => {
      // this.newpageno = data;
      // console.log(this.newpageno, "this.getMagIssnewpagenoueDatesandAdvtNames")
    });
    this.toaster.success('success', 'Page No Added Succesfully');
    this.ngOnInit();
  }
  typeclear() {
    this.Addadvttype.reset();
  }

  removeolddata(id) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );
    if (
      window.confirm(
        'Do you really want to remove the data'
      )
    ) {
      this.service.removeOlddatay(parseInt(id)).subscribe((data) => {

      });
    }
  }

  removeadvttype(id: any) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );

    if (window.confirm('Do you really want to remove the data')) {
      this.service.removeadvttype(parseInt(id)).subscribe(() => {
        window.location.reload();   // 🔥 refresh the whole page
      });
    }
  }



  removeadvtudhishta(id: any) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );

    if (window.confirm('Do you really want to remove the data')) {
      this.service.removeadvtudhishta(parseInt(id)).subscribe(() => {
        window.location.reload();   // 🔥 refresh the whole page
      });
    }
  }


  contractReportType = '';
  getContractReportType(event) {
    // console.log(event.value);
    this.contractReportType = event.value;
  }


  //showContract

  showContractReportReminder() {


     const typedRepName = this.Sendreminderform.get('repname')?.value;
  if (typedRepName) {
    this.contractReportRepName = typedRepName;
  }

    debugger
    // console.log(this.contractData);

    if (this.contractReportType !== '' && this.contractReportType !== 'send-reminder1' && this.contractReportType !== 'send-reminder2') {

      this.dialog.open(ContractBriefReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.startDate,
          endDate: this.Sendreminderform.value.endDate,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'send-reminder1') {

      debugger
      this.dialog.open(SendReminderLetterAdvtComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.startDate,
          endDate: this.Sendreminderform.value.endDate,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
    else if (this.contractReportType === 'send-reminder2') {

      debugger
      this.dialog.open(SendReminderLetterRepComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.startDate,
          endDate: this.Sendreminderform.value.endDate,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {

      alert('Please select report type');

    }
  }



  showContractBusiness() {
    debugger
    // console.log(this.contractData);

    if (this.contractReportType !== '' && this.contractReportType !== 'BusinessReportBriefly' && this.contractReportType !== 'BusinessReportVBriefly' && this.contractReportType !== 'IssueBusinessReport' && this.contractReportType !== 'IssueBusinessDetailAdvtReport' && this.contractReportType !== 'IssueYearBusinessAdvtReport'  && this.contractReportType !== 'JahitatJamaReport' && this.contractReportType !== 'JahitatJamaPratinidiReport' && this.contractReportType !== 'YeneBakiJahiratPratinidiReport' && this.contractReportType !== 'YeneBakiJahiratReport' ) {

      this.dialog.open(BusinessReportIndetailComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'BusinessReportBriefly') {

      this.dialog.open(BusinessReportBrieflyComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
    else if (this.contractReportType === 'BusinessReportVBriefly') {

      this.dialog.open(BusinessReportVeryBrieflyComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'IssueBusinessReport') {

      this.dialog.open(IssueWiseReportAdvtBusinessComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'IssueBusinessDetailAdvtReport') {

      this.dialog.open(IssueWiseReportAdvtDetailBusinessComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issuedatespp,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'IssueYearBusinessAdvtReport') {
      debugger

      this.dialog.open(AdvtissueYearWiseReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,   // "name1,name2"
          issuedatespp:   this.issuedatespp,
          issue_date: this.BusinessReportForm.value.issueDates,
          issue_name: this.BusinessReportForm.value.issuename,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }else if (this.contractReportType === 'JahitatJamaReport') {
        debugger
        this.dialog.open(JahiriatJamaReportComponent, {
          data: {
            contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,   // "name1,name2"
          issuedatespp:   this.issuedatespp,
          issue_date: this.BusinessReportForm.value.issueDates,
          issue_name: this.BusinessReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
      else if (this.contractReportType === 'JahitatJamaPratinidiReport') {
        debugger
        this.dialog.open(JahiratPratinidiwiseJamareportComponent, {
          data: {
            contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,   // "name1,name2"
          issuedatespp:   this.issuedatespp,
          issue_date: this.BusinessReportForm.value.issueDates,
          issue_name: this.BusinessReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
      else if (this.contractReportType === 'YeneBakiJahiratPratinidiReport') {
        debugger
        this.dialog.open(YeneBakiJahiratReportComponent, {
          data: {
            contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,   // "name1,name2"
          issuedatespp:   this.issuedatespp,
          issue_date: this.BusinessReportForm.value.issueDates,
          issue_name: this.BusinessReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
      else if (this.contractReportType === 'YeneBakiJahiratReport') {
        debugger
        this.dialog.open(YenebakiOffwiseJahirataComponent, {
          data: {
            contractData: this.contractData,
          startDate: this.BusinessReportForm.value.start,
          endDate: this.BusinessReportForm.value.end,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          country: this.BusinessReportForm.value.country,      // ✅ Read from form
          state: this.BusinessReportForm.value.state,          // ✅ Read from form
          district: this.BusinessReportForm.value.district,    // ✅ Read from form
          taluka: this.BusinessReportForm.value.taluka,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,   // "name1,name2"
          issuedatespp:   this.issuedatespp,
          issue_date: this.BusinessReportForm.value.issueDates,
          issue_name: this.BusinessReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }else {

      alert('Please select report type');

    }
  }


  // showContractReportAddress() {

  //   debugger;
  //   // console.log(this.contractData);

  //   if (this.contractReportType === 'AddressL') {
  //     debugger;
  //     this.dialog.open(AddressAdvtLabelsComponent, {
  //       data: {
  //         contractData: this.contractData,
  //         startDate: this.AddressForm.value.start,
  //         endDate: this.AddressForm.value.end,
  //         repname: this.AddressForm.value.repname,
  //         offRepName: this.contractReportOffRepName,
  //         reportType: this.contractReportType,
  //         newissuedatepp: this.newissuedatepp,
  //         issueDates: this.AddressForm.value.issueDates,
  //         issuedatepp: this.issuedatespp,
  //         country: this.AddressForm.value.country,      // ✅ Read from form
  //         state: this.AddressForm.value.state,          // ✅ Read from form
  //         district: this.AddressForm.value.district,    // ✅ Read from form
  //         taluka: this.AddressForm.value.taluka,
  //         advtType: this.AddressForm.value.advtType

  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });

  //   }
 
  //   else {

  //     alert('Please select report type');

  //   }


  // }



  // showContractReportadvt(){

  //     this.dialog.open(AdvertisementAddress1Component, {
  //       data: {
  //         // contractData: this.OutStandingForm.value.repname,
  //         startDate: this.OutStandingForm.value.start,
  //         endDate: this.OutStandingForm.value.end,
  //         repName: this.OutStandingForm.value.repname,
  //         offRepName: this.OutStandingForm.value.offrepname,
  //         name: this.advt_name, 
  //         reportType:this.OutStandingForm.value.issuecate,
  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });

  // }

  // showContractReport() {
  //   // console.log(this.contractData);
  //   debugger
  //   const req:any = {
  //     "rep_name":this.CreditNoteForm.value.rep_name,
  //     "start_date":this.CreditNoteForm.value.start,
  //     "end_date":this.CreditNoteForm.value.end,
  //     "off_rep_name":this.CreditNoteForm.value.off_rep_name,
  //     // "issue_name":this.CreditNoteForm.value.issue_cat,
  //     "issue_name":this.CreditNoteForm.value.issuename,
  //     "issue_date":this.CreditNoteForm.value.issueDates,
  //     "advt_name" : this.advtName
  //   }
  //   this.service.getCreditRegiInDetails1(req).subscribe((data) => {

  //     this.advtcreditnotetRegiInDetailsFormBeans = data;
  //     this.PaymentadvtOffInDTotal = 0;
  //     console.log( this.advtcreditnotetRegiInDetailsFormBeans , "data receipt")


  //      for (let data1 of this.advtcreditnotetRegiInDetailsFormBeans) {

  //              this.PaymentadvtOffInDTotal += parseInt(data1.credit_v_amt) || 0;

  //             }
  //      })
  //      this.service.getCreditRegiInDetails1(req).subscribe((data) => {
  //       // this.data_for_two_receipt = data;

  //       // this.data_for_two_receipt.forEach(element => {
  //       //  element.is_selected = false;
  //       // });

  //      debugger
  //   if (this.contractReportType !== '' && this.contractReportType != 'AdvertisementAddress') {
  //     this.dialog.open(ContractBriefReportComponent, {
  //       data: {
  //         contractData: this.contractData,
  //         startDate: this.startDate_contract,
  //         endDate: this.enddate_contract,
  //         repName: this.contractReportRepName,
  //         offRepName: this.contractReportOffRepName,
  //         name:  this.advt_name,
  //         reportType: this.contractReportType,
  //         issue_date:this.CreditNoteForm.value.issueDates,
  //         issue_name:this.CreditNoteForm.value.issuename,

  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });
  //   }
  //   if (this.contractReportType == 'AdvertisementAddress') {
  //     this.dialog.open(AdvertisementAddressComponent, {
  //       data: {
  //         contractData: this.contractData,
  //         startDate: this.startDate_contract,
  //         endDate: this.enddate_contract,
  //         repName: this.contractReportRepName,
  //         offRepName: this.contractReportOffRepName,
  //         name:  this.advt_name,
  //         reportType: this.contractReportType,
  //         issue_date:this.CreditNoteForm.value.issueDates,
  //         issue_name:this.CreditNoteForm.value.issuename,

  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });
  //  }else {
  //     alert('Please select report type');
  //   }
  // })
  // }





  showContractReportAddress() {

    debugger;
    // console.log(this.contractData);

    if (this.contractReportType === 'AddressL') {
      debugger;
      this.dialog.open(AddressAdvtLabelsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.AddressForm.value.start,
          endDate: this.AddressForm.value.end,
          repname: this.AddressForm.value.repname,
          offRepName: this.contractReportOffRepName,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issueDates: this.AddressForm.value.issueDates,
          issuedatepp: this.issuedatespp,
          country: this.AddressForm.value.country,
          state: this.AddressForm.value.state,
          district: this.AddressForm.value.district,
          taluka: this.AddressForm.value.taluka,
          advtType: this.AddressForm.value.advtType

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }

    else if (this.contractReportType === 'AddressList') {

      this.dialog.open(AddressListAdvtComponentComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.AddressForm.value.start,
          endDate: this.AddressForm.value.end,
          repname: this.AddressForm.value.repname,
          offRepName: this.contractReportOffRepName,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issueDates: this.AddressForm.value.issueDates,
          issuedatepp: this.issuedatespp,
          country: this.AddressForm.value.country,
          state: this.AddressForm.value.state,
          district: this.AddressForm.value.district,
          taluka: this.AddressForm.value.taluka,
          advtType: this.AddressForm.value.advtType

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }

    else {

      alert('Please select report type');

    }


}
  showContractReport() {
    // console.log(this.contractData);
    debugger
    const req: any = {
      "rep_name": this.CreditNoteForm.value.repname,
      "start_date": this.CreditNoteForm.value.start,
      "end_date": this.CreditNoteForm.value.end,
      "off_rep_name": this.CreditNoteForm.value.off_rep_name,
      // "issue_name":this.CreditNoteForm.value.issue_cat,
      "issue_name": this.CreditNoteForm.value.issuename,
      "issue_date": this.CreditNoteForm.value.issueDates,
      "advt_name": this.advtName
    }
    this.service.getCreditRegiInDetails1(req).subscribe((data) => {

      this.advtcreditnotetRegiInDetailsFormBeans = data;
      this.PaymentadvtOffInDTotal = 0;
      console.log(this.advtcreditnotetRegiInDetailsFormBeans, "data receipt")


      for (let data1 of this.advtcreditnotetRegiInDetailsFormBeans) {
        this.PaymentadvtOffInDTotal += parseInt(data1.credit_v_amt) || 0;
      }
    });

    this.service.getCreditRegiInDetails1(req).subscribe((data) => {
      // this.data_for_two_receipt = data;
      // this.data_for_two_receipt.forEach(element => {
      //  element.is_selected = false;
      // });

      debugger
      if (this.contractReportType === '') {
        alert('Please select report type');
      } else if (this.contractReportType === 'AdvertisementAddress') {
        this.dialog.open(AdvertisementAddressComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
            newissuedatepp: this.newissuedatepp,
            issuedatepp: this.issuedatespp,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType == 'Advtoutstandingbriefly') {
        this.dialog.open(OutstandingBrieflyReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType == 'AdvtoutstandingAllbriefly') {
        this.dialog.open(AdvtoutstandingAllbrieflyComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType == 'AdvtoutstandingInDetails') {
        this.dialog.open(AdvtOutstandingReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType === 'unpaidOutstandingbriefly') {
        this.dialog.open(UnpaidOutstandingBrieflyReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType === 'unpaidOutstandingVbriefly') {
        this.dialog.open(UnpaidOutstandingVbrieflyComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType == 'unpaidOutstandingInDetails') {
        this.dialog.open(UnpaidOutstandingInDetailComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType == 'RepresantativeAddress') {
        this.dialog.open(AdvtRepresentativeAddressListComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType == 'AdvertisementAddressList') {
        this.dialog.open(AdvertisementAddressListComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'InDetailCreditNote') {
        this.dialog.open(CreditNoteRegisterIndetailComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'CreditNotebriefly') {
        this.dialog.open(CreditNoteBrieflyRegisterComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'CreditMonthwise') {
        this.dialog.open(CreditNoteMonthwiseRegisterComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'InDetail-CreditOfficer') {
        this.dialog.open(CreditNoteInDetailCreditOfficerComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'VeryBriefly-CreditNote') {
        this.dialog.open(CreditNoteVeryBrieflyCreditNoteComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'Briefly-OfficerCredit') {
        this.dialog.open(CreditNoteBrieflyOfficerCreditComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_name: this.CreditNoteForm.value.issuename,
            issue_date: this.CreditNoteForm.value.issueDates,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType == 'GSTFullReport') {
        this.dialog.open(OutstandingGstRegistrationReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType === 'CompletedCommReport') {
        this.dialog.open(CompletedCommissionReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.CommissionReportForm.value.issueDates,
            issue_name: this.CommissionReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType === 'PendingCommReport') {
        debugger
        this.dialog.open(PendingCommReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.CommissionReportForm.value.issueDates,
            issue_name: this.CommissionReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else if (this.contractReportType === 'AllCommReport') {
        this.dialog.open(AllCommReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.CommissionReportForm.value.issueDates,
            issue_name: this.CommissionReportForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      } else if (this.contractReportType == 'creditdOutstandingindetails') {
        this.dialog.open(CreditOutstandingIndetailsComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
        // alert('Please select report type');
      }
      else {
        this.dialog.open(ContractBriefReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            name: this.advt_name,
            reportType: this.contractReportType,
            issue_date: this.OutStandingForm.value.issueDates,
            issue_name: this.OutStandingForm.value.issuename,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
    });
  }
  showContractReportoutstanding() {

    // console.log(this.contractData);
    if (this.contractReportType !== '') {
      this.dialog.open(ContractBriefReportComponent, {
        data: {
          // contractData: this.OutStandingForm.value.repname,
          startDate: this.OutStandingForm.value.start,
          endDate: this.OutStandingForm.value.end,
          repName: this.OutStandingForm.value.repname,
          offRepName: this.OutStandingForm.value.offrepname,
          name: this.advt_name,
          reportType: this.OutStandingForm.value.issuecate,
          issue_date: this.OutStandingForm.value.issueDates,
          issue_name: this.OutStandingForm.value.issuename,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    } else {
      alert('Please select report type');
    }
  }

  showContractoneReport() {

    debugger
    // console.log(this.contractData);
    if (this.contractReportType !== '' && this.contractReportType !== 'briefly') {
      this.dialog.open(ContractIndetailReportComponent, {
        data: {
          // contractData: this.contractData,
          startDate: this.contractDetailsForm.value.start,
          endDate: this.contractDetailsForm.value.end,
          repName: this.contractDetailsForm.value.rep_name,
          offRepName: this.contractDetailsForm.value.off_rep_name,
          name: this.advt_name,
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    } else if (this.contractReportType === 'briefly') {
      this.dialog.open(ContractBrieflyReportComponent, {
        data: {
          // contractData: this.contractData,
          startDate: this.contractDetailsForm.value.start,
          endDate: this.contractDetailsForm.value.end,
          repName: this.contractDetailsForm.value.rep_name,
          offRepName: this.contractDetailsForm.value.off_rep_name,
          name: this.contractDetailsForm.value.advt_name,
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      alert('Please select report type');
    }
  }


  showPersonalLedgerReport() {
    const dataPayload = {
      contractData: this.contractData,
      startDate: this.startDate_contract,
      endDate: this.enddate_contract,
      repName: this.contractReportRepName,
      offRepName: this.contractReportOffRepName,
      name: this.PersonalNoteform.value.advtname,
      reportType: this.contractReportType,
    };

    if (this.contractReportType === 'InDetail-personalledger') {
      this.dialog.open(PersonalLedgerInDetailComponent, {
        data: dataPayload,
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    } else if (this.contractReportType === 'InDetail-personalledger1') {
      this.dialog.open(PersonalLedgerInDetail1Component, {
        data: dataPayload,
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    } else if (this.contractReportType === 'briefly-personalledger') {
      this.dialog.open(ContractBriefReportComponent, {
        data: dataPayload,
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    } else {
      alert('Please select a valid report type');
    }
  }


  advtNames;
  getMagIssueDatesandAdvtNames;
  getIssuesAdvtNames(e) {
    // console.log(e);
    debugger
    this.advtNames = e.source.value;
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames(e.source.value).subscribe((data) => {
      this.getMagIssueDatesandAdvtNames = data;
      console.log(this.getMagIssueDatesandAdvtNames, "this.getMagIssueDatesandAdvtNames")
      this.filterissuedate = data;
    });
  }
  getIssuesAdvtNames1(e) {

    // console.log(e);
    this.advtNames = e.source.value;
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames1(e.source.value).subscribe((data) => {
      this.getMagIssueDatesandAdvtNames1 = data;
      this.filterissuedate = data;
      console.log(this.getMagIssueDatesandAdvtInvoiceNames, "issue date by isssu name")
    });
  }

  advtInvoiceNames1;
  getMagIssueDatesandAdvtInvoiceNames;
  getIssuesAdvtInvoice(e) {
    // console.log(e);
    this.advtInvoiceNames1 = e.value;
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandAdvtInvoiceNames = data;
      console.log('advt name', data);
    });
  }

  advtInvoiceIssueDates;
  getAdvtInvoiceDates(e) {
    this.advtInvoiceIssueDates = e.value;
  }

  advtInvoiceStartDate;
  advtInvoiceEndDate;
  getChangedDateAdvtInvoice() {
    if (
      this.advtinvoiceForm.get('start').value != null &&
      this.advtinvoiceForm.get('end').value != null
    ) {
      this.advtInvoiceStartDate = formatDate(
        this.advtinvoiceForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.advtInvoiceEndDate = formatDate(
        this.advtinvoiceForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    const selectedDate = new Date(this.advtInvoiceStartDate);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.advtinvoiceForm.get('start')?.setValue(null);
      this.advtinvoiceForm.get('end')?.setValue(null);
    }
  }
  advtstampStartDate: any
  advtstampEndDate: any
  getdateforstamp() {

    if (
      this.stampgetdata.get('start').value != null &&
      this.stampgetdata.get('end').value != null
    ) {
      this.advtstampStartDate = formatDate(
        this.stampgetdata.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.advtstampEndDate = formatDate(
        this.stampgetdata.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
    debugger
    const advt_name = '';
    const start_date = this.advtstampStartDate;
    const end_date = this.advtstampEndDate;

    // Call the service with the calculated dates
    this.service.getStampdata(start_date, end_date, advt_name).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.stampdata = data;
      console.log(this.stampdata, "stamp data");
      // this.ngOnInit();
    });


    const selectedDate = new Date(this.advtstampStartDate);
    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    if (selectedDate < min || selectedDate > max) {
      alert('Date is outside the allowed range.');
      this.stampgetdata.get('start')?.setValue(null);
      this.stampgetdata.get('end')?.setValue(null);
    }
  }



  advtstampStartDate1: any;
  advtstampEndDate1: any;

  getdateforstamp1() {

    const startVal = this.stampgetdata1.get('start')?.value;
    const endVal = this.stampgetdata1.get('end')?.value;

    // STOP if any date is empty
    if (!startVal || !endVal) return;

    // Convert to Date objects (correct for comparison)
    const startDate = new Date(startVal);
    const endDate = new Date(endVal);

    const minDate = new Date(this.financialYearMin);
    const maxDate = new Date(this.financialYearMax);

    /* ---------------------
          VALIDATION
    ---------------------- */

    // Check if start > end
    // if (startDate > endDate) {
    //   alert('End date must be greater than or equal to Start date.');
    //   this.stampgetdata1.get('end')?.setValue('');
    //   return;
    // }

    // // Check start date range
    // if (startDate < minDate || startDate > maxDate) {
    //   alert('Start date is outside the allowed financial year range.');
    //   this.stampgetdata1.get('start')?.setValue('');
    //   return;
    // }

    // // Check end date range
    // if (endDate < minDate || endDate > maxDate) {
    //   alert('End date is outside the allowed financial year range.');
    //   this.stampgetdata1.get('end')?.setValue('');
    //   return;
    // }

    /* ---------------------
          FORMAT DATES
    ---------------------- */
    this.advtstampStartDate1 = formatDate(startVal, 'yyyy-MM-dd', 'en-IN');
    this.advtstampEndDate1 = formatDate(endVal, 'yyyy-MM-dd', 'en-IN');

    /* ---------------------
          API CALL
    ---------------------- */
    // this.service
    //   .getStampdata('', this.advtstampStartDate1, this.advtstampEndDate1)
    //   .subscribe((data: any) => {
    //     console.log("ADVT Stamp Data =", data);
    //     this.stampdata1 = data;
    //   });
  }






  advtNamesIssueDates;
  advtNamesStringDates;
  advtInvoiceNames;
  // searchOnlyIssueDate:any=[]
  getAdvtNameDates(e) {
    // this.debugger
    // this.searchOnlyIssueDate.push(e.value);

    this.advtNamesIssueDates = e.value;
    this.advtNamesStringDates = this.advtNamesIssueDates.toString();

    // console.log('StringDates', this.advtNamesStringDates);
    console.log('IssueDates', this.advtNamesIssueDates);
    this.advtInvoiceNames = [];
    for (let index = 0; index < this.advtNamesIssueDates.length; index++) {
      this.service
        .getAdvtInvoiceforAdvtNames(this.advtNamesIssueDates[index])
        .subscribe((res: any) => {
          // console.log(`${index}`, res);
          if (res) {
            res?.map((a) => {
              this.advtInvoiceNames.push({ advt_name: a.name });
            });
          }
        });
      if (index == this.advtNamesIssueDates.length - 1) {
        console.log(this.advtInvoiceNames);

        //   this.advtInvoiceNames = this.uniqueid(
        //     this.advtInvoiceNames,
        //     (i) => i.advt_name
        //   );
      }
    }
    console.log(this.advtInvoiceNames);

    this.advtInvoiceNames = this.uniqueid(
      this.advtInvoiceNames,
      (i) => i.advt_name
    );
    console.log(this.advtInvoiceNames);

    this.cid = this.advtbillForm.value.issuedate

    this.service.getinvoicdedetails(this.cid).subscribe((res) => {

      // console.log(res);
      this.newissuedate = res;
      // this.newissuedate1 = this.newissuedate[0].DS_ISSUEDATE
      let dates = []
      this.newissuedate = res;
      this.issueName = res;
      this.newissuedate.forEach((element: any) => {
        dates.push(element.DS_ISSUEDATE)
      });
      this.newissuedate1 = dates
      console.log(this.newissuedate1, "invoice list for new issuedaate")
      // for (let index = 0; index < this.advtInvoiceList.length; index++) {
      //   this.advtNamesData.push({
      //     id: this.advtInvoiceList[index]['id'],
      //     advt_name: this.advtInvoiceList[index]['advt_name'],
      //   });
      // }
    });

  }

  advtInvoiceDate(event) {
    // console.log(event.value);
    this.getAdvtInoivceNo(event.value);
  }

  getAdvtInoivceNo(date) {
    // let date = new Date();
    let id = 1;
    this.service
      .getNextAdvtInvoiceNo(formatDate(date, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'))
      .subscribe((res) => {
        // console.log(res);
        if (Object.keys(res).length > 0) {
          id = parseInt(res['advt_invoice_no'].split('/')[3]) + 1;
          // console.log(id);
        }

        let bill_no = `VSJ/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getMonth() + 1 < 4
          ? (date.getFullYear() - 1).toString().slice(-2) +
          '' +
          date.getFullYear().toString().slice(-2)
          : date.getFullYear().toString().slice(-2) +
          '' +
          (date.getFullYear() + 1).toString().slice(-2)
          }/${('0000' + id).slice(-4)}`;
        //   // console.log(bill_no);
        this.advtbillForm.get('billno').setValue(bill_no);
      });
  }

  // openAdvtBill() {
  //   debugger

  //   let date = new Date(this.advtbillForm.get('date').value)
  //   let dialogData = this.dialog.open(AdvtBillComponent, {
  //     data: {
  //       issuenames: this.advtNames,
  //       issueDates: this.newissuedate1,
  //       issueName: this.issueName,
  //       advtName: this.getData,
  //       date: date,
  //       isupdate: this.isupdate,
  //       billno: this.advtbillForm.get('billno').value,

  //     },
  //     width: '1200px',
  //     height: '1300px',
  //     maxWidth: '100%',

  //   });

  //   dialogData.afterClosed().subscribe((output) => {
  //     this.advtbillForm.reset('');
  //     // this.getIssuesAdvtNames({ value: '' });
  //     console.log(output);
  //     this.ngOnInit();
  //     this.getAllAdvtInovicesData();
  //   });
  // }



  openAdvtBill() {
    debugger;
    let date = new Date(this.advtbillForm.get('date').value);

    console.log('Raw date value:', this.advtbillForm.get('date').value);
    console.log('Parsed Invoice Date:', date);
    console.log('Invoice Month (actual):', date.getMonth() + 1);
    console.log('Invoice Year:', date.getFullYear());

    // NEW: Validate month/year before opening dialog
    if (this.newissuedate1) {
      console.log('Raw issue date:', this.newissuedate1);
      console.log('Type of issue date:', typeof this.newissuedate1);
      console.log('Is Array:', Array.isArray(this.newissuedate1));

      // Handle if it's an array
      let issueDateStr: string;

      if (Array.isArray(this.newissuedate1)) {
        // If it's an array, get the first element
        issueDateStr = this.newissuedate1[0];
      } else if (typeof this.newissuedate1 === 'string') {
        // If it's already a string
        issueDateStr = this.newissuedate1;
      } else {
        console.error('Unexpected issue date format:', this.newissuedate1);
        return;
      }

      console.log('Issue date string:', issueDateStr);

      // Extract the first date from the comma-separated string
      // Format: "26/10/2025,दिवाळी विशेषांक 25,19/10/2025"
      let dateOnly = issueDateStr.split(',')[0].trim(); // Get "26/10/2025"

      console.log('Extracted issue date:', dateOnly);

      // Parse DD/MM/YYYY format correctly
      const dateParts = dateOnly.split('/');
      let issueDate: Date;

      if (dateParts.length === 3) {
        // Create date: new Date(year, monthIndex, day)
        issueDate = new Date(
          parseInt(dateParts[2]), // year
          parseInt(dateParts[1]) - 1, // month (0-indexed)
          parseInt(dateParts[0]) // day
        );
      } else {
        console.error('Cannot parse issue date:', dateOnly);
        return;
      }

      console.log('Parsed Issue Date:', issueDate);
      console.log('Issue Month (actual):', issueDate.getMonth() + 1);
      console.log('Issue Year:', issueDate.getFullYear());

      const invoiceMonth = date.getMonth();
      const invoiceYear = date.getFullYear();

      const issueMonth = issueDate.getMonth();
      const issueYear = issueDate.getFullYear();

      console.log('Comparison:', {
        invoiceMonth: invoiceMonth + 1,
        issueMonth: issueMonth + 1,
        invoiceYear,
        issueYear,
        monthMatch: invoiceMonth === issueMonth,
        yearMatch: invoiceYear === issueYear
      });

      if (invoiceMonth !== issueMonth || invoiceYear !== issueYear) {
        alert('चुकीचा महिना! इन्व्हॉइसची तारीख आणि अंकाची तारीख एकाच महिन्याची असली पाहिजे.');
        return;
      }
    }

    let dialogData = this.dialog.open(AdvtBillComponent, {
      data: {
        issuenames: this.advtNames,
        issueDates: this.newissuedate1,
        issueName: this.issueName,
        advtName: this.getData,
        date: date,
        isupdate: this.isupdate,
        billno: this.advtbillForm.get('billno').value,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogData.afterClosed().subscribe((output) => {
      this.advtbillForm.reset('');
      console.log(output);
      this.ngOnInit();
      this.getAllAdvtInovicesData();
    });
  }


  total_amount: any;





  setDefaultValues() {
    // Set default dates if not already set
    if (!this.start) {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      this.start = this.formatDate(firstDay);
      this.end = this.formatDate(today);
    }

    // Set default rep_name if not set
    if (!this.repregreport) {
      this.repregreport = ''; // or 'all' or whatever default
    }
  }

  formatDate(date: Date): string {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`; // Returns: yyyy-mm-dd
  }

  getAllAdvtInovicesData() {


    const filterType = this.advtbillFormsecond.get('zeroFilter').value;

    const req: any = {
      "start_date": this.start,
      "end_date": this.end,
      "rep_name": this.repregreport,
      "zero_filter": filterType

    }

    this.service.getAllAdvtInvoicesList(req).subscribe((res) => {

      // console.log(res);
      this.advtInvoiceList = res;
      // this.advtInvoiceList = this.advtInvoiceList.reverse();
      console.log(res, "invoice list")

    });
    // this.ngOnInit();
    // console.log(this.advtNamesData);
  }

  cancelAdvtInvoice(id: number) {
    if (
      window.confirm(
        'This operation is not reversable, Do you want to cancel invoice?'
      )
    ) {
      // console.log(id);
      this.service.cancelAdvtInvoice(id).subscribe((res) => {
        if (res['status'] === 'Success') {
          // console.log(res);
          alert(res['message']);
          this.ngOnInit();
        } else {
          alert('Something went wrong, Please try again.');
        }
      });
    }
  }

  viewAdvtInvoice(id: number) {
    let data = this.advtInvoiceList.filter((a) => a.id === id);
    this.total_amount = this.sharedService.getData();
    // console.log(id, data);
    debugger;
    this.openAdvtInvoice(data);
  }

  openAdvtInvoice(data: any) {

    debugger
    this.sharedService.getData().subscribe((sharedData) => {
      if (sharedData) {  // Check if data exists
        this.allList = sharedData;
      }
    });

    let dialogdata = this.dialog.open(ViewAdvtBillComponent, {
      data: {
        advtData: data,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((output) => {
      this.ngOnInit();
      // this.allSelectedtable = false;
    });
  }

  GenerateCRno2() {
    let indate = this.datePipe.transform(this.Advtremainingamt.value.invoiceDate, 'dd-MM-yyyy');

    // let indate = this.Advtremainingamt.value.invoiceDate;
    console.log(indate, "indate")
  }
  recdate1: any
  GenerateCRno() {


    // let recdate = this.advtCreditNoteform.value.recptdate ;
    this.recdate1 = this.datePipe.transform(this.advtCreditNoteform.value.recptdate, 'yyyy-MM-dd');
    // console.log(recdate);

    this.service.getCreditNoteG1(this.recdate1).subscribe((data: any) => {


      // console.log("auto CrNo=",data);
      this.autogeneratedno = (data as any);;
      // console.log(this.autogeneratedno)
      this.advtCreditNoteform.patchValue({
        crdtvno: this.autogeneratedno.new_rcpt

      })

    });
    // let newg: Number = 0;
    // // this.newg = this.autogeneratedno;
    // if (this.autogeneratedno == undefined) {
    //   this.newg = 1;
    // }
    // else {
    //   this.newg++;
    // }

    // let today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    // let rcpt_no = `${new Date(recdate).getMonth() + 1 < 4
    //     ? (new Date(recdate).getFullYear() - 1).toString().slice(-2) +
    //     '-' +
    //     new Date(recdate).getFullYear().toString().slice(-2)
    //     : new Date(recdate).getFullYear().toString().slice(-2) +
    //     '-' +
    //     (new Date(recdate).getFullYear() + 1).toString().slice(-2)
    //   }`;
    // let no: Number = 1;

    // console.log('JCN'+this.datePipe.transform(this.currentDate, 'MM')+'00'+this.newg+'/'+rcpt_no)

    //  this.autogeneratedno ++;
  }
  recdate: any
  GenerateAdvanceStampno() {

    // let recdate = this.advtCreditNoteform.value.recptdate ;
    this.recdate = this.datePipe.transform(this.advtAdvanceStampform.value.recptdate, 'yyyy-MM-dd');
    // console.log(recdate, "stampnumber");

    this.service.getAdvtStampNumber(this.recdate).subscribe((data: any) => {

      // console.log("auto CrNo=",data);
      this.autogeneratedno = (data as any);;
      console.log(this.autogeneratedno.new_rcpt)
      this.advtsn = this.autogeneratedno.new_rcpt

      this.advtAdvanceStampform.patchValue({
        crdtvno: this.advtsn
      })

    });
    // let newg: Number = 0;
    // if (this.autogeneratedno == undefined) {
    //   this.newg = 1;
    // }
    // else {
    //   this.newg++;
    // }

    // let today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    // let rcpt_no = `${new Date(recdate).getMonth() + 1 < 4
    //     ? (new Date(recdate).getFullYear() - 1).toString().slice(-2) +
    //     '-' +
    //     new Date(recdate).getFullYear().toString().slice(-2)
    //     : new Date(recdate).getFullYear().toString().slice(-2) +
    //     '-' +
    //     (new Date(recdate).getFullYear() + 1).toString().slice(-2)
    //   }`;
    // let no: Number = 1;

    // console.log('JCN'+this.datePipe.transform(this.currentDate, 'MM')+'00'+this.newg+'/'+rcpt_no)
    // 
    // this.advtAdvanceStampform.patchValue({
    //   crdtvno: this.advtsn
    // })

    //  this.autogeneratedno ++;
  }

  editAdvtInvoice(data: any) {
    console.log(data);
  }

  advtInvoiceReportType;
  getAdvtInvoiceReportType(e) {
    this.advtInvoiceReportType = e.value;
  }



  // openAdvtInvoiceRegister() {

  //   // this.issuedatelist = this.advtinvoiceForm.value.issuedate.split(',')[0];
  //   if (this.advtInvoiceReportType != "In Detail") {
  //     this.dialog.open(AdvtInvoiceRegisterComponent, {
  //       data: {
  //         startDate: this.advtInvoiceStartDate,
  //         endDate: this.advtInvoiceEndDate,
  //         issue_name: this.advtinvoiceForm.value.issuename,
  //         issue_date: this.advtinvoiceForm.value.issuedate,
  //         reportType: this.advtInvoiceReportType,

  //       },
  //       width: '1200px',
  //       height: '1300px',
  //       maxWidth: '100%',
  //     });
  //   } else {
  //     this.dialog.open(AdvtInvoiceIndetailReportComponent, {
  //       data: {
  //         startDate: this.advtInvoiceStartDate,
  //         endDate: this.advtInvoiceEndDate,
  //         issueName: this.advtinvoiceForm.value.issuename,
  //         issueDates: this.advtinvoiceForm.value.issuedate,
  //         reportType: this.advtInvoiceReportType,

  //       },
  //       width: '1200px',
  //       height: '1300px',
  //       maxWidth: '100%',
  //     });


  //   }
  // }
  openAdvtInvoiceRegister() {

    // this.issuedatelist = this.advtinvoiceForm.value.issuedate.split(',')[0];
    debugger
    if (this.advtInvoiceReportType != "In Detail" && this.advtInvoiceReportType != "Monthwise" && this.advtInvoiceReportType != "Indetail-Officer" && this.advtInvoiceReportType != "Briefly-Officer"
      && this.advtInvoiceReportType != "VeryBriefly-Officer"
    ) {
      this.dialog.open(AdvtInvoiceRegisterComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issue_name: this.advtinvoiceForm.value.issuename,
          issue_date: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.advtInvoiceReportType === "Monthwise") {
      debugger
      this.dialog.open(AdvtInvoiceMonthwiseRegisterComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issueName: this.advtinvoiceForm.value.issuename,
          issueDates: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
    else if (this.advtInvoiceReportType === "Indetail-Officer") {
      debugger
      this.dialog.open(AdvtInvoiceRegisterIndetailOfficerComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issueName: this.advtinvoiceForm.value.issuename,
          issueDates: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.advtInvoiceReportType === "Briefly-Officer") {
      debugger
      this.dialog.open(AdvtInvoiceRegisterOfficeBrieflyComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issueName: this.advtinvoiceForm.value.issuename,
          issueDates: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else if (this.advtInvoiceReportType === "VeryBriefly-Officer") {
      debugger
      this.dialog.open(AdvtInvoiceVeryBrieflyComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issueName: this.advtinvoiceForm.value.issuename,
          issueDates: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    } else {
      this.dialog.open(AdvtInvoiceIndetailReportComponent, {
        data: {
          startDate: this.advtInvoiceStartDate,
          endDate: this.advtInvoiceEndDate,
          issueName: this.advtinvoiceForm.value.issuename,
          issueDates: this.advtinvoiceForm.value.issuedate,
          rep_name: this.repregreport,
          off_rep_name: this.advtinvoiceForm.value.off_rep_name,
          reportType: this.advtInvoiceReportType,
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    }
  }


  generateCreditNoteNumber(): string {
    // Format: YYYYMMDD
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');

    const creditNoteNumber = `${year}${month}${day}`;

    // Save the generated credit note number in the variable
    this.generatedCreditNote = creditNoteNumber;

    return creditNoteNumber;
  }
  advtname: any
  searchAdvtCN() {

    {
      // console.log(this.contractData);
      if (this.contractReportType !== '') {
        this.dialog.open(ContractBriefReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.contractReportRepName,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
      // else {
      //   alert('Please select report type');
      // }
    }

  }

  opentworeceipt() {

    // console.log(this.contractData);

    this.dialog.open(TworeceiptComponent, {
      data: {
        receiptdata: this.newList1,


      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });
    console.log(this.data, "open two receipt")

  }

  opentwostampreceipt(book: any) {

    // console.log(this.contractData);

    this.dialog.open(ThreeStampReceiptComponent, {
      data: {
        stampdata: book,


      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });
    console.log(this.data, "open two receipt")

  }



  //  opentwocreditreceipt(item: any) {

  //   this.dialog.open(AdvtCreditPrintComponent, {
  //     data: {
  //       id: item.id   // ✅ Pass only ID
  //     },
  //     height: '1300px',
  //     width: '95%',
  //     maxWidth: '100%',
  //   });

  // }


  opentwocreditreceipt(item) {
    this.dialog.open(AdvtCreditPrintComponent, {
      data: { id: item.id },
    });
  }



  showContractReportPRR() {
    const req: any = {
      "rep_name": this.PaymentReceiptRegister.value.repname,
      "start_date": this.PaymentReceiptRegister.value.start,
      "end_date": this.PaymentReceiptRegister.value.end,
      "off_rep_name": this.PaymentReceiptRegister.value.off_rep_name,
      "issue_name": this.PaymentReceiptRegister.value.issuename,
      "issue_date": this.PaymentReceiptRegister.value.issueDates,

      "advt_name": this.advtName
    }

    this.service.getPaymentRegiInDetails1(req).subscribe((data) => {

      this.advtPaymentRegiInDetailsFormBeans = data;
      this.PaymentadvtOffInDTotal = 0;
      console.log(this.advtPaymentRegiInDetailsFormBeans, "data receipt")


      for (let data1 of this.advtPaymentRegiInDetailsFormBeans) {

        this.PaymentadvtOffInDTotal += parseInt(data1.rcv_amt) || 0;

      }
    });



    this.service.getPaymentRegiInDetails1(req).subscribe((data) => {
      this.data_for_two_receipt = data;

      this.data_for_two_receipt.forEach(element => {
        element.is_selected = false;
      });

      if (this.contractReportType === 'briefly1') {
        this.dialog.open(PaymentReceiptRegisterComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType === 'InDetail') {
        debugger
        this.dialog.open(PaymentReceiptIndetailReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }
      else if (this.contractReportType === 'Monthwise') {
        this.dialog.open(PaymentRegisterMonthwiseComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType === 'InDetail-Officer') {
        this.dialog.open(PaymnetReceiptIndetailOfficerComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType === 'VeryBriefly-Officer') {
        this.dialog.open(PaymnetReceieptVeryBreiflyOfficerComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else if (this.contractReportType === 'Briefly-Officer') {
        this.dialog.open(PaymentReceiptBrieflyOfficerComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      }  else if (this.contractReportType !== '') {
        debugger
        this.dialog.open(ContractBriefReportComponent, {
          data: {
            contractData: this.contractData,
            startDate: this.startDate_contract,
            endDate: this.enddate_contract,
            repName: this.repregreport,
            offRepName: this.contractReportOffRepName,
            advtName: this.contractReportAdvtRepName,
            reportType: this.contractReportType,
            issueDates: this.PaymentReceiptRegister.value.issueDates
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });
      } else {
        alert('Please select report type');
      }
    });


    // console.log(this.contractData);

  }

  crdtvno: any
  openAdvtBill1(book) {
    debugger
    this.advtCreditNote1 = book
    console.log("new book", book)
    const remainval = book.remain_amt;
    console.log("remain val", remainval)
    debugger
    this.crdtvno = this.advtCreditNoteform.value.crdtvno;
    let dialogData = this.dialog.open(OpenselectmodalComponent, {
      data: {
        issuenames: this.advtNames,
        issueDates: this.advtNamesIssueDates,
        advertisement_id: book.advertisement_id,
        date: this.advtbillForm.get('date').value,
        invoice_no: book.invoice_no,
        invoice_date: book.invoice_date,
        advt_amt: book.advt_amt,
        advt_name1: this.advtCreditNoteform.value.advtname,
        cr_vocher: this.advtCreditNoteform.value.crdtvno,
        create_date: this.advtCreditNoteform.value.date,
        receipt_date: formatDate(this.advtCreditNoteform.value.recptdate, 'dd-MM-yyyy', 'en-US'),
        rep_name: book.rep_name,
        credit_count: this.newg,
        remainvalue: remainval
      },

      width: '1200px',
      height: '1300px',
      maxWidth: '100%',

    });

    dialogData.afterClosed().subscribe((output) => {
      this.advtbillForm.reset('');
      // this.getIssuesAdvtNames({ value: '' });
      this.credit_type = output.credit_type
      this.remark = output.remark
      console.log(output);
      this.ngOnInit();
      this.getAllAdvtInovicesData();
    });
  }




  // openAdvtBill2() {

  //   let dialogData = this.dialog.open(CommmodalComponent, {
  //     data: {
  //       ModalList: this.newList
  //     },
  //     width: '95%',
  //     height: '1300px',
  //     maxWidth: '100%',

  //   });

  //   dialogData.afterClosed().subscribe((output) => {

  //     // this.advtbillForm.reset('');
  //     // // this.getIssuesAdvtNames({ value: '' });
  //     // console.log(output);
  //     // this.ngOnInit();
  //     // this.getAllAdvtInovicesData();
  //     this.newList = [];
  //     this.practice()
  //   });
  // }


  autoGenerateCommissionNo() {
    let today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

    const req: any = {
      "date": today
    }

    this.service.getcommissionnumber(req).subscribe((data: any) => {
      this.autogeneratedno = data;
      console.log("Auto-generated commission data:", this.autogeneratedno);

      if (this.autogeneratedno && this.autogeneratedno.length > 0 && this.autogeneratedno[0].commision_no) {
        const rcpt_no = this.autogeneratedno[0].commision_no;

        // Auto-fill Receipt No and Date fields
        this.advtcommrecptform.get('recptno').setValue(rcpt_no);
        this.advtcommrecptform.get('date').setValue(today);

        console.log("Auto-filled Receipt No:", rcpt_no);
        console.log("Auto-filled Date:", today);
      }
    });
  }




  // openAdvtBill2() {
  //   debugger

  //   const totalSelectedAmount = this.selectedRows.reduce(
  //     (sum, row) => sum + (row.selectedAmount || 0),
  //     0
  //   );
  //   const allPercentages = this.selectedRows.map(
  //     row => row.commissionPercentage || 15
  //   );

  //   let dialogData = this.dialog.open(CommmodalComponent, {
  //     data: {
  //       ModalList: this.selectedRows,
  //       tdsAmt: this.advtcommrecptform.get('tdsAmount')?.value,
  //       tdspercentage: this.advtcommrecptform.get('tdsPercentage')?.value,
  //       balamount: this.advtcommrecptform.get('balamt')?.value,
  //       rcpt_no: this.advtcommrecptform.get('recptno')?.value,
  //       rcpt_date: this.advtcommrecptform.get('date')?.value,

  //       seamt: totalSelectedAmount,
  //       commissionPercentage: this.selectedRows.length
  //         ? this.selectedRows[0].commissionPercentage || 15
  //         : null,
  //       voucher_no: this.pendingAdvtData1?.voucher_no ?? '',
  //       cheque_no: this.pendingAdvtData1?.cheque_no ?? '',
  //       cheque_date: this.pendingAdvtData1?.chequeDate ?? '',
  //       voucher_date: this.pendingAdvtData1?.voucher_date ?? '',

  //     },
  //     width: '95%',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });

  //   dialogData.afterClosed().subscribe((output) => {
  //     this.selectedRows = []; // clear after closing modal
  //     this.practice();
  //   });
  // }


  // openAdvtBill3() {

  //   debugger

  //   const req3: any = {
  //     "data": this.advtCreditNote1.advertisement_id,
  //   }
  //   this.service.getCdatabyid(req3).subscribe((data: any) => {
  //     console.log("Get databy id", data)
  //     if (data.length == 0) {
  //       debugger
  //       let dialogData = this.dialog.open(CrreceiptComponent, {
  //         data: {
  //           name: data.name,
  //           add: data.address,
  //           mobile: data.mobile,
  //           invoicenum: data.invoice_no,
  //           cr_vocher: data.cr_vocher,
  //           invoicedate: data.voc_date,
  //           jama: data.credit_amt,
  //           credit_type: this.credit_type,
  //           remark: this.remark,
  //           cr_voucher: this.crdtvno,
  //           tds_amt: this.tds_amt,
  //            other_credit_amt: this.other_credit_amt,
  //            total_credit_amt:this.total_credit_amt,

  //         },

  //         width: '1200px',
  //         height: '1300px',
  //         maxWidth: '100%',

  //       });
  //       dialogData.afterClosed().subscribe((output) => {
  //       });
  //     } else {
  //       let dialogData = this.dialog.open(CrreceiptComponent, {

  //         data: {
  //           name: data[data.length - 1].name,
  //           add: data[data.length - 1].address,
  //           mobile: data[data.length - 1].mobile,
  //           invoicenum: data[data.length - 1].invoice_no,
  //           // cr_vocher : data[data.length-1].cr_vocher,
  //           invoicedate: data[data.length - 1].voc_date,
  //           jama: data[data.length - 1].credit_amt,
  //           credit_type: this.credit_type,
  //           remark: this.remark,
  //           cr_voucher: this.crdtvno,
  //           tds_amt: this.tds_amt,
  //           other_credit_amt: this.other_credit_amt,
  //           total_credit_amt:this.total_credit_amt,
  //         },

  //         width: '1200px',
  //         height: '1300px',
  //         maxWidth: '100%',

  //       });
  //       dialogData.afterClosed().subscribe((output) => {
  //       });
  //     }
  //   });
  // }



  // openAdvtBill2() {
  //   debugger

  //   // Collect all selected rows from database
  //   const selectedDatabaseRows = [];

  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && record.rep_data.length > 0) {
  //         record.rep_data.forEach((item: any) => {
  //           // Only add items that have selectedAmount (checked items)
  //           if (item.selectedAmount && item.selectedAmount > 0) {
  //             selectedDatabaseRows.push(item);
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Check if manual entry is selected and has data
  //   const manualEntrySelected = this.manualEntryForm.get('isSelected')?.value;
  //   const manualInvoiceNo = this.manualEntryForm.get('advt_invoice_no')?.value;
  //   const manualRcvAmt = this.manualEntryForm.get('rcv_amt')?.value;

  //   // Add manual entry to selected rows if checkbox is checked and required fields are filled
  //   if (manualEntrySelected && manualInvoiceNo && manualRcvAmt) {
  //     const manualEntry = {
  //       advt_invoice_no: this.manualEntryForm.get('advt_invoice_no')?.value,
  //       advt_invoice_date: this.manualEntryForm.get('advt_invoice_date')?.value,
  //       advt_name: this.manualEntryForm.get('advt_name')?.value,
  //       DS_ISSUENAME: this.manualEntryForm.get('DS_ISSUENAME')?.value,
  //       DS_ISSUEDATE: this.manualEntryForm.get('DS_ISSUEDATE')?.value,
  //       net_amount: this.manualEntryForm.get('net_amount')?.value || 0,
  //       pending_amt: this.manualEntryForm.get('pending_amt')?.value || 0,
  //       rcv_amt: this.manualEntryForm.get('rcv_amt')?.value || 0,
  //       commissionPercentage: this.manualEntryForm.get('commissionPercentage')?.value || 0,
  //       commissionAmount: this.commissionAmount,
  //       selectedAmount: this.commissionAmount,
  //       com_paid_date: null,
  //       com_amt: 0,
  //       isManualEntry: true // Flag to identify manual entry
  //     };
  //     selectedDatabaseRows.push(manualEntry);
  //   }

  //   // Calculate total selected amount
  //   const totalSelectedAmount = selectedDatabaseRows.reduce(
  //     (sum, row) => sum + (row.selectedAmount || 0),
  //     0
  //   );

  //   // Validate if any rows are selected
  //   if (selectedDatabaseRows.length === 0) {
  //     alert('Please select at least one entry or add manual entry');
  //     return;
  //   }

  //   // Open dialog with all selected data
  //   let dialogData = this.dialog.open(CommmodalComponent, {
  //     data: {
  //       ModalList: selectedDatabaseRows,
  //       tdsAmt: this.advtcommrecptform.get('tdsAmount')?.value,
  //       tdspercentage: this.advtcommrecptform.get('tdsPercentage')?.value,
  //       balamount: this.advtcommrecptform.get('balamt')?.value,
  //       totalbalanceamount: this.calculateTotalBalanceAmount(),
  //       rcpt_no: this.advtcommrecptform.get('recptno')?.value,
  //       rcpt_date: this.advtcommrecptform.get('recptdate')?.value,
  //       voucher_date: this.advtcommrecptform.get('date')?.value,
  //       seamt: totalSelectedAmount,
  //       crdtvno: this.advtcommrecptform.get('crdtvno')?.value,
  //       crdtvamt: this.advtcommrecptform.get('crdtvamt')?.value,
  //       advtname: this.advtcommrecptform.get('advtname')?.value,
  //       repname: this.advtcommrecptform.get('repname')?.value,
  //       commissionPercentage: selectedDatabaseRows.length
  //         ? selectedDatabaseRows[0].commissionPercentage || 15
  //         : null,
  //       voucher_no: this.pendingAdvtData1?.voucher_no ?? '',
  //       cheque_no: this.pendingAdvtData1?.cheque_no ?? '',
  //       cheque_date: this.pendingAdvtData1?.chequeDate ?? '',
  //       comm_percentage: this.comm_percentage || 15
  //     },
  //     width: '95%',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });

  //   dialogData.afterClosed().subscribe((output) => {
  //     // Clear selected amounts after closing modal
  //     if (this.CommissionData && this.CommissionData.length > 0) {
  //       this.CommissionData.forEach(record => {
  //         if (record.rep_data && record.rep_data.length > 0) {
  //           record.rep_data.forEach((item: any) => {
  //             item.selectedAmount = 0;
  //           });
  //         }
  //       });
  //     }

  //     // Clear manual entry form
  //     this.clearAllManualEntries();

  //     this.practice();
  //   });
  // }

  //   openAdvtBill2() {
  //     debugger

  //   // Collect all selected rows from database
  //   const selectedDatabaseRows = [];

  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && record.rep_data.length > 0) {
  //         record.rep_data.forEach((item: any) => {
  //           // Only add items that have selectedAmount (checked items)
  //           if (item.selectedAmount && item.selectedAmount > 0) {
  //             selectedDatabaseRows.push(item);
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Collect all selected manual entries
  //   if (this.manualEntries && this.manualEntries.length > 0) {
  //     for (let i = 0; i < this.manualEntries.length; i++) {
  //       const formGroup = this.manualEntries.at(i) as FormGroup;
  //       const isSelected = formGroup.get('isSelected')?.value;
  //       const invoiceNo = formGroup.get('advt_invoice_no')?.value;
  //       const rcvAmt = formGroup.get('rcv_amt')?.value;


  //       // Add manual entry if checkbox is checked and required fields are filled
  //       if (isSelected && invoiceNo && rcvAmt) {



  //         const commissionAmount = this.getManualCommissionAmount(i);

  //         const manualEntry = {
  //           advt_invoice_no: formGroup.get('advt_invoice_no')?.value,
  //           advt_invoice_date: this.convertToISODate(formGroup.get('advt_invoice_date')?.value),
  //           advt_name: formGroup.get('advt_name')?.value || this.advtcommrecptform.get('advtname')?.value,
  //           DS_ISSUENAME: formGroup.get('DS_ISSUENAME')?.value,
  //           rep_name: this.advtcommrecptform.get('repname')?.value,
  //           DS_ISSUEDATE: formGroup.get('DS_ISSUEDATE')?.value,
  //           net_amount: formGroup.get('net_amount')?.value || 0,
  //           pending_amt: formGroup.get('pending_amt')?.value || 0,
  //           rcv_amt: formGroup.get('rcv_amt')?.value || 0,
  //           commissionPercentage: formGroup.get('commissionPercentage')?.value || 15,
  //           commissionAmount: commissionAmount,
  //           selectedAmount: commissionAmount,
  //           com_paid_date: null,
  //           com_amt: 0,
  //           isManualEntry: true // Flag to identify manual entry
  //         };
  //         selectedDatabaseRows.push(manualEntry);
  //       }
  //     }
  //   }

  //   // Calculate total selected amount
  //   const totalSelectedAmount = selectedDatabaseRows.reduce(
  //     (sum, row) => sum + (row.selectedAmount || 0),
  //     0
  //   );


  //   const crdtAmt = parseFloat(this.advtcommrecptform.get('crdtvamt')?.value) || 0;

  //   // Validate if any rows are selected
  //   // if (selectedDatabaseRows.length === 0) {
  //   //   alert('Please select at least one entry or add manual entry');
  //   //   return;
  //   // }

  //   // Open dialog with all selected data
  //    debugger

  //   let dialogData = this.dialog.open(CommmodalComponent, {
  //     data: {
  //       ModalList: selectedDatabaseRows,


  //      commissionAmount: totalSelectedAmount,   // <-- SELECT ENTRY AMOUNT
  //       tdsAmt: this.advtcommrecptform.get('tdsAmount')?.value,
  //       tdspercentage: this.advtcommrecptform.get('tdsPercentage')?.value,
  //       balamount: this.advtcommrecptform.get('balamt')?.value,
  //       totalbalanceamount: this.calculateTotalBalanceAmount(),
  //       rcpt_no: this.advtcommrecptform.get('recptno')?.value,
  //       rcpt_date: this.advtcommrecptform.get('recptdate')?.value,
  //       voucher_date: this.advtcommrecptform.get('date')?.value,
  //       seamt: totalSelectedAmount,
  //       crdtvno: this.advtcommrecptform.get('crdtvno')?.value,
  //       crdtvamt: this.advtcommrecptform.get('crdtvamt')?.value,
  //       advtname: this.advtcommrecptform.get('advtname')?.value,
  //       repname: this.advtcommrecptform.get('repname')?.value,
  //       commissionPercentage: selectedDatabaseRows.length
  //         ? selectedDatabaseRows[0].commissionPercentage || 15
  //         : null,
  //       voucher_no: this.pendingAdvtData1?.voucher_no ?? '',
  //       cheque_no: this.pendingAdvtData1?.cheque_no ?? '',
  //       cheque_date: this.pendingAdvtData1?.chequeDate ?? '',
  //       comm_percentage: this.comm_percentage || 15
  //     },
  //     width: '95%',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });

  //   dialogData.afterClosed().subscribe((output) => {
  //     // Clear selected amounts after closing modal
  //     if (this.CommissionData && this.CommissionData.length > 0) {
  //       this.CommissionData.forEach(record => {
  //         if (record.rep_data && record.rep_data.length > 0) {
  //           record.rep_data.forEach((item: any) => {
  //             item.selectedAmount = 0;
  //             item.isSelected = false;
  //           });
  //         }
  //       });
  //     }

  //     // Clear all manual entry forms
  //     this.clearAllManualEntries();

  //     this.practice();
  //   });
  // }


  openAdvtBill2() {
    debugger

    // Collect all selected rows from database
    const selectedDatabaseRows = [];

    if (this.CommissionData && this.CommissionData.length > 0) {
      this.CommissionData.forEach(record => {
        if (record.rep_data && record.rep_data.length > 0) {
          record.rep_data.forEach((item: any) => {
            // Only add items that have selectedAmount (checked items)
            if (item.selectedAmount && item.selectedAmount > 0) {
              // Ensure each row has its own commission amount
              selectedDatabaseRows.push({
                ...item,
                commissionAmount: item.selectedAmount || item.commissionAmount || 0,
                individualCommission: item.selectedAmount || item.commissionAmount || 0
              });
            }
          });
        }
      });
    }

    // Collect all selected manual entries
    if (this.manualEntries && this.manualEntries.length > 0) {
      for (let i = 0; i < this.manualEntries.length; i++) {
        const formGroup = this.manualEntries.at(i) as FormGroup;
        const isSelected = formGroup.get('isSelected')?.value;
        const invoiceNo = formGroup.get('advt_invoice_no')?.value;
        const rcvAmt = formGroup.get('rcv_amt')?.value;

        // Add manual entry if checkbox is checked and required fields are filled
        if (isSelected && invoiceNo && rcvAmt) {
          const commissionAmount = this.getManualCommissionAmount(i);

          const manualEntry = {
            advt_invoice_no: formGroup.get('advt_invoice_no')?.value,
            advt_invoice_date: this.convertToISODate(formGroup.get('advt_invoice_date')?.value),
            advt_name: formGroup.get('advt_name')?.value || this.advtcommrecptform.get('advtname')?.value,
            DS_ISSUENAME: formGroup.get('DS_ISSUENAME')?.value,
            rep_name: this.advtcommrecptform.get('repname')?.value,
            DS_ISSUEDATE: formGroup.get('DS_ISSUEDATE')?.value,
            net_amount: formGroup.get('net_amount')?.value || 0,
            pending_amt: formGroup.get('pending_amt')?.value || 0,
            rcv_amt: formGroup.get('rcv_amt')?.value || 0,
            commissionPercentage: formGroup.get('commissionPercentage')?.value || 15,
            commissionAmount: commissionAmount,
            selectedAmount: commissionAmount,
            individualCommission: commissionAmount, // Individual commission for this entry
            com_paid_date: null,
            com_amt: 0,
            isManualEntry: true
          };
          selectedDatabaseRows.push(manualEntry);
        }
      }
    }

    // Calculate total selected amount (sum of all individual commissions)
    const totalSelectedAmount = selectedDatabaseRows.reduce(
      (sum, row) => sum + (row.commissionAmount || 0),
      0
    );

    const crdtAmt = parseFloat(this.advtcommrecptform.get('crdtvamt')?.value) || 0;

    // Validate if any rows are selected
    // if (selectedDatabaseRows.length === 0) {
    //   alert('Please select at least one entry or add manual entry');
    //   return;
    // }

    // Open dialog with all selected data
    debugger

    let dialogData = this.dialog.open(CommmodalComponent, {
      data: {
        ModalList: selectedDatabaseRows,
        totalCommissionAmount: totalSelectedAmount,
        tdsAmt: this.advtcommrecptform.get('tdsAmount')?.value,
        tdspercentage: this.advtcommrecptform.get('tdsPercentage')?.value,
        balamount: this.advtcommrecptform.get('balamt')?.value,
        totalbalanceamount: this.calculateTotalBalanceAmount(),
        rcpt_no: this.advtcommrecptform.get('recptno')?.value,
        rcpt_date: this.advtcommrecptform.get('recptdate')?.value,
        voucher_date: this.advtcommrecptform.get('recptdate')?.value || this.advtcommrecptform.get('date')?.value, // Check correct field name
        seamt: totalSelectedAmount,
        crdtvno: this.advtcommrecptform.get('crdtvno')?.value,
        crdtvamt: this.advtcommrecptform.get('crdtvamt')?.value,
        advtname: this.advtcommrecptform.get('advtname')?.value,
        repname: this.advtcommrecptform.get('repname')?.value,
        commissionPercentage: selectedDatabaseRows.length
          ? selectedDatabaseRows[0].commissionPercentage || 15
          : null,
        voucher_no: this.pendingAdvtData1?.voucher_no ?? '',
        cheque_no: this.pendingAdvtData1?.cheque_no ?? '',
        cheque_date: this.pendingAdvtData1?.chequeDate ?? '',
        comm_percentage: this.comm_percentage || 15
      },
      width: '95%',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogData.afterClosed().subscribe((output) => {
      // Clear selected amounts after closing modal
      if (this.CommissionData && this.CommissionData.length > 0) {
        this.CommissionData.forEach(record => {
          if (record.rep_data && record.rep_data.length > 0) {
            record.rep_data.forEach((item: any) => {
              item.selectedAmount = 0;
              item.isSelected = false;
            });
          }
        });
      }

      // Clear all manual entry forms
      this.clearAllManualEntries();

      this.practice();
    });
  }



  openAdvtBill3() {
    debugger

    const req3: any = {
      "data": this.advtCreditNote1.advertisement_id,
    }
    this.service.getCdatabyid(req3).subscribe((data: any) => {
      console.log("Get databy id", data)

      if (data.length == 0) {
        debugger
        let dialogData = this.dialog.open(CrreceiptComponent, {
          data: {
            name: data.name,
            add: data.address,
            mobile: data.mobile,
            invoicenum: data.invoice_no,
            cr_vocher: data.cr_vocher,
            invoicedate: data.voc_date,
            jama: data.credit_amt,
            credit_type: this.credit_type,
            remark: this.remark,
            cr_voucher: this.crdtvno,
            tds_amt: data.tds_amt,  // ✅ Changed from this.tds_amt
            other_credit_amt: data.other_credit_amt,  // ✅ Changed
            total_credit_amt: data.total_credit_amt,
            rcv_amt: data.rcv_amt,
            invoice_no: data.invoice_no,
            invoice_date: data.invoice_date,

          },
          width: '1200px',
          height: '1300px',
          maxWidth: '100%',
        });
        dialogData.afterClosed().subscribe((output) => {
        });
      } else {
        debugger
        let dialogData = this.dialog.open(CrreceiptComponent, {
          data: {
            name: data[data.length - 1].name,
            add: data[data.length - 1].address,
            mobile: data[data.length - 1].mobile,
            invoicenum: data[data.length - 1].invoice_no,
            invoicedate: data[data.length - 1].voc_date,
            jama: data[data.length - 1].credit_amt,
            credit_type: this.credit_type,
            remark: this.remark,
            cr_voucher: this.crdtvno,
            tds_amt: data[data.length - 1].tds_amt,  // ✅ Changed
            other_credit_amt: data[data.length - 1].other_credit_amt,  // ✅ Changed
            total_credit_amt: data[data.length - 1].total_credit_amt,  // ✅ Changed
            rcv_amt: data.rcv_amt,
            invoice_no: data.invoice_no,
            invoice_date: data.invoice_date,
          },
          width: '1200px',
          height: '1300px',
          maxWidth: '100%',
        });
        dialogData.afterClosed().subscribe((output) => {
        });
      }
    });
  }


  // New method for percentage change
  onPercentageChange(data1: any, index: number): void {
    const percentage = data1.commissionPercentage || 0;
    const rcvAmt = data1.rcv_amt || 0;

    // Calculate commission amount based on received amount
    const commissionAmount = (rcvAmt * percentage) / 100;

    // Update the commission amount
    data1.commissionAmount = Math.round(commissionAmount * 100) / 100;

    // If item is selected, update selectedAmount as well
    if (data1.isSelected) {
      data1.selectedAmount = data1.commissionAmount;

      // Update the Select Entry Amount field
      this.advtcommrecptform.patchValue({
        seamt: this.getGrandTotal('selectedAmount')
      });
    }

    // Recalculate TDS and Balance
    this.calculateTdsAmount();
    this.calculateBalanceAmount();
  }

  openAdvtBill4() {

    let dialogData = this.dialog.open(StampreceiptComponent, {
      data: {
        // console.log(this.newList1, "this.newList")
        stampdata: this.newList1,
        // total : this.total,  formatDate(event.target.value, 'MM', 'en-IN', 'GMT+0530')
        // creation_date : this.advtAdvanceStampform.value.recptdate,
        creation_date: formatDate(this.advtAdvanceStampform.value.recptdate, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
        current_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
        // issuenames: this.advtNames,
        // issueDates: this.advtNamesIssueDates,
        // advertisement_id: book.advertisement_id,
        // date: this.advtbillForm.get('date').value,
        // invoice_no: book.invoice_no,
        // advt_name1: this.advtCreditNoteform.value.advtname,
        // cr_vocher: this.advtCreditNoteform.value.crdtvno,
        // create_date: this.advtCreditNoteform.value.date,
        // receipt_date: this.advtCreditNoteform.value.recptdate,
        rep_name: this.contractReportRepName,
        stamp_number: this.advtsn,
        advancenum: this.advtAdvanceStampform.value.crdtvno,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
    console.log("hello", this.data)

    dialogData.afterClosed().subscribe((output) => {
      this.advtbillForm.reset('');
      // this.getIssuesAdvtNames({ value: '' });

      console.log(output);
      this.ngOnInit();
      this.getAllAdvtInovicesData();
    });
  }

  practice() {

    const req: any = {
      "start_date": this.startDate_contract,
      "end_date": this.enddate_contract,
      "rep_name": this.contractReportRepName,
      "issue_name": ""
    }

    this.service.practice(req).subscribe((data: any) => {

      console.log("practice", data)
      this.CommissionData1 = data as any;
      for (let data of this.CommissionData1) {
        for (let data1 of data.rep_data) {
          let copydata8 = null;
          data1.copydata8 = copydata8
        }
      }


      this.selecteddata = 0;
      this.initializeCommissions();
    });
  }

  practiceC() {

    const req: any = {
      "start_date": this.startDate_contract,
      "end_date": this.enddate_contract,
      "rep_name": this.contractReportRepName,
      "issue_name": ""
    }

    this.service.practiceC(req).subscribe((data: any) => {
      debugger
      console.log("practice", data)
      this.CommissionData = data as any;
      for (let data of this.CommissionData) {
        for (let data1 of data.rep_data) {
          let copydata8 = null;
          data1.copydata8 = copydata8
        }
      }
      this.selecteddata = 0;
    });
  }





  copydata(data1, event) {
    if (event.target.checked) {
      data1.copydata = data1.rcv_amt;
      this.newList.push(data1);
    }
    else {
      data1.copydata = null;
      this.newList = this.newList.filter((person: any) => person.advt_id !== data1.advt_id).slice();
    }
    console.log(this.newList, "this.newList")
  }
  newList = []
  total = 0;

  copydata1(data1, event) {
    if (event.checked) {
      this.total = this.total + data1.remain_amt
      this.newList1.push(data1);
    }
    else {
      this.newList1 = this.newList1.filter((person: any) => person.rcpt_no !== data1.rcpt_no).slice();
      this.total = this.total - data1.remain_amt
    }
    console.log(this.newList1, "this.newList")
    console.log(this.total)
  }
  copydata2(data1, event) {
    if (event.checked) {
      this.total = this.total + data1.remain_amt
      this.newList1.push(data1);
    }
    else {
      this.newList1 = this.newList1.filter((person: any) => person.rcpt_no !== data1.rcpt_no).slice();
      this.total = this.total - data1.remain_amt
    }
    console.log(this.newList1, "this.newList")
    console.log(this.total)
  }

  saveolddata() {
    if (this.Advtremainingamt.invalid) {
      this.toaster.error('error', 'Fill required data');
      return

    }
    const data = this.Advtremainingamt.value;
    let indate = this.datePipe.transform(this.Advtremainingamt.value.invoiceDate, 'dd-MM-yyyy');
    data.invoiceDate = indate
    console.log("penind data", data)
    this.toaster.success('success', 'Data Added Succesfully');

    this.service.getaddolddata(data).subscribe((data: any) => {

      debugger;
      console.log("old data=", data);

      this.oldata()
      //  this.toaster.success('success', 'add');
    });
    this.Advtremainingamt.reset();
    this.invoicenumber = 'VSJ-'
  }
  saveupdatedata() {
    const data: any = {
      "advt_types_select": this.Addadvttype.value.advttypedeatils,
      "advt_type": this.Addadvttype.value.advttype,
      "id": this.Addadvttype.value.id
    }

    this.service.addupdateddata(data).subscribe((data: any) => {
      console.log("add advt type", data);
      this.toaster.success('success', 'Updadated  Succesfully');

      // this.ngOnInit();
      window.location.reload();
      //  this.toaster.success('success', 'add');
    });

  }



  //   saveupdatedataudhishta() {

  //   if (this.Addudhishta.invalid) {
  //     this.toaster.error('Error', 'Fill required data');
  //     return;
  //   }

  //   const data = {
  //     id: this.Addudhishta.value.id,
  //     repname: this.Addudhishta.value.repname,
  //     udhishta_amount: this.Addudhishta.value.Udhishta_amount
  //   };

  //   this.service.updateudhishta(data).subscribe((res: any) => {
  //     console.log("Updated udhishta", res);
  //     this.toaster.success('Success', 'Updated Successfully');
  //     window.location.reload();
  //   });
  // }


  saveupdatedataudhishta() {

    if (this.Addudhishta.invalid) {
      this.toaster.error('Error', 'Fill Required Fields');
      return;
    }

    const data = {
      id: this.Addudhishta.value.id,
      repname: this.Addudhishta.value.repname,
      udhishta_amount: this.Addudhishta.value.Udhishta_amount
    };

    this.service.updateudhishta(data).subscribe((res: any) => {
      this.toaster.success("Success", "Updated Successfully");
      window.location.reload();
    });
  }


  saveadvttype() {
    if (this.Addadvttype.invalid) {
      this.toaster.error('error', 'Fill required data');
      return

    }
    const data: any = {
      "advt_type": this.Addadvttype.value.advttype,
      "advt_types_select": this.Addadvttype.value.advttypedeatils
    }


    this.service.getaddadvttype(data).subscribe((data: any) => {
      console.log("add advt type", data);

      window.location.reload();
      //  this.toaster.success('success', 'add');
    });
    this.Advtremainingamt.reset();
    this.invoicenumber = 'VSJ-'
  }


  saveudhishta() {

    if (this.Addudhishta.invalid) {
      this.toaster.error('error', 'Fill required data');
      return;
    }

    const data = {
      repname: this.Addudhishta.value.repname,
      udhishta_amount: this.Addudhishta.value.Udhishta_amount
    };

    this.service.getaddudhishta(data).subscribe((res: any) => {
      console.log("add udhishta", res);
      window.location.reload();
    });

    this.Addudhishta.reset();
  }





  selectall(event) {
    if (event.checked) {
      debugger
      this.total = 0;
      this.data_for_two_receipt.forEach(element => {
        element.is_selected = true;
        // this.total = this.total + element.remain_amt
      })
    }

    else {
      this.data_for_two_receipt.forEach(element => {
        element.is_selected = false;
      });;
    }
  }

  newList1 = []

  updatePendingAmount(): void {
    const totalamt = this.Advtremainingamt.get('totalamt').value;
    const receivedAmount = this.Advtremainingamt.get('receivedAmount').value;
    const CreditdAmount = this.Advtremainingamt.get('CreditdAmount').value;

    if (totalamt !== null && receivedAmount !== null) {
      const pendingamt = totalamt - receivedAmount;
      this.Advtremainingamt.patchValue({ pendingamt }, { emitEvent: false });
    }
  }

  issueDate: any
  // issueName:any
  updateAdvtInvoice(data) {
    this.isupdate = true;
    // let date=this.datePipe.transform(data.invoice_date,'yyyy-MM-dd')

    if (data.fourth_week_issue_name != "" && data.fourth_week_issue_name != null && data.fourth_week_issue_name != undefined) {
      this.issueName = data.fourth_week_issue_name
    } else if (data.fifth_week_issue_name != "" && data.fifth_week_issue_name != null && data.fifth_week_issue_name != undefined) {
      this.issueName = data.fifth_week_issue_name
    } else if (data.third_week_issue_name != "" && data.third_week_issue_name != null && data.third_week_issue_name != undefined) {
      this.issueName = data.third_week_issue_name
    }
    else if (data.second_week_issue_name != "" && data.second_week_issue_name != null && data.second_week_issue_name != undefined) {
      this.issueName = data.second_week_issue_name
    } else if (data.first_week_issue_name != "" && data.first_week_issue_name != null && data.first_week_issue_name != undefined) {
      this.issueName = data.first_week_issue_name
    }

    this.getadvtName(this.issueName)

    if (data.fifth_week_issue_date != "" && data.fifth_week_issue_date != null && data.fifth_week_issue_date != undefined) {
      this.issueDate = data.fifth_week_issue_date
    } else if (data.fourth_week_issue_date != "" && data.fourth_week_issue_date != null && data.fourth_week_issue_date != undefined) {
      this.issueDate = data.fourth_week_issue_date
    } else if (data.third_week_issue_date != "" && data.third_week_issue_date != null && data.third_week_issue_date != undefined) {
      this.issueDate = data.third_week_issue_date
    }
    else if (data.second_week_issue_date != "" && data.second_week_issue_date != null && data.second_week_issue_date != undefined) {
      this.issueDate = data.second_week_issue_date
    } else if (data.first_week_issue_date != "" && data.first_week_issue_date != null && data.first_week_issue_date != undefined) {
      this.issueDate = data.first_week_issue_date
    }

    this.advtname = data.advt_name

    let date = data.invoice_date.split("-")
    let date1 = date[2] + "-" + date[1] + "-" + date[0]
    this.advtbillForm.patchValue({
      billno: data.invoice_no,
      date: date1,
      issuename: this.issueName,
      // issuedate :  this.issueDate,


    })
  }


  getadvtName(e) {

    // console.log(e);
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames(e).subscribe((data) => {
      this.getMagIssueDatesandAdvtNames = data;
      console.log(this.getMagIssueDatesandAdvtNames, "this.getMagIssueDatesandAdvtNames")
      this.filterissuedate = data;

      this.advtbillForm.patchValue({
        issuedate: [this.issueDate],

      })
      this.getISN1()
    });

  }


  getISN1() {
    this.advtNamesIssueDates = [this.issueDate];
    this.advtNamesStringDates = this.advtNamesIssueDates.toString();

    // console.log('StringDates', this.advtNamesStringDates);
    console.log('IssueDates', this.advtNamesIssueDates);
    this.advtInvoiceNames = [];
    for (let index = 0; index < this.advtNamesIssueDates.length; index++) {
      this.service
        .getAdvtInvoiceforAdvtNames(this.advtNamesIssueDates[index])
        .subscribe((res: any) => {
          // console.log(`${index}`, res);
          if (res) {
            res?.map((a) => {
              this.advtInvoiceNames.push({ advt_name: a.name });
            });
          }
        });
      if (index == this.advtNamesIssueDates.length - 1) {
        console.log(this.advtInvoiceNames);

        //   this.advtInvoiceNames = this.uniqueid(
        //     this.advtInvoiceNames,
        //     (i) => i.advt_name
        //   );
      }
    }
    this.advtbillForm.patchValue({
      advt_name: [this.advtname],

    })
    console.log(this.advtInvoiceNames);
    this.getISN2()
    this.advtInvoiceNames = this.uniqueid(
      this.advtInvoiceNames,
      (i) => i.advt_name
    );
    console.log(this.advtInvoiceNames);
  }

  getISN2() {
    // console.log(e.value.toString());
    this.advtNames = this.issueName
    this.getData = [this.advtname];
    this.getData = this.getData.filter((a) => a != 'all');
    this.stringdata = this.getData.toString();
  }


  onTabClick(event: any) {
    debugger
    console.log(event)
    localStorage.setItem("tab", event.index)
  }
  deletestamp(item) {
    let id = item.id

    this.service.stampreceiptdelete(id).subscribe((res) => {

    })
    this.toaster.success('delete', 'Stamp Receipt Deleted');

    this.ngOnInit()

  }
  newordel(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_pymt_rcpt',
      }
      this.service.getdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecipt = data;
      });
    }
    else {
      this.deleterec = false
    }
  }
  newordelC(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_pymt_rcpt',
      }
      this.service.getdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecipt = data;
      });
    }
    else {
      this.deleterec = false
    }
  }

  // newordelbooking(e) {
  //   debugger;
  //   if (e.value == 'deleted') {
  //     this.deleterec = true;
  //     const data: any = {
  //       "value": 'bookingno',
  //     }
  //     this.service.getdeletebooking(data).subscribe((data) => {
  //       // console.log('Database data', data);
  //       this.getdeletedBookings = data;
  //     });
  //   }
  //   else {
  //     this.deleterec = false
  //   }
  // }



  newordelbooking(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;

      // Add required validator for deleted bookings
      this.issueForm.get('bookingno')?.setValidators([Validators.required]);
      this.issueForm.get('bookingno')?.updateValueAndValidity();

      const data: any = {
        "value": 'bookingno',
      }
      this.service.getdeletebooking(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeletedBookings = data;
      });
    }
    else {
      this.deleterec = false;

      // Clear the bookingno field when switching to "New"
      this.issueForm.patchValue({
        bookingno: null
      });

      // Remove required validator for bookingno in "New" mode
      this.issueForm.get('bookingno')?.clearValidators();
      this.issueForm.get('bookingno')?.updateValueAndValidity();
    }
  }


  newordelinvoice(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_invoice',
      }
      this.service.getdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeletereciptinvoice = data;
      });
    }
    else {
      this.deleterec = false
    }
  }
  newordelstamp(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_stamp_rcpt',
      }
      this.service.getdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecitstamp = data;
      });
    }
    else {
      this.deleterec = false
    }
  }

  newordelcn(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'credit_note',
      }
      this.service.getdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecitcn = data;
      });
    }
    else {
      this.deleterec = false
    }

  }

  advtamout = new FormControl(100); // Example: Default value

  isFieldReadonly() {
    const invoiceNo = this.invoice_no || null;
    const rcptNo = this.rcpt_no || null;

    // Disable if either invoiceNo OR rcptNo is present
    return this.advtamout.value > 0 && (invoiceNo || rcptNo);
  }

  showAlert() {
    const invoiceNo = this.invoice_no || null;
    const rcptNo = this.rcpt_no || null;

    // Show alert if either invoiceNo OR rcptNo is present
    if (this.advtamout.value > 0 && (invoiceNo || rcptNo)) {
      alert(
        `You cannot modify the Advertisement.` +
        (invoiceNo ? ` Invoice No: ${invoiceNo}.` : '') +
        (rcptNo ? ` Receipt No: ${rcptNo}.` : '')
      );
    } else {
      console.log("Modification allowed.");
    }
  }


  showFields: boolean = false; // Initially hidden
  toggleFields() {
    this.showFields = !this.showFields;
  }


  showFields1: boolean = false; // Default: Hidden


  toggleContractForm() {
    this.showFields1 = !this.showFields1;
  }

  // ADD THIS copydata METHOD to your existing component
  // copydata8(data: any, event: any): void {
  //   const isChecked = event.target.checked;

  //   if (isChecked) {
  //     // Set selectedAmount to the commission amount when checkbox is checked
  //     data.selectedAmount = data.commissionAmount || 0;
  //   } 
  //   // else {
  //   //   // Reset selectedAmount to 0 when checkbox is unchecked
  //   //   data.selectedAmount = 0;
  //   // }
  // }
  selectedRows: any[] = [];

  // copydata8(data: any, event: any): void {



  //   const isChecked = event.target.checked;

  //   if (isChecked) {
  //     data.selectedAmount = data.commissionAmount || 0;
  //     data.commissionPercentage = data.commissionPercentage || 15;



  //     // ✅ Add to selectedRows if not already there
  //     if (!this.selectedRows.includes(data)) {
  //       this.selectedRows.push(data);
  //     }
  //   } else {
  //     data.selectedAmount = 0;

  //     // ❌ Remove from selectedRows
  //     this.selectedRows = this.selectedRows.filter(item => item !== data);
  //   }

  //   console.log("Selected Rows:", this.selectedRows);
  // }

  // UPDATE YOUR calculateTdsAmount method to use selectedAmount instead of commissionAmount


  copydata8(data1: any, event: any): void {
    debugger
    const isChecked = event.target.checked;

    if (isChecked) {
      // When checkbox is checked, set isSelected and selectedAmount
      data1.isSelected = true;
      data1.selectedAmount = data1.commissionAmount || 0;
    } else {
      // When checkbox is unchecked, clear selection
      data1.isSelected = false;
      data1.selectedAmount = 0;
    }

    // Update the Select Entry Amount field
    this.advtcommrecptform.patchValue({
      seamt: this.getGrandTotal('selectedAmount')
    });

    // Recalculate TDS and Balance
    this.calculateTdsAmount();
    this.calculateBalanceAmount();
  }

  calculateTdsAmount(): void {
    debugger
    // Get values and default to 0 if null/empty/NaN
    const tdsPercentage = Number(this.advtcommrecptform.get('tdsPercentage')?.value) || 0;
    const entryAmount = Number(this.getGrandTotal('selectedAmount')) || 0;

    // Calculate TDS
    this.calculatedTdsAmount = Math.round((entryAmount * tdsPercentage) / 100) || 0;

    console.log('TDS Amount:', this.calculatedTdsAmount);

    // Patch form value
    this.advtcommrecptform.patchValue({
      tdsAmount: this.calculatedTdsAmount
    });
  }


  // UPDATE YOUR calculateBalanceAmount method to use selectedAmount
  calculateBalanceAmount(): void {
    const entryAmount = this.getGrandTotal('selectedAmount'); // Changed from 'commissionAmount' to 'selectedAmount'
    const tdsAmount = this.calculatedTdsAmount;

    if (entryAmount && tdsAmount >= 0) {
      // Balance Amount = Entry Amount - TDS Amount
      this.calculatedBalanceAmount = Math.round(entryAmount - tdsAmount);
    } else {
      this.calculatedBalanceAmount = Math.round(entryAmount || 0);
    }

    this.advtcommrecptform.get('balamt')?.setValue(this.calculatedBalanceAmount);
  }

  // UPDATE YOUR calculateBalanceAmount method to use selectedAmount
  calculateTotalBalanceAmount(): number {
    const commissionVoucherAmount = Number(this.advtcommrecptform.get('crdtvamt')?.value) || 0;
    const balanceAmount = Number(this.advtcommrecptform.get('balamt')?.value) || 0;

    return Math.round(commissionVoucherAmount - balanceAmount);
  }






  // UPDATE YOUR calculateTdsAmountFormatted method to use selectedAmount
  calculateTdsAmountFormatted(): void {
    const tdsPercentage = this.advtcommrecptform.get('tdsPercentage')?.value;
    const entryAmount = this.getGrandTotal('selectedAmount'); // Changed from 'commissionAmount' to 'selectedAmount'

    if (tdsPercentage && entryAmount) {
      // Calculate TDS Amount with 2 decimal places
      this.calculatedTdsAmount = Math.round((entryAmount * tdsPercentage / 100) * 100) / 100;

      this.advtcommrecptform.get('tdsAmount')?.setValue(this.calculatedTdsAmount);
      this.calculateBalanceAmount();
    } else {
      this.calculatedTdsAmount = 0;
      this.advtcommrecptform.get('tdsAmount')?.setValue(0);
    }
  }

  // YOUR EXISTING METHODS (NO CHANGES)
  setDefaultCommissionAndCalculate() {
    if (this.CommissionData && this.CommissionData.length > 0) {
      this.CommissionData.forEach(record => {
        if (record.rep_data && record.rep_data.length > 0) {
          record.rep_data.forEach((item: any) => {
            // Set default 15% if not already set
            if (!item.commissionPercentage) {
              item.commissionPercentage = 15;
            }
            // Calculate commission amount with default or existing percentage
            const receivedAmount = parseFloat(item.rcv_amt) || 0;
            const percentage = parseFloat(item.commissionPercentage) || 15;
            item.commissionAmount = (receivedAmount * percentage) / 100;
            item.commissionAmount = Math.round(item.commissionAmount * 100) / 100;
          });
        }
      });

      // Force change detection to update totals in template
      this.calculateAllTotals();
    }
  }


  // Call this method after loading CommissionData from backend
  // Initialize all commission calculations
  initializeCommissions(): void {
    this.CommissionData.forEach(data => {
      data.rep_data.forEach((data1: any) => {
        // Set default percentage if not exists
        if (!data1.commissionPercentage) {
          data1.commissionPercentage = 15;
        }

        // Calculate commission amount
        const rcvAmt = data1.rcv_amt || 0;
        const percentage = data1.commissionPercentage || 15;
        const commissionAmount = (rcvAmt * percentage) / 100;

        data1.commissionAmount = Math.round(commissionAmount * 100) / 100;
      });
    });

    // Recalculate TDS and Balance after initialization
    this.calculateTdsAmount();
    this.calculateBalanceAmount();
  }

  // Method to calculate all totals
  calculateAllTotals() {
    // This method triggers calculation of all totals
    // The actual calculation happens in getGrandTotal method when template renders
  }




  // Updated CalculateAmount method with record index


  //   CalculateAmount(data1: any, event: any, index: number): void {

  //     debugger

  //   const percentage = parseFloat(event.target.value) || 0;
  //   const rcvAmt = data1.rcv_amt || 0;

  //   // Calculate commission amount based on received amount
  //   const commissionAmount = (rcvAmt * percentage) / 100;

  //   // Update the data object
  //   data1.commissionPercentage = percentage;
  //   data1.commissionAmount = Math.round(commissionAmount * 100) / 100; // Round to 2 decimal places

  //   // If item is selected, update selectedAmount as well
  //   if (data1.isSelected) {
  //     data1.selectedAmount = data1.commissionAmount;

  //     // Update the Select Entry Amount field
  //     this.advtcommrecptform.patchValue({
  //       seamt: this.getGrandTotal('selectedAmount')
  //     });
  //   }

  //   // Recalculate TDS and Balance
  //   this.calculateTdsAmount();
  //   this.calculateBalanceAmount();
  // }

  CalculateAmount(data1: any, event: any, index: number): void {

    const percentage = event.target.valueAsNumber || 0;
    const rcvAmt = Number(data1.rcv_amt) || 0;

    const commissionAmount = (rcvAmt * percentage) / 100;

    data1.commissionPercentage = percentage;
    data1.commissionAmount = Math.round(commissionAmount * 100) / 100;

    if (data1.isSelected) {
      data1.selectedAmount = data1.commissionAmount;

      this.advtcommrecptform.patchValue({
        seamt: this.getGrandTotal('selectedAmount')
      });
    }

    this.calculateTdsAmount();
    this.calculateBalanceAmount();
  }


  // Method to calculate total for a specific field in a record group
  // getRecordTotal(repData: any[], fieldName: string): number {
  //   if (!repData || repData.length === 0) return 0;

  //   return repData.reduce((total, item) => {
  //     // Ensure commission amount is calculated if not present
  //     if (fieldName === 'commissionAmount' && (!item.commissionAmount || item.commissionAmount === 0)) {
  //       const receivedAmount = parseFloat(item.rcv_amt) || 0;
  //       const percentage = parseFloat(item.commissionPercentage) || 15;
  //       item.commissionAmount = (receivedAmount * percentage) / 100;
  //       item.commissionAmount = Math.round(item.commissionAmount * 100) / 100;
  //     }

  //     const value = parseFloat(item[fieldName]) || 0;
  //     return total + value;
  //   }, 0);
  // }

  // Method to calculate average percentage for a record group
  getAveragePercentage(repData: any[]): number {
    if (!repData || repData.length === 0) return 0;

    const validPercentages = repData.filter(item =>
      item.commissionPercentage && !isNaN(parseFloat(item.commissionPercentage))
    );

    if (validPercentages.length === 0) return 0;

    const totalPercentage = validPercentages.reduce((total, item) => {
      return total + parseFloat(item.commissionPercentage);
    }, 0);

    return Math.round((totalPercentage / validPercentages.length) * 100) / 100;
  }

  // // Method to calculate grand total across all records
  // getGrandTotal(fieldName: string): number {
  //   if (!this.CommissionData || this.CommissionData.length === 0) return 0;

  //   let grandTotal = 0;

  //   this.CommissionData.forEach(record => {
  //     if (record.rep_data && record.rep_data.length > 0) {
  //       record.rep_data.forEach((item: any) => {
  //         // Ensure commission amount is calculated if not present
  //         if (fieldName === 'commissionAmount' && (!item.commissionAmount || item.commissionAmount === 0)) {
  //           const receivedAmount = parseFloat(item.rcv_amt) || 0;
  //           const percentage = parseFloat(item.commissionPercentage) || 15;
  //           item.commissionAmount = (receivedAmount * percentage) / 100;
  //           item.commissionAmount = Math.round(item.commissionAmount); // Rounded to whole number
  //         }

  //         const value = parseFloat(item[fieldName]) || 0;
  //         grandTotal += value;
  //       });
  //     }

  //   });

  //   return Math.round(grandTotal); // Final whole number total




  // }


  //   getGrandTotal(fieldName: string): number {
  //      let total = 0;

  //   // Calculate total from CommissionData
  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(data => {
  //       if (data.rep_data && Array.isArray(data.rep_data)) {
  //         data.rep_data.forEach((item: any) => {
  //           if (fieldName === 'commissionAmount') {
  //             total += item.commissionAmount || 0;
  //           } else if (fieldName === 'paidCommission') {
  //             total += item.com_amt || 0;
  //           } else if (fieldName === 'selectedAmount') {
  //             if (item.isSelected) {
  //               total += item.commissionAmount || 0;
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }




  //     let grandTotal = 0;

  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && record.rep_data.length > 0) {
  //         record.rep_data.forEach((item: any) => {
  //           // Ensure commission amount is calculated if not present
  //           if (fieldName === 'commissionAmount' && (!item.commissionAmount || item.commissionAmount === 0)) {
  //             const receivedAmount = parseFloat(item.rcv_amt) || 0;
  //             const percentage = parseFloat(item.commissionPercentage) || 15;
  //             item.commissionAmount = (receivedAmount * percentage) / 100;
  //             item.commissionAmount = Math.round(item.commissionAmount); // Rounded to whole number
  //           }

  //           // For selectedAmount, only add if item has selectedAmount property (checked)
  //           if (fieldName === 'selectedAmount') {
  //             const selectedValue = parseFloat(item.selectedAmount) || 0;
  //             grandTotal += selectedValue;
  //           } else if (fieldName === 'paidCommission') {
  //             // For paid commission, use com_amt field
  //             const paidValue = parseFloat(item.com_amt) || 0;
  //             grandTotal += paidValue;
  //           } else {
  //             // For other fields like commissionAmount
  //             const value = parseFloat(item[fieldName]) || 0;
  //             grandTotal += value;
  //           }
  //         });
  //       }
  //     });

  //     // Add manual entry amount if checkbox is selected and field is selectedAmount
  //     // Loop through all manual entries instead of checking single form
  // if (fieldName === 'selectedAmount') {
  //   for (let i = 0; i < this.manualEntries.length; i++) {
  //     const formGroup = this.manualEntries.at(i) as FormGroup;
  //     if (formGroup.get('isSelected')?.value) {
  //       grandTotal += this.getManualCommissionAmount(i);
  //     }
  //   }
  // }

  //     return Math.round(grandTotal); // Final whole number total
  //   }

  // getGrandTotal(fieldName: string): number {
  //   let grandTotal = 0;

  //   // Calculate total from backend CommissionData
  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && Array.isArray(record.rep_data)) {
  //         record.rep_data.forEach((item: any) => {
  //           if (fieldName === 'commissionAmount') {
  //             grandTotal += item.commissionAmount || 0;
  //           } else if (fieldName === 'paidCommission') {
  //             grandTotal += item.com_amt || 0;
  //           } else if (fieldName === 'selectedAmount') {
  //             // For backend data, use selectedAmount when item is selected
  //             if (item.isSelected) {
  //               grandTotal += item.selectedAmount || 0;
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Add manual entries to total
  //   if (this.manualEntries && this.manualEntries.length > 0) {
  //     for (let i = 0; i < this.manualEntries.length; i++) {
  //       const formGroup = this.manualEntries.at(i) as FormGroup;
  //       const isSelected = formGroup.get('isSelected')?.value;

  //       if (fieldName === 'commissionAmount') {
  //         grandTotal += this.getManualCommissionAmount(i);
  //       } else if (fieldName === 'paidCommission') {
  //         // Manual entries have no paid commission yet
  //         grandTotal += 0;
  //       } else if (fieldName === 'selectedAmount') {
  //         // For manual entries, add commission amount when selected (same behavior as backend data)
  //         if (isSelected) {
  //           grandTotal += this.getManualCommissionAmount(i);
  //         }
  //       }
  //     }
  //   }

  //   return Math.round(grandTotal);
  // }


  // getGrandTotal(fieldName: string): number {
  //   let grandTotal = 0;

  //   // Calculate total from backend CommissionData
  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && Array.isArray(record.rep_data)) {
  //         record.rep_data.forEach((item: any) => {
  //           if (fieldName === 'commissionAmount') {
  //             const commAmt = parseFloat(item.commissionAmount) || 0;
  //             grandTotal += commAmt;
  //           } else if (fieldName === 'paidCommission') {
  //             const paidAmt = parseFloat(item.com_amt) || 0;
  //             grandTotal += paidAmt;
  //           } else if (fieldName === 'selectedAmount') {
  //             // For backend data, use selectedAmount when item is selected
  //             if (item.isSelected) {
  //               const selAmt = parseFloat(item.selectedAmount) || 0;
  //               grandTotal += selAmt;
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Add manual entries to total
  //   if (this.manualEntries && this.manualEntries.length > 0) {
  //     for (let i = 0; i < this.manualEntries.length; i++) {
  //       const formGroup = this.manualEntries.at(i) as FormGroup;
  //       const isSelected = formGroup.get('isSelected')?.value;

  //       if (fieldName === 'commissionAmount') {
  //         const manualCommAmt = this.getManualCommissionAmount(i) || 0;
  //         grandTotal += manualCommAmt;
  //       } else if (fieldName === 'paidCommission') {
  //         // Manual entries have no paid commission yet
  //         grandTotal += 0;
  //       } else if (fieldName === 'selectedAmount') {
  //         // For manual entries, add commission amount when selected (same behavior as backend data)
  //         if (isSelected) {
  //           const manualSelAmt = this.getManualCommissionAmount(i) || 0;
  //           grandTotal += manualSelAmt;
  //         }
  //       }
  //     }
  //   }

  //   // Return 0 if result is NaN, otherwise return rounded total
  //   return isNaN(grandTotal) ? 0 : Math.round(grandTotal);
  // }

  // Add this new method to calculate totals for each individual record group
  // getRecordTotal(recordData: any[], fieldName: string): number {
  //   let total = 0;

  //   if (recordData && Array.isArray(recordData)) {
  //     recordData.forEach((item: any) => {
  //       if (fieldName === 'commissionAmount') {
  //         const commAmt = parseFloat(item.commissionAmount) || 0;
  //         total += commAmt;
  //       } else if (fieldName === 'paidCommission') {
  //         const paidAmt = parseFloat(item.com_amt) || 0;
  //         total += paidAmt;
  //       } else if (fieldName === 'unpaidCommission') {
  //         // Unpaid = Total Commission - Paid Commission
  //         const totalComm = parseFloat(item.commissionAmount) || 0;
  //         const paidComm = parseFloat(item.com_amt) || 0;
  //         const unpaidAmt = totalComm - paidComm;
  //         total += unpaidAmt;
  //       } else if (fieldName === 'selectedAmount') {
  //         if (item.isSelected) {
  //           const selAmt = parseFloat(item.selectedAmount) || 0;
  //           total += selAmt;
  //         }
  //       } else if (fieldName === 'netAmount') {
  //         const netAmt = parseFloat(item.net_amount) || 0;
  //         total += netAmt;
  //       } else if (fieldName === 'pendingAmount') {
  //         const pendAmt = parseFloat(item.pending_amt) || 0;
  //         total += pendAmt;
  //       } else if (fieldName === 'receivedAmount') {
  //         const rcvAmt = parseFloat(item.rcv_amt) || 0;
  //         total += rcvAmt;
  //       }
  //     });
  //   }

  //   return isNaN(total) ? 0 : Math.round(total * 100) / 100;
  // }

  // // Keep your existing getGrandTotal method as is
  // getGrandTotal(fieldName: string): number {
  //   let grandTotal = 0;

  //   // Calculate total from backend CommissionData
  //   if (this.CommissionData && this.CommissionData.length > 0) {
  //     this.CommissionData.forEach(record => {
  //       if (record.rep_data && Array.isArray(record.rep_data)) {
  //         record.rep_data.forEach((item: any) => {
  //           if (fieldName === 'commissionAmount') {
  //             const commAmt = parseFloat(item.commissionAmount) || 0;
  //             grandTotal += commAmt;
  //           } else if (fieldName === 'paidCommission') {
  //             const paidAmt = parseFloat(item.com_amt) || 0;
  //             grandTotal += paidAmt;
  //           } else if (fieldName === 'unpaidCommission') {
  //             // Unpaid = Total Commission - Paid Commission
  //             const totalComm = parseFloat(item.commissionAmount) || 0;
  //             const paidComm = parseFloat(item.com_amt) || 0;
  //             const unpaidAmt = totalComm - paidComm;
  //             grandTotal += unpaidAmt;
  //           } else if (fieldName === 'selectedAmount') {
  //             // For backend data, use selectedAmount when item is selected
  //             if (item.isSelected) {
  //               const selAmt = parseFloat(item.selectedAmount) || 0;
  //               grandTotal += selAmt;
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }

  //   // Add manual entries to total
  //   if (this.manualEntries && this.manualEntries.length > 0) {
  //     for (let i = 0; i < this.manualEntries.length; i++) {
  //       const formGroup = this.manualEntries.at(i) as FormGroup;
  //       const isSelected = formGroup.get('isSelected')?.value;

  //       if (fieldName === 'commissionAmount') {
  //         const manualCommAmt = this.getManualCommissionAmount(i) || 0;
  //         grandTotal += manualCommAmt;
  //       } else if (fieldName === 'paidCommission') {
  //         // Manual entries have no paid commission yet
  //         grandTotal += 0;
  //       } else if (fieldName === 'unpaidCommission') {
  //         // For manual entries: unpaid = total commission - 0 (no paid yet)
  //         const manualCommAmt = this.getManualCommissionAmount(i) || 0;
  //         grandTotal += manualCommAmt;
  //       } else if (fieldName === 'selectedAmount') {
  //         // For manual entries, add commission amount when selected (same behavior as backend data)
  //         if (isSelected) {
  //           const manualSelAmt = this.getManualCommissionAmount(i) || 0;
  //           grandTotal += manualSelAmt;
  //         }
  //       }
  //     }
  //   }

  //   // Return 0 if result is NaN, otherwise return rounded total
  //   return isNaN(grandTotal) ? 0 : Math.round(grandTotal);
  // }


  // Modified method to calculate totals for each individual record group
  getRecordTotal(recordData: any[], fieldName: string): number {
    let total = 0;

    if (recordData && Array.isArray(recordData)) {
      recordData.forEach((item: any) => {
        if (fieldName === 'commissionAmount') {
          const commAmt = parseFloat(item.commissionAmount) || 0;
          total += commAmt;
        } else if (fieldName === 'paidCommission') {
          const paidAmt = parseFloat(item.com_amt) || 0;
          total += paidAmt;
        } else if (fieldName === 'unpaidCommission') {
          // Unpaid = Total Commission - Paid Commission
          const totalComm = parseFloat(item.commissionAmount) || 0;
          const paidComm = parseFloat(item.com_amt) || 0;
          const unpaidAmt = totalComm - paidComm;
          total += unpaidAmt;
        } else if (fieldName === 'selectedAmount') {
          if (item.isSelected) {
            // Selected Amount = Unpaid/Balance Commission (when checkbox is selected)
            const totalComm = parseFloat(item.commissionAmount) || 0;
            const paidComm = parseFloat(item.com_amt) || 0;
            const selAmt = totalComm - paidComm;
            total += selAmt;
          }
        } else if (fieldName === 'netAmount') {
          const netAmt = parseFloat(item.net_amount) || 0;
          total += netAmt;
        } else if (fieldName === 'pendingAmount') {
          const pendAmt = parseFloat(item.pending_amt) || 0;
          total += pendAmt;
        } else if (fieldName === 'receivedAmount') {
          const rcvAmt = parseFloat(item.rcv_amt) || 0;
          total += rcvAmt;
        }
      });
    }

    return isNaN(total) ? 0 : Math.round(total * 100) / 100;
  }

  // Modified getGrandTotal method
  getGrandTotal(fieldName: string): number {
    let grandTotal = 0;

    // Calculate total from backend CommissionData
    if (this.CommissionData && this.CommissionData.length > 0) {
      this.CommissionData.forEach(record => {
        if (record.rep_data && Array.isArray(record.rep_data)) {
          record.rep_data.forEach((item: any) => {
            if (fieldName === 'commissionAmount') {
              const commAmt = parseFloat(item.commissionAmount) || 0;
              grandTotal += commAmt;
            } else if (fieldName === 'paidCommission') {
              const paidAmt = parseFloat(item.com_amt) || 0;
              grandTotal += paidAmt;
            } else if (fieldName === 'unpaidCommission') {
              // Unpaid = Total Commission - Paid Commission
              const totalComm = parseFloat(item.commissionAmount) || 0;
              const paidComm = parseFloat(item.com_amt) || 0;
              const unpaidAmt = totalComm - paidComm;
              grandTotal += unpaidAmt;
            } else if (fieldName === 'selectedAmount') {
              // Selected Amount = Unpaid/Balance Commission (when checkbox is selected)
              if (item.isSelected) {
                const totalComm = parseFloat(item.commissionAmount) || 0;
                const paidComm = parseFloat(item.com_amt) || 0;
                const selAmt = totalComm - paidComm;
                grandTotal += selAmt;
              }
            }
          });
        }
      });
    }

    // Add manual entries to total
    if (this.manualEntries && this.manualEntries.length > 0) {
      for (let i = 0; i < this.manualEntries.length; i++) {
        const formGroup = this.manualEntries.at(i) as FormGroup;
        const isSelected = formGroup.get('isSelected')?.value;

        if (fieldName === 'commissionAmount') {
          const manualCommAmt = this.getManualCommissionAmount(i) || 0;
          grandTotal += manualCommAmt;
        } else if (fieldName === 'paidCommission') {
          // Manual entries have no paid commission yet (0)
          grandTotal += 0;
        } else if (fieldName === 'unpaidCommission') {
          // For manual entries: unpaid = commission amount - 0 (nothing paid yet)
          const manualCommAmt = this.getManualCommissionAmount(i) || 0;
          grandTotal += manualCommAmt;
        } else if (fieldName === 'selectedAmount') {
          // For manual entries: selected amount = commission amount when checked
          if (isSelected) {
            const manualSelAmt = this.getManualCommissionAmount(i) || 0;
            grandTotal += manualSelAmt;
          }
        }
      }
    }

    // Return 0 if result is NaN, otherwise return rounded total
    return isNaN(grandTotal) ? 0 : Math.round(grandTotal);
  }


  // Method to calculate overall average percentage across all records
  getOverallAveragePercentage(): number {
    if (!this.CommissionData || this.CommissionData.length === 0) return 0;

    let totalPercentage = 0;
    let totalItems = 0;

    this.CommissionData.forEach(record => {
      if (record.rep_data) {
        record.rep_data.forEach((item: any) => {
          if (item.commissionPercentage && !isNaN(parseFloat(item.commissionPercentage))) {
            totalPercentage += parseFloat(item.commissionPercentage);
            totalItems++;
          }
        });
      }
    });

    return totalItems > 0 ? Math.round((totalPercentage / totalItems) * 100) / 100 : 0;
  }

  // Properties for calculations
  calculatedTdsAmount: number = 0;
  calculatedBalanceAmount: number = 0;
  totalBalanceAmount: number = 0;


  printCommission(data1: any) {
    if (!data1.commision_no) {
      alert('Commission number not found for this record');
      return;
    }

    this.dialog.open(ComModalPrintComponent, {
      width: '1000px',
      data: {
        innerData: data1,

      }
    });
  }

  deleteCommission(advtId: number) {
    debugger
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deleteCommission({ id: advtId }).subscribe((res) => {
        console.log(res, "delete response");
        this.ngOnInit();  // refresh after success
      });
    }
  }

  ShowReportAdvanceType() {
    debugger

    if (this.contractReportType === 'Indetail') {   // FIXED: matches HTML

      this.dialog.open(AdvtStampRegisterReportComponentComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.advtstampStartDate1,  // FIXED
          endDate: this.advtstampEndDate1,         // sending end date
          repName: this.repregreport,
          offRepName: this.contractReportOffRepName,
          name: this.advt_name,
          reportType: this.contractReportType,
          issueDates: this.stampgetdata1.value.issueDates,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }

  }


  onGstPercentageChange(event) {
    this.percentage = event.value;
    console.log('GST Percentage changed to:', this.percentage);
    this.onAmountChange(); // Recalculate when percentage changes
  }


  convertToISODate(dateString: string): string | null {
    if (!dateString) return null;

    const ddmmyyyyPattern = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = dateString.match(ddmmyyyyPattern);

    if (match) {
      const [, day, month, year] = match;
      return `${year}-${month}-${day}`;
    }

    return dateString;
  }


  normalizeDate(dateStr: string): string | null {
    if (!dateStr) return null;

    // already ISO
    if (dateStr.includes('-') && dateStr.split('-')[0].length === 4) {
      return dateStr;
    }

    // DD-MM-YYYY
    const [d, m, y] = dateStr.split('-');
    return `${y}-${m}-${d}`;
  }





}


function moment() {
  throw new Error('Function not implemented.');
}

function getCreditNoteMain(req1: { rep_name: any; }, any: any) {
  throw new Error('Function not implemented.');
}

function selectedModal() {
  throw new Error('Function not implemented.');
}



